import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__ from "@mui/material";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__ from "@mui/material/Typography";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__mui_styled_engine_24226ae5__ from "@mui/styled-engine";
import * as __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__ from "@bonusx-global/bx-icons";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__ from "@mui/material/Grid";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__ from "@mui/material/Box";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__ from "@mui/material/SvgIcon";
import * as __WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__ from "@mui/system/Box";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__ from "@mui/material/CircularProgress";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__ from "@mui/material/IconButton";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails_d2db12ca__ from "@mui/material/AccordionDetails";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Accordion_4220dc4d__ from "@mui/material/Accordion";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary_85088446__ from "@mui/material/AccordionSummary";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__ from "@mui/material/Alert";
import * as __WEBPACK_EXTERNAL_MODULE_react_device_detect_2985bda2__ from "react-device-detect";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_AppBar_72083ef1__ from "@mui/material/AppBar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Toolbar_089287ec__ from "@mui/material/Toolbar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__ from "@mui/material/Chip";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__ from "@mui/material/Autocomplete";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__ from "@mui/material/TextField";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__ from "@mui/material/Badge";
import * as __WEBPACK_EXTERNAL_MODULE_react_dropzone_e9959fec__ from "react-dropzone";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Avatar_eb4ee1a2__ from "@mui/material/Avatar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__ from "@mui/material/Stack";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_SwipeableDrawer_b1c2876e__ from "@mui/material/SwipeableDrawer";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_List_e42ad5de__ from "@mui/material/List";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Collapse_1f7ec3cf__ from "@mui/material/Collapse";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__ from "@mui/material/ListItemButton";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__ from "@mui/material/ListItemIcon";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__ from "@mui/material/ListItemText";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigation_918bb977__ from "@mui/material/BottomNavigation";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigationAction_261e3421__ from "@mui/material/BottomNavigationAction";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Link_317b0bd9__ from "@mui/material/Link";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Breadcrumbs_3d9c9a2c__ from "@mui/material/Breadcrumbs";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__ from "@mui/material/Button";
import * as __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__ from "@mui/system";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__ from "@mui/material/InputAdornment";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__ from "@mui/material/ClickAwayListener";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__ from "@mui/material/Checkbox";
import * as __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_DesktopDatePicker_970824af__ from "@mui/x-date-pickers/DesktopDatePicker";
import * as __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_MobileDatePicker_8c47fa9b__ from "@mui/x-date-pickers/MobileDatePicker";
import * as __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__ from "@mui/x-date-pickers";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__ from "@mui/material/Dialog";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogActions_c3764e69__ from "@mui/material/DialogActions";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogContent_37fd6d87__ from "@mui/material/DialogContent";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_DialogTitle_112a25af__ from "@mui/material/DialogTitle";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tooltip_69cc2f11__ from "@mui/material/Tooltip";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormControlLabel_8c33cd98__ from "@mui/material/FormControlLabel";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__ from "@mui/material/styles";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__ from "@mui/material/Card";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__ from "@mui/material/LinearProgress";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItem_695b112b__ from "@mui/material/ListItem";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__ from "@mui/material/Divider";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_ListItemAvatar_037fd911__ from "@mui/material/ListItemAvatar";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Step_3911fe4c__ from "@mui/material/Step";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_StepLabel_7ace807e__ from "@mui/material/StepLabel";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_StepConnector_b0bd5d60__ from "@mui/material/StepConnector";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Stepper_18643dcd__ from "@mui/material/Stepper";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__ from "@mui/material/Paper";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__ from "@mui/material/FormControl";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_FormHelperText_3b87fa55__ from "@mui/material/FormHelperText";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__ from "@mui/material/InputLabel";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Select_bb5d0ab2__ from "@mui/material/Select";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Slide_61aa8233__ from "@mui/material/Slide";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__ from "@mui/material/Switch";
import * as __WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_cc7bd6a4__ from "@mui/x-data-grid";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__ from "@mui/material/Tab";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__ from "@mui/material/Tabs";
import * as __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__ from "@emotion/react";
import * as __WEBPACK_EXTERNAL_MODULE__mui_material_CssBaseline_6a578862__ from "@mui/material/CssBaseline";
var __webpack_modules__ = {
    "./node_modules/lodash/_DataView.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var DataView = getNative(root, 'DataView');
        module.exports = DataView;
    },
    "./node_modules/lodash/_Map.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Map1 = getNative(root, 'Map');
        module.exports = Map1;
    },
    "./node_modules/lodash/_Promise.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Promise = getNative(root, 'Promise');
        module.exports = Promise;
    },
    "./node_modules/lodash/_Set.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var Set1 = getNative(root, 'Set');
        module.exports = Set1;
    },
    "./node_modules/lodash/_Symbol.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var root = __webpack_require__("./node_modules/lodash/_root.js");
        var Symbol = root.Symbol;
        module.exports = Symbol;
    },
    "./node_modules/lodash/_WeakMap.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"), root = __webpack_require__("./node_modules/lodash/_root.js");
        var WeakMap = getNative(root, 'WeakMap');
        module.exports = WeakMap;
    },
    "./node_modules/lodash/_baseGetTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"), getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"), objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
        var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
        var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
        function baseGetTag(value) {
            if (null == value) return void 0 === value ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
        }
        module.exports = baseGetTag;
    },
    "./node_modules/lodash/_baseIsArguments.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var argsTag = '[object Arguments]';
        function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        module.exports = baseIsArguments;
    },
    "./node_modules/lodash/_baseIsNative.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"), isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"), isObject = __webpack_require__("./node_modules/lodash/isObject.js"), toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var funcProto = Function.prototype, objectProto = Object.prototype;
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        module.exports = baseIsNative;
    },
    "./node_modules/lodash/_baseIsTypedArray.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isLength = __webpack_require__("./node_modules/lodash/isLength.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        module.exports = baseIsTypedArray;
    },
    "./node_modules/lodash/_baseKeys.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"), nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object(object))if (hasOwnProperty.call(object, key) && 'constructor' != key) result.push(key);
            return result;
        }
        module.exports = baseKeys;
    },
    "./node_modules/lodash/_baseUnary.js": function(module) {
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        module.exports = baseUnary;
    },
    "./node_modules/lodash/_coreJsData.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var root = __webpack_require__("./node_modules/lodash/_root.js");
        var coreJsData = root['__core-js_shared__'];
        module.exports = coreJsData;
    },
    "./node_modules/lodash/_freeGlobal.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var freeGlobal = 'object' == typeof __webpack_require__.g && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
        module.exports = freeGlobal;
    },
    "./node_modules/lodash/_getNative.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"), getValue = __webpack_require__("./node_modules/lodash/_getValue.js");
        function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : void 0;
        }
        module.exports = getNative;
    },
    "./node_modules/lodash/_getRawTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var nativeObjectToString = objectProto.toString;
        var symToStringTag = Symbol ? Symbol.toStringTag : void 0;
        function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = void 0;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
            return result;
        }
        module.exports = getRawTag;
    },
    "./node_modules/lodash/_getTag.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"), Map1 = __webpack_require__("./node_modules/lodash/_Map.js"), Promise = __webpack_require__("./node_modules/lodash/_Promise.js"), Set1 = __webpack_require__("./node_modules/lodash/_Set.js"), WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"), baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
        var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
        var dataViewTag = '[object DataView]';
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map1), promiseCtorString = toSource(Promise), setCtorString = toSource(Set1), weakMapCtorString = toSource(WeakMap);
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map1 && getTag(new Map1) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set1 && getTag(new Set1) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        module.exports = getTag;
    },
    "./node_modules/lodash/_getValue.js": function(module) {
        function getValue(object, key) {
            return null == object ? void 0 : object[key];
        }
        module.exports = getValue;
    },
    "./node_modules/lodash/_isMasked.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");
        var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        module.exports = isMasked;
    },
    "./node_modules/lodash/_isPrototype.js": function(module) {
        var objectProto = Object.prototype;
        function isPrototype(value) {
            var Ctor = value && value.constructor, proto = 'function' == typeof Ctor && Ctor.prototype || objectProto;
            return value === proto;
        }
        module.exports = isPrototype;
    },
    "./node_modules/lodash/_nativeKeys.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
        var nativeKeys = overArg(Object.keys, Object);
        module.exports = nativeKeys;
    },
    "./node_modules/lodash/_nodeUtil.js": function(module, exports, __webpack_require__) {
        module = __webpack_require__.nmd(module);
        var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        module.exports = nodeUtil;
    },
    "./node_modules/lodash/_objectToString.js": function(module) {
        var objectProto = Object.prototype;
        var nativeObjectToString = objectProto.toString;
        function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        module.exports = objectToString;
    },
    "./node_modules/lodash/_overArg.js": function(module) {
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        module.exports = overArg;
    },
    "./node_modules/lodash/_root.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
        var freeSelf = 'object' == typeof self && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        module.exports = root;
    },
    "./node_modules/lodash/_toSource.js": function(module) {
        var funcProto = Function.prototype;
        var funcToString = funcProto.toString;
        function toSource(func) {
            if (null != func) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        module.exports = toSource;
    },
    "./node_modules/lodash/isArguments.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var propertyIsEnumerable = objectProto.propertyIsEnumerable;
        var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        module.exports = isArguments;
    },
    "./node_modules/lodash/isArray.js": function(module) {
        var isArray = Array.isArray;
        module.exports = isArray;
    },
    "./node_modules/lodash/isArrayLike.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"), isLength = __webpack_require__("./node_modules/lodash/isLength.js");
        function isArrayLike(value) {
            return null != value && isLength(value.length) && !isFunction(value);
        }
        module.exports = isArrayLike;
    },
    "./node_modules/lodash/isBuffer.js": function(module, exports, __webpack_require__) {
        module = __webpack_require__.nmd(module);
        var root = __webpack_require__("./node_modules/lodash/_root.js"), stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var Buffer = moduleExports ? root.Buffer : void 0;
        var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
        var isBuffer = nativeIsBuffer || stubFalse;
        module.exports = isBuffer;
    },
    "./node_modules/lodash/isEmpty.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"), getTag = __webpack_require__("./node_modules/lodash/_getTag.js"), isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"), isArray = __webpack_require__("./node_modules/lodash/isArray.js"), isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"), isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"), isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"), isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
        var mapTag = '[object Map]', setTag = '[object Set]';
        var objectProto = Object.prototype;
        var hasOwnProperty = objectProto.hasOwnProperty;
        function isEmpty(value) {
            if (null == value) return true;
            if (isArrayLike(value) && (isArray(value) || 'string' == typeof value || 'function' == typeof value.splice || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value)if (hasOwnProperty.call(value, key)) return false;
            return true;
        }
        module.exports = isEmpty;
    },
    "./node_modules/lodash/isFunction.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObject = __webpack_require__("./node_modules/lodash/isObject.js");
        var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
        function isFunction(value) {
            if (!isObject(value)) return false;
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        module.exports = isFunction;
    },
    "./node_modules/lodash/isLength.js": function(module) {
        var MAX_SAFE_INTEGER = 9007199254740991;
        function isLength(value) {
            return 'number' == typeof value && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        module.exports = isLength;
    },
    "./node_modules/lodash/isNaN.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var isNumber = __webpack_require__("./node_modules/lodash/isNumber.js");
        function isNaN1(value) {
            return isNumber(value) && value != +value;
        }
        module.exports = isNaN1;
    },
    "./node_modules/lodash/isNumber.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"), isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
        var numberTag = '[object Number]';
        function isNumber(value) {
            return 'number' == typeof value || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        module.exports = isNumber;
    },
    "./node_modules/lodash/isObject.js": function(module) {
        function isObject(value) {
            var type = typeof value;
            return null != value && ('object' == type || 'function' == type);
        }
        module.exports = isObject;
    },
    "./node_modules/lodash/isObjectLike.js": function(module) {
        function isObjectLike(value) {
            return null != value && 'object' == typeof value;
        }
        module.exports = isObjectLike;
    },
    "./node_modules/lodash/isTypedArray.js": function(module, __unused_webpack_exports, __webpack_require__) {
        var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"), baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"), nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
        var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        module.exports = isTypedArray;
    },
    "./node_modules/lodash/isUndefined.js": function(module) {
        function isUndefined(value) {
            return void 0 === value;
        }
        module.exports = isUndefined;
    },
    "./node_modules/lodash/stubFalse.js": function(module) {
        function stubFalse() {
            return false;
        }
        module.exports = stubFalse;
    }
};
var __webpack_module_cache__ = {};
function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
        id: moduleId,
        loaded: false,
        exports: {}
    };
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    module.loaded = true;
    return module.exports;
}
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.g = (()=>{
        if ('object' == typeof globalThis) return globalThis;
        try {
            return this || new Function('return this')();
        } catch (e) {
            if ('object' == typeof window) return window;
        }
    })();
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.nmd = (module)=>{
        module.paths = [];
        if (!module.children) module.children = [];
        return module;
    };
})();
const Bluex = {
    0: "#FCFDFF",
    50: "#F1F4FC",
    100: "#DAE2F6",
    200: "#B1C2ED",
    300: "#5378d7",
    400: "#1246C8",
    500: "#0E379E",
    600: "#0A266D",
    700: "#05153D"
};
const Tealx = {
    0: "#dcf8f1",
    100: "#b8f1e2",
    200: "#7ae4ca",
    300: "#3dd8b1",
    400: "#00bb8c",
    500: "#008a67",
    600: "#006a50",
    700: "#00392b"
};
const Pinkx = {
    0: "#ffecf2",
    100: "#fecfdd",
    200: "#fd9cb9",
    300: "#fc608e",
    400: "#d72f60",
    500: "#a3284c",
    600: "#6f1b34",
    700: "#3f0f1d"
};
const DeepBluex = {
    0: "#eaecf0",
    100: "#cbcfda",
    200: "#979fb5",
    300: "#626e90",
    400: "#2e3e6b",
    500: "#232f50",
    600: "#171f36",
    700: "#0c101b"
};
const Nudex = {
    0: "#fffefd",
    100: "#fefcfa",
    200: "#fdfaf6",
    300: "#fcf7f1",
    400: "#fcf5ed",
    500: "#eee7dd",
    600: "#bab4ac",
    700: "#85817b"
};
const Purplex = {
    0: "#f8f7fe",
    100: "#e1dff9",
    200: "#c2bff4",
    300: "#a49fee",
    400: "#867fe8",
    500: "#685fe3",
    600: "#5148cb",
    700: "#403aa2"
};
const Napolix = {
    0: "#f3fbff",
    100: "#d6f2ff",
    200: "#b5e7ff",
    300: "#83d8ff",
    400: "#5acaff",
    500: "#179fdf",
    600: "#1176a6",
    700: "#0b4d6c"
};
const Celestex = {
    0: "#e7fafd",
    100: "#aff0f8",
    200: "#4dddef",
    300: "#00c4db",
    400: "#00a9bd",
    500: "#008fa0",
    600: "#007684",
    700: "#005e69"
};
const Orangex = {
    0: "#fff4e6",
    100: "#ffe3bf",
    200: "#ffc680",
    300: "#ffaa40",
    400: "#ff8d00",
    500: "#bf6a00",
    600: "#804700",
    700: "#402300"
};
const Redx = {
    0: "#fbecec",
    100: "#f6d0d0",
    200: "#eca1a1",
    300: "#e37171",
    400: "#d94242",
    500: "#d01313",
    600: "#b60000",
    700: "#900000"
};
const Greenx = {
    0: "#ddf5eb",
    100: "#aee6d0",
    200: "#5acd9e",
    300: "#2bac78",
    400: "#22885f",
    500: "#1a6648",
    600: "#124631",
    700: "#0a291c"
};
const Greyx = {
    0: "#F9FAFA",
    100: "#F1F2F3",
    200: "#E3E5E8",
    300: "#D4D8DC",
    400: "#C6CBD1",
    500: "#B8BEC5",
    600: "#93989E",
    700: "#6E7276",
    800: "#4A4C4F",
    900: "#252627"
};
const Goldenx = {
    0: "#FDF8E6",
    100: "#F6EBC2",
    200: "#EDD98F",
    300: "#E2C05A",
    400: "#B3931E",
    500: "#947E05",
    600: "#664D00",
    700: "#543C00"
};
const AlphaDeepColor = "#171f36";
const AlphaDeep = {
    4: `${AlphaDeepColor}0a`,
    8: `${AlphaDeepColor}14`,
    10: `${AlphaDeepColor}1a`,
    12: `${AlphaDeepColor}1f`,
    16: `${AlphaDeepColor}29`,
    20: `${AlphaDeepColor}33`,
    24: `${AlphaDeepColor}3d`,
    30: `${AlphaDeepColor}4d`,
    38: `${AlphaDeepColor}61`,
    50: `${AlphaDeepColor}80`,
    56: `${AlphaDeepColor}8f`,
    60: `${AlphaDeepColor}99`,
    70: `${AlphaDeepColor}b3`
};
const GREY_BORDER_CARD = "rgba(23, 31, 54, 0.12)";
const GREY_BORDER_CARD_MIDDLE_OPACITY = "rgba(23, 31, 54, 0.5)";
const GREY_BORDER_CARD_HOVERED = "rgba(23, 31, 54, 0.30)";
const GREY_BORDER_CARD_HOVERED_MIDDLE_OPACITY = "rgba(23, 31, 54, 0.5)";
const WHITE_TRANSPARENT_LIGHT = "rgba(0, 0, 0, 0.08)";
const White = {
    main: "#FFFFFF",
    light: "rgba(255, 255, 255, 0.12)",
    dark: "rgba(255, 255, 255, 0.30)",
    contrastText: "rgba(255, 255, 255, 0.08)",
    focus: "rgba(255, 255, 255, 0.12)",
    focusVisible: "rgba(255, 255, 255, 0.30)",
    hover: "rgba(255, 255, 255, 0.04)",
    outlinedBorder: "rgba(255, 255, 255, 0.50)",
    selected: "rgba(255, 255, 255, 0.08)"
};
const Common = {
    white: White,
    dark: {
        main: DeepBluex["600"],
        hover: AlphaDeep["4"]
    }
};
const Text = {
    primary: DeepBluex["600"],
    secondary: AlphaDeep["70"],
    disabled: AlphaDeep["38"]
};
const Primary = {
    main: Bluex["400"],
    light: Bluex["50"],
    dark: Bluex["500"],
    contrastText: Common.white.main,
    focus: "rgba(18, 70, 200, 0.12)",
    focusVisible: "rgba(18, 70, 200, 0.10)",
    hover: "rgba(18, 70, 200, 0.04)",
    outlinedBorder: "rgba(18, 70, 200, 0.50)",
    selected: "rgba(18, 70, 200, 0.08)"
};
const Secondary = {
    main: Tealx["400"],
    light: Tealx["0"],
    dark: Tealx["500"],
    contrastText: Text.primary,
    focus: "rgba(0, 187, 140, 0.12)",
    focusVisible: "rgba(0, 187, 140, 0.10)",
    hover: "rgba(0, 187, 140, 0.04)",
    outlinedBorder: "rgba(0, 187, 140, 0.50)",
    selected: "rgba(0, 187, 140, 0.08)"
};
const ErrorToken = {
    main: Redx["400"],
    light: Redx["200"],
    dark: Redx["600"],
    contrastText: Common.white.main,
    focusVisible: "rgba(217, 66, 66, 0.10)",
    hover: "rgba(217, 66, 66, 0.04)",
    outlinedBorder: "rgba(217, 66, 66, 0.50)",
    selected: "rgba(217, 66, 66, 0.08)"
};
const Warning = {
    main: Orangex["400"],
    light: Orangex["100"],
    dark: Orangex["600"],
    contrastText: Common.white.main,
    hover: "rgba(255, 141, 0, 0.04)",
    focusVisible: "rgba(255, 141, 0, 0.10)",
    outlinedBorder: "rgba(255, 141, 0, 0.50)",
    selected: "rgba(255, 141, 0, 0.08)"
};
const Info = {
    main: Napolix["500"],
    light: Napolix["0"],
    dark: Napolix["600"],
    contrastText: Common.white.main,
    focusVisible: "rgba(23, 159, 223, 0.10)",
    hover: "rgba(23, 159, 223, 0.04)",
    outlinedBorder: "rgba(23, 159, 223, 0.50)",
    selected: "rgba(23, 159, 223, 0.08)"
};
const Success = {
    main: Greenx["400"],
    light: Greenx["0"],
    dark: Greenx["500"],
    contrastText: Common.white.main,
    hover: "rgba(34, 136, 95, 0.04)",
    focusVisible: "rgba(34, 136, 95, 0.08)",
    outlinedBorder: "rgba(34, 136, 95, 0.50)",
    selected: "rgba(34, 136, 95, 0.08)"
};
const Action = {
    active: AlphaDeep["56"],
    disabled: AlphaDeep["24"],
    disabledBackground: AlphaDeep["12"],
    focus: AlphaDeep["12"],
    hover: AlphaDeep["4"],
    selected: AlphaDeep["8"]
};
const Tertiary = {
    main: Pinkx["400"],
    light: Pinkx["0"],
    dark: Pinkx["500"],
    contrastText: Common.white.main,
    focus: "rgba(215, 47, 96, 0.12)",
    focusVisible: "rgba(215, 47, 96, 0.10)",
    hover: "rgba(215, 47, 96, 0.04)",
    outlinedBorder: "rgba(215, 47, 96, 0.50)",
    selected: "rgba(215, 47, 96, 0.08)"
};
const Purple = {
    main: Purplex["600"],
    light: Purplex["100"],
    dark: Purplex["700"],
    contrastText: Common.white.main
};
const PurpleLight = {
    main: Purplex["0"],
    dark: Purplex["100"],
    contrastText: Purplex["600"],
    focus: "rgba(134, 127, 232, 0.12)",
    focusVisible: "rgba(134, 127, 232, 0.10)",
    hover: "rgba(134, 127, 232, 0.12)",
    outlinedBorder: "rgba(134, 95, 227, 0.50)",
    selected: "rgba(134, 127, 232, 0.8)"
};
const DeepBlue = {
    main: DeepBluex["300"],
    light: DeepBluex["0"],
    dark: DeepBluex["700"],
    contrastText: Common.white.main
};
const Border = {
    main: AlphaDeep["12"],
    light: AlphaDeep["10"],
    dark: AlphaDeep["30"],
    outlinedBorder: AlphaDeep["50"],
    selected: AlphaDeep["8"],
    focus: AlphaDeep["12"],
    focusVisible: AlphaDeep["30"],
    fillBackdrop: AlphaDeep["50"],
    contrastText: ""
};
const Background = {
    default: Greyx["0"],
    paper: Common.white.main
};
const DIVIDER_COLOR = "#171F361F";
const TRANSPARENT_COLOR = "transparent";
const palette = {
    primary: {
        main: Primary.main,
        light: Primary.light,
        dark: Primary.dark,
        contrastText: Primary.contrastText
    },
    secondary: {
        main: Secondary.main,
        light: Secondary.light,
        dark: Secondary.dark,
        contrastText: Secondary.contrastText
    },
    error: {
        main: ErrorToken.main,
        light: ErrorToken.light,
        dark: ErrorToken.dark,
        contrastText: ErrorToken.contrastText
    },
    warning: {
        main: Warning.main,
        light: Warning.light,
        dark: Warning.dark,
        contrastText: Warning.contrastText
    },
    info: {
        main: Info.main,
        light: Info.light,
        dark: Info.dark,
        contrastText: Info.contrastText
    },
    success: {
        main: Success.main,
        light: Success.light,
        dark: Success.dark,
        contrastText: Success.contrastText
    },
    white: {
        main: White.main,
        light: White.light,
        dark: White.dark,
        contrastText: White.contrastText
    },
    text: {
        primary: Text.primary,
        secondary: Text.secondary,
        disabled: Text.disabled
    },
    action: {
        active: Action.active,
        hover: Action.hover,
        selected: Action.selected,
        focus: Action.focus,
        disabled: Action.disabled,
        disabledBackground: Action.disabledBackground
    },
    tertiary: {
        main: Tertiary.main,
        light: Tertiary.light,
        dark: Tertiary.dark,
        contrastText: Tertiary.contrastText
    },
    purple: {
        main: Purple.main,
        light: Purple.light,
        dark: Purple.dark,
        contrastText: Purple.contrastText
    },
    purpleLight: {
        main: PurpleLight.main,
        dark: PurpleLight.dark,
        contrastText: PurpleLight.contrastText,
        focus: PurpleLight.focus,
        focusVisible: PurpleLight.focusVisible,
        hover: PurpleLight.hover,
        outlinedBorder: PurpleLight.outlinedBorder
    },
    deepBlue: {
        main: DeepBlue.main,
        light: DeepBlue.light,
        dark: DeepBlue.dark,
        contrastText: DeepBlue.contrastText
    },
    border: {
        main: Border.main,
        light: Border.light,
        dark: Border.dark,
        contrastText: Border.contrastText
    },
    tealDusk: {
        main: Tealx["500"],
        light: Tealx["100"],
        dark: Tealx["500"],
        contrastText: "#FFFFFF"
    },
    pinkHaze: {
        main: Purplex["600"],
        light: Purplex["100"],
        dark: Purplex["600"],
        contrastText: "#FFFFFF"
    },
    goldenUmber: {
        main: Goldenx["500"],
        light: Goldenx["100"],
        dark: Goldenx["500"],
        contrastText: "#FFFFFF"
    },
    background: {
        default: Background.default,
        paper: Background.paper
    },
    divider: DIVIDER_COLOR
};
const WorkingTurnsColors = {
    cafOperator: Orangex["400"],
    user: Bluex["400"],
    finalized: Tealx["400"]
};
var displaying_Displaying = /*#__PURE__*/ function(Displaying) {
    Displaying["inherit"] = "inherit";
    Displaying["initial"] = "initial";
    Displaying["inline"] = "inline";
    Displaying["flex"] = "flex";
    Displaying["block"] = "block";
    Displaying["contents"] = "contents";
    Displaying["grid"] = "grid";
    Displaying["inlineBlock"] = "inline-block";
    Displaying["inlineFlex"] = "inline-flex";
    Displaying["inlineGrid"] = "inline-grid";
    Displaying["inlineTable"] = "inline-table";
    Displaying["listItem"] = "list-item";
    Displaying["table"] = "table";
    Displaying["tableCell"] = "table-cell";
    Displaying["none"] = "none";
    Displaying["auto"] = "auto";
    return Displaying;
}({});
var direction_Direction = /*#__PURE__*/ function(Direction) {
    Direction["column"] = "column";
    Direction["row"] = "row";
    Direction["rowReverse"] = "row-reverse";
    Direction["columnReverse"] = "column-reverse";
    return Direction;
}({});
var alignment_Alignment = /*#__PURE__*/ function(Alignment) {
    Alignment["start"] = "start";
    Alignment["end"] = "end";
    Alignment["flexStart"] = "flex-start";
    Alignment["flexEnd"] = "flex-end";
    Alignment["center"] = "center";
    Alignment["left"] = "left";
    Alignment["right"] = "right";
    Alignment["normal"] = "normal";
    Alignment["spaceBetween"] = "space-between";
    Alignment["spaceAround"] = "space-around";
    Alignment["spaceEvenly"] = "space-evenly";
    Alignment["stretch"] = "stretch";
    Alignment["safe"] = "safe";
    Alignment["unsafe"] = "unsafe";
    Alignment["baseline"] = "baseline";
    return Alignment;
}({});
const Spacing = {
    0: "0rem",
    25: "0.025rem",
    125: "0.125rem",
    250: "0.25rem",
    500: "0.5rem",
    650: "0.65rem",
    750: "0.75rem",
    875: "0.875rem",
    1000: "1rem",
    1125: "1.125rem",
    1250: "1.25rem",
    1500: "1.5rem",
    1750: "1.75rem",
    2000: "2rem",
    2180: "2.1875rem",
    2500: "2.5rem",
    3000: "3rem",
    3500: "3.5rem",
    4000: "4rem",
    4500: "4.5rem",
    4750: "4.75rem",
    5000: "5rem",
    6000: "6rem",
    7000: "7rem",
    8000: "8rem",
    10000: "10rem",
    12500: "12.5rem",
    15000: "15rem",
    18750: "18.75rem"
};
const ONE_PIXEL_REM = "0.065rem";
const BorderRadius = {
    none: 0,
    soft: Spacing["125"],
    brand: Spacing["500"],
    paper: Spacing["750"],
    full: "100%"
};
var positioning_Positioning = /*#__PURE__*/ function(Positioning) {
    Positioning["absolute"] = "absolute";
    Positioning["fixed"] = "fixed";
    Positioning["relative"] = "relative";
    Positioning["static"] = "static";
    Positioning["sticky"] = "sticky";
    Positioning["inherit"] = "inherit";
    Positioning["initial"] = "initial";
    Positioning["revert"] = "revert";
    Positioning["revertLayer"] = "revert-layer";
    Positioning["unset"] = "unset";
    Positioning["flexEnd"] = "flex-end";
    return Positioning;
}({});
class Gradient {
    colorName;
    startMainColor;
    fromPercentages;
    toMainColor;
    toPercentages;
    type;
    degree;
    startDarkColor;
    toDarkColor;
    _computedMainColor = new Map();
    _computedDarkColor = new Map();
    getMainColor(opacityScale = 100, overrideToPercentage) {
        const colorMapKey = `${opacityScale}-${overrideToPercentage}`;
        const currentColor = this._computedMainColor.get(colorMapKey);
        if (currentColor) return currentColor;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startMainColor, opacity);
        const rgbaTo = this._hexToRgba(this.toMainColor, opacity);
        const styleWithOpacity = (0, __WEBPACK_EXTERNAL_MODULE__mui_styled_engine_24226ae5__.css)`
      ${this.type}(${this.degree}deg, ${rgbaFrom} ${this.fromPercentages}%, ${rgbaTo} ${overrideToPercentage ?? this.toPercentages}%)
    `;
        const styleSerialized = styleWithOpacity.styles.trim();
        this._computedMainColor.set(colorMapKey, styleSerialized);
        return styleSerialized;
    }
    getDarkColor(opacityScale = 100, overrideToPercentage) {
        const colorMapKey = `${opacityScale}-${overrideToPercentage}`;
        const currentColor = this._computedDarkColor.get(colorMapKey);
        if (currentColor) return currentColor;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startDarkColor, opacity);
        const rgbaTo = this._hexToRgba(this.toDarkColor, opacity);
        const styleWithOpacity = (0, __WEBPACK_EXTERNAL_MODULE__mui_styled_engine_24226ae5__.css)`
      ${this.type}(${this.degree}deg, ${rgbaFrom} ${this.fromPercentages}%, ${rgbaTo} ${overrideToPercentage ?? this.toPercentages}%)
    `;
        const styleSerialized = styleWithOpacity.styles.trim();
        this._computedDarkColor.set(colorMapKey, styleSerialized);
        return styleSerialized;
    }
    getButtonStylesOverride(opacityScale = 100) {
        const overrideSelectorFilled = `&[class*="filled${this.colorName}"]`;
        const overrideSelectorOutlined = `&[class*="outlined${this.colorName}"]:not(:disabled)`;
        const overrideSelectorOutlinedHover = `${overrideSelectorOutlined}:hover`;
        const overrideSelectorOutlinedBefore = `${overrideSelectorOutlined}::before`;
        const overrideSelectorOutlinedBeforeHover = `${overrideSelectorOutlined}:hover::before`;
        const overrideContained = `&[class*="contained${this.colorName}"]:not(:disabled)`;
        const overrideContainedHover = `${overrideContained}:hover`;
        const overrideText = `&[class*="text${this.colorName}"]:not(:disabled)`;
        const overrideTextHover = `${overrideText}:hover`;
        const mainColor = this.getMainColor(opacityScale);
        const darkColor = this.getDarkColor(opacityScale);
        return {
            [overrideSelectorFilled]: {
                background: mainColor
            },
            [overrideContained]: {
                background: mainColor
            },
            [overrideContainedHover]: {
                background: darkColor
            },
            [overrideSelectorOutlined]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${mainColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideSelectorOutlinedHover]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${darkColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideText]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${mainColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            [overrideTextHover]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: `${darkColor} border-box`,
                backgroundClip: "text",
                textFillColor: "transparent"
            },
            "&.MuiButton-root::before": {
                borderRadius: "0.5rem"
            },
            "&.MuiChip-root::before": {
                borderRadius: "50px"
            },
            [overrideSelectorOutlinedBefore]: {
                content: '""',
                position: positioning_Positioning.absolute,
                inset: "0",
                border: "1px solid transparent",
                background: `${mainColor} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            },
            [overrideSelectorOutlinedBeforeHover]: {
                content: '""',
                position: positioning_Positioning.absolute,
                inset: "0",
                border: "1px solid transparent",
                background: `${darkColor} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            }
        };
    }
    getTextStylesOverride(opacityScale = 100) {
        const textGradient = `&.text-gradient${this.colorName}`;
        const mainColor = this.getMainColor(opacityScale, 50);
        return {
            [textGradient]: {
                position: positioning_Positioning.relative,
                borderColor: "transparent",
                background: mainColor,
                backgroundClip: "text",
                textFillColor: "transparent"
            }
        };
    }
    getBoxStylesOverride(opacityScale = 100) {
        const color = this.getMainColor(opacityScale);
        const background = this.getMainColor(10);
        const boxGradient = `&.box-gradient${this.colorName}`;
        const boxGradientBefore = `${boxGradient}::before`;
        const boxGradientBackground = `${boxGradient} .background`;
        const boxGradientContent = `${boxGradient} .content`;
        return {
            [boxGradient]: {
                borderRadius: "0.5rem",
                position: positioning_Positioning.relative,
                background: "transparent"
            },
            [boxGradientBackground]: {
                borderRadius: "0.5rem",
                position: "absolute",
                background: background,
                zIndex: "1"
            },
            [boxGradientContent]: {
                zIndex: "2"
            },
            [boxGradientBefore]: {
                borderRadius: "0.5rem",
                content: '""',
                position: "absolute",
                inset: "0",
                border: "1px solid transparent",
                background: `${color} border-box`,
                mask: `
          linear-gradient(#000 0 0) padding-box, 
          linear-gradient(#000 0 0);`,
                maskComposite: "exclude"
            }
        };
    }
    getBoxOutlinedStylesOverride(opacityScale = 100) {
        const color = this.getMainColor(opacityScale);
        const boxGradient = `&.box-gradientOutlined${this.colorName}`;
        const boxGradientContent = `${boxGradient} .content`;
        return {
            [boxGradient]: {
                position: positioning_Positioning.relative,
                border: "1px solid transparent",
                background: `${color} border-box`
            },
            [boxGradientContent]: {
                background: Background.paper
            }
        };
    }
    getIconStylesOverride() {
        const overrideSvgIconColor = `&[class*="SvgIcon-color${this.colorName}"]`;
        const gradientId = `gradient-${this.colorName.toLowerCase()}`;
        return {
            [overrideSvgIconColor]: {
                fill: `url(#${gradientId})`,
                "*": {
                    fill: `url(#${gradientId}) !important`
                }
            }
        };
    }
    getSvgGradient(opacityScale = 100) {
        const gradientId = `gradient-${this.colorName.toLowerCase()}`;
        const opacity = this._getOpacity(opacityScale);
        const rgbaFrom = this._hexToRgba(this.startMainColor, opacity);
        const rgbaTo = this._hexToRgba(this.toMainColor, opacity);
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
            width: 0,
            height: 0,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("linearGradient", {
                id: gradientId,
                x1: 0,
                y1: 0,
                x2: 1,
                y2: 0,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                        offset: 0,
                        stopColor: rgbaFrom
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("stop", {
                        offset: 1,
                        stopColor: rgbaTo
                    })
                ]
            })
        });
    }
    _getOpacity(opacityScale) {
        const OPACITY_SCALE_DIVISOR = 100;
        const OPACITY_MIN = 0;
        const OPACITY_MAX = 1;
        const opacityWithMin = Math.max(opacityScale / OPACITY_SCALE_DIVISOR, OPACITY_MIN);
        return Math.min(opacityWithMin, OPACITY_MAX);
    }
    _hexToRgba(hex, opacity = 1) {
        const bigint = parseInt(hex.replace("#", ""), 16);
        const red = bigint >> 16 & 255;
        const green = bigint >> 8 & 255;
        const blue = 255 & bigint;
        return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
    }
}
class TealDusk extends Gradient {
    colorName = "TealDusk";
    startMainColor = Tealx["500"];
    fromPercentages = "0";
    toMainColor = Purplex["600"];
    toPercentages = "100";
    type = "linear-gradient";
    degree = 98;
    startDarkColor = Tealx["600"];
    toDarkColor = Purplex["700"];
}
const tealDusk = new TealDusk();
class PinkHaze extends Gradient {
    colorName = "PinkHaze";
    startMainColor = Pinkx["400"];
    fromPercentages = "12.96";
    toMainColor = Purplex["600"];
    toPercentages = "85.66";
    type = "linear-gradient";
    degree = 121.52;
    startDarkColor = Pinkx["500"];
    toDarkColor = Purplex["700"];
}
const pinkHaze = new PinkHaze();
class GoldenUmber extends Gradient {
    colorName = "GoldenUmber";
    startMainColor = Goldenx["400"];
    fromPercentages = "7.99";
    toMainColor = Goldenx["600"];
    toPercentages = "84.09";
    type = "linear-gradient";
    degree = 128.09;
    startDarkColor = Goldenx["500"];
    toDarkColor = Goldenx["700"];
}
const goldenUmber = new GoldenUmber();
function capitalizeFirstLetter(string) {
    const text = string.charAt(0).toUpperCase() + string.slice(1);
    return text;
}
const tealDuskStyle = tealDusk.getTextStylesOverride();
const pinkHazeStyle = pinkHaze.getTextStylesOverride();
const goldenUmberStyle = goldenUmber.getTextStylesOverride();
const TypographyWithGradient = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"])`
  ${tealDuskStyle}
  ${pinkHazeStyle}
  ${goldenUmberStyle}
`;
function Typography(props) {
    const [color, gradientClassName] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = "";
        let color = props.color;
        if (props.gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(props.gradient);
            gradientClassName = ` text-gradient${colorNameCapitalized}`;
            color = `${props.gradient}.main`;
        }
        return [
            color,
            gradientClassName
        ];
    }, [
        props.gradient,
        props.color
    ]);
    const defaultClassname = "";
    const propsClassName = props.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TypographyWithGradient, {
        ...props,
        className: propsClassName + gradientClassName,
        color: color
    });
}
const wrapperStyle = {
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    gap: Spacing["250"],
    alignItems: alignment_Alignment.center,
    lineHeight: "166%"
};
const GridIconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    height: Spacing["1250"]
});
const BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    wrapperStyle
});
function InnerLabel({ label, icon, className }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        className: className,
        style: {
            display: displaying_Displaying.flex,
            flexDirection: direction_Direction.row,
            gap: Spacing["250"],
            whiteSpace: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "primary",
                variant: "caption",
                children: label
            }),
            icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridIconWrapper, {
                item: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxWrapper, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ShieldCheckSolid, {
                        color: "secondary",
                        fontSize: "small"
                    })
                })
            })
        ]
    });
}
function Visa(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.78125",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.9768 16.9364H8.79971L7.16714 10.6178C7.08965 10.3271 6.92512 10.0701 6.6831 9.94904C6.07911 9.64469 5.41356 9.40248 4.6875 9.28032V9.03705H8.19466C8.6787 9.03705 9.04173 9.40248 9.10224 9.82688L9.94931 14.3847L12.1254 9.03705H14.242L10.9768 16.9364ZM15.4526 16.9364H13.3965L15.0896 9.03705H17.1457L15.4526 16.9364ZM19.8051 11.226C19.8656 10.8006 20.2287 10.5573 20.6522 10.5573C21.3177 10.4962 22.0427 10.6184 22.6478 10.9217L23.0108 9.2209C22.4058 8.97763 21.7402 8.85547 21.1362 8.85547C19.1406 8.85547 17.6885 9.94964 17.6885 11.4682C17.6885 12.6235 18.7171 13.2301 19.4432 13.5955C20.2287 13.9599 20.5312 14.2031 20.4707 14.5675C20.4707 15.1141 19.8656 15.3573 19.2616 15.3573C18.5356 15.3573 17.8095 15.1751 17.145 14.8708L16.782 16.5726C17.5081 16.8759 18.2936 16.9981 19.0196 16.9981C21.2572 17.0581 22.6478 15.965 22.6478 14.3242C22.6478 12.258 19.8051 12.1369 19.8051 11.226ZM29.8442 16.9364L28.2117 9.03705H26.4581C26.0951 9.03705 25.732 9.28032 25.611 9.64469L22.5879 16.9364H24.7045L25.127 15.7822H27.7276L27.9696 16.9364H29.8442ZM26.7601 11.1656L27.3641 14.1428H25.671L26.7601 11.1656Z",
                    fill: "#172B85"
                })
            ]
        })
    });
}
function Amex(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.4585",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "#1F72CD",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.15272 8.78143L3.80225 16.5246H7.81323L8.31048 15.29H9.44707L9.94432 16.5246H14.3593V15.5823L14.7527 16.5246H17.0365L17.4299 15.5624V16.5246H26.6118L27.7283 15.3221L28.7737 16.5246L33.4897 16.5346L30.1287 12.6746L33.4897 8.78143H28.8468L27.76 9.96173L26.7475 8.78143H16.7588L15.901 10.78L15.0232 8.78143H11.0206V9.69165L10.5753 8.78143H7.15272ZM20.8638 9.883H26.1365L27.7491 11.7022L29.4138 9.883H31.0265L28.5762 12.6756L31.0265 15.436H29.3407L27.728 13.5956L26.0548 15.436H20.8638V9.883ZM22.1665 12.0467V11.0324V11.0314H25.4565L26.8921 12.6535L25.3929 14.2845H22.1665V13.1772H25.043V12.0467H22.1665ZM7.9282 9.883H9.88334L12.1057 15.1337V9.883H14.2475L15.964 13.6477L17.546 9.883H19.6771V15.4392H18.3804L18.3698 11.0854L16.4793 15.4392H15.3193L13.4183 11.0854V15.4392H10.7506L10.2449 14.1936H7.51259L7.0079 15.4381H5.57861L7.9282 9.883ZM7.97998 13.0395L8.88016 10.8205L9.7793 13.0395H7.97998Z",
                    fill: "white"
                })
            ]
        })
    });
}
function MasterCard(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.13525",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6579 18.2752C17.2867 19.4257 15.5079 20.1203 13.5642 20.1203C9.22721 20.1203 5.71143 16.6625 5.71143 12.3971C5.71143 8.13163 9.22721 4.67383 13.5642 4.67383C15.5079 4.67383 17.2867 5.36837 18.6579 6.51889C20.0292 5.36837 21.808 4.67383 23.7517 4.67383C28.0886 4.67383 31.6044 8.13163 31.6044 12.3971C31.6044 16.6625 28.0886 20.1203 23.7517 20.1203C21.808 20.1203 20.0292 19.4257 18.6579 18.2752Z",
                    fill: "#ED0006"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6577 18.2752C20.3461 16.8586 21.4167 14.7508 21.4167 12.3971C21.4167 10.0433 20.3461 7.93546 18.6577 6.51888C20.029 5.36837 21.8078 4.67383 23.7515 4.67383C28.0884 4.67383 31.6042 8.13163 31.6042 12.3971C31.6042 16.6625 28.0884 20.1203 23.7515 20.1203C21.8078 20.1203 20.029 19.4257 18.6577 18.2752Z",
                    fill: "#F9A000"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.6579 18.2752C20.3463 16.8586 21.4169 14.7508 21.4169 12.3971C21.4169 10.0433 20.3463 7.93546 18.6579 6.51888C16.9695 7.93546 15.8989 10.0433 15.8989 12.397C15.8989 14.7508 16.9695 16.8586 18.6579 18.2752Z",
                    fill: "#FF5E00"
                })
            ]
        })
    });
}
function Maestro(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.8125",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M20.7758 12.4141C20.7758 16.6813 17.3562 20.1406 13.1379 20.1406C8.9196 20.1406 5.5 16.6813 5.5 12.4141C5.5 8.1468 8.9196 4.6875 13.1379 4.6875C17.3562 4.6875 20.7758 8.1468 20.7758 12.4141Z",
                    fill: "#ED0006"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M30.684 12.4141C30.684 16.6813 27.2644 20.1406 23.0461 20.1406C18.8278 20.1406 15.4082 16.6813 15.4082 12.4141C15.4082 8.1468 18.8278 4.6875 23.0461 4.6875C27.2644 4.6875 30.684 8.1468 30.684 12.4141Z",
                    fill: "#0099DF"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.093 18.2951C19.7353 16.8779 20.7768 14.7691 20.7768 12.4142C20.7768 10.0592 19.7354 7.9504 18.093 6.5332C16.4506 7.9504 15.4092 10.0593 15.4092 12.4142C15.4092 14.7691 16.4506 16.8779 18.093 18.2951Z",
                    fill: "#6C6BBD"
                })
            ]
        })
    });
}
function Paypal(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.48975",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.021 15.8768H9.40057C9.28968 15.8768 9.19537 15.9574 9.17808 16.0669L8.5227 20.2221C8.50967 20.3041 8.57317 20.378 8.65634 20.378H9.42995C9.54084 20.378 9.63514 20.2975 9.65244 20.1878L9.8292 19.0671C9.84625 18.9573 9.94079 18.8768 10.0515 18.8768H10.5644C11.6319 18.8768 12.2479 18.3603 12.4088 17.3367C12.4813 16.8889 12.4119 16.537 12.2021 16.2905C11.9719 16.02 11.5633 15.8768 11.021 15.8768ZM11.208 17.3945C11.1194 17.976 10.6751 17.976 10.2455 17.976H10.001L10.1725 16.89C10.1827 16.8244 10.2396 16.7761 10.3059 16.7761H10.418C10.7106 16.7761 10.9867 16.7761 11.1293 16.9428C11.2143 17.0424 11.2404 17.1902 11.208 17.3945ZM15.8649 17.3758H15.0889C15.0228 17.3758 14.9656 17.4242 14.9554 17.4899L14.9211 17.7069L14.8668 17.6283C14.6989 17.3844 14.3243 17.3029 13.9504 17.3029C13.0928 17.3029 12.3605 17.9524 12.2178 18.8635C12.1437 19.3178 12.2491 19.7524 12.5069 20.0555C12.7434 20.3341 13.0818 20.4502 13.4843 20.4502C14.1752 20.4502 14.5584 20.0059 14.5584 20.0059L14.5238 20.2216C14.5107 20.304 14.5742 20.3779 14.6569 20.3779H15.3559C15.4671 20.3779 15.5608 20.2973 15.5784 20.1877L15.9978 17.5318C16.011 17.4501 15.9478 17.3758 15.8649 17.3758ZM14.7832 18.8862C14.7083 19.3295 14.3564 19.6271 13.9077 19.6271C13.6824 19.6271 13.5023 19.5548 13.3867 19.4178C13.272 19.2819 13.2284 19.0882 13.2649 18.8727C13.3348 18.4331 13.6926 18.1258 14.1345 18.1258C14.3548 18.1258 14.5339 18.199 14.6519 18.3371C14.7701 18.4767 14.8171 18.6715 14.7832 18.8862ZM19.2178 17.3757H19.9977C20.1069 17.3757 20.1706 17.4982 20.1085 17.5878L17.515 21.3314C17.473 21.3921 17.4038 21.4282 17.3299 21.4282H16.5511C16.4414 21.4282 16.3774 21.3047 16.4409 21.2149L17.2484 20.075L16.3895 17.5544C16.3598 17.4667 16.4245 17.3757 16.5177 17.3757H17.284C17.3835 17.3757 17.4713 17.4411 17.5001 17.5364L17.9559 19.0587L19.0314 17.4745C19.0735 17.4127 19.1435 17.3757 19.2178 17.3757Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M27.6728 20.2223L28.3378 15.9911C28.348 15.9254 28.4049 15.8771 28.471 15.8768H29.2197C29.3024 15.8768 29.3659 15.951 29.3528 16.033L28.697 20.188C28.6799 20.2977 28.5856 20.3783 28.4745 20.3783H27.8059C27.7232 20.3783 27.6597 20.3044 27.6728 20.2223ZM22.5797 15.8771H20.9589C20.8483 15.8771 20.754 15.9576 20.7367 16.0671L20.0813 20.2223C20.0682 20.3044 20.1317 20.3783 20.2145 20.3783H21.0461C21.1234 20.3783 21.1895 20.3219 21.2016 20.2452L21.3875 19.0673C21.4047 18.9575 21.4992 18.8771 21.6098 18.8771H22.1225C23.1902 18.8771 23.8061 18.3605 23.9672 17.3369C24.0399 16.8891 23.97 16.5372 23.7604 16.2908C23.5302 16.0203 23.122 15.8771 22.5797 15.8771ZM22.7666 17.3947C22.6782 17.9762 22.2339 17.9762 21.8041 17.9762H21.5598L21.7316 16.8902C21.7418 16.8246 21.7982 16.7763 21.8647 16.7763H21.9768C22.2692 16.7763 22.5456 16.7763 22.6881 16.9431C22.7732 17.0426 22.7991 17.1904 22.7666 17.3947ZM27.4231 17.3761H26.6477C26.581 17.3761 26.5244 17.4244 26.5144 17.4901L26.4801 17.7071L26.4256 17.6285C26.2576 17.3846 25.8833 17.3032 25.5094 17.3032C24.6518 17.3032 23.9197 17.9526 23.777 18.8637C23.7031 19.3181 23.8081 19.7526 24.0658 20.0557C24.3028 20.3343 24.6407 20.4504 25.0433 20.4504C25.7342 20.4504 26.1173 20.0061 26.1173 20.0061L26.0827 20.2218C26.0697 20.3043 26.1332 20.3782 26.2164 20.3782H26.9151C27.0257 20.3782 27.12 20.2976 27.1373 20.1879L27.557 17.532C27.5698 17.4503 27.5063 17.3761 27.4231 17.3761ZM26.3415 18.8864C26.2671 19.3297 25.9148 19.6273 25.466 19.6273C25.2411 19.6273 25.0606 19.555 24.9449 19.4181C24.8302 19.2821 24.7871 19.0885 24.8232 18.8729C24.8935 18.4333 25.2508 18.1261 25.6927 18.1261C25.9131 18.1261 26.0922 18.1992 26.2103 18.3374C26.3289 18.4769 26.3758 18.6717 26.3415 18.8864Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.0183 14.389L17.2175 13.1236L16.7738 13.1133H14.6548L16.1274 3.77597C16.1319 3.74778 16.1468 3.7215 16.1685 3.70284C16.1902 3.68417 16.2181 3.67389 16.247 3.67389H19.8199C21.0061 3.67389 21.8246 3.92072 22.2521 4.4079C22.4524 4.63646 22.58 4.87528 22.6418 5.13811C22.7064 5.4139 22.7077 5.74339 22.6444 6.14525L22.6398 6.17459V6.43208L22.8402 6.5456C23.009 6.6351 23.143 6.73757 23.2458 6.85489C23.4173 7.0503 23.5282 7.29866 23.575 7.5931C23.6233 7.89593 23.6073 8.25627 23.5282 8.66423C23.4367 9.13352 23.2889 9.54224 23.0893 9.87668C22.9057 10.1848 22.6718 10.4404 22.3942 10.6385C22.129 10.8267 21.814 10.9695 21.4579 11.061C21.1127 11.1508 20.7193 11.1962 20.2877 11.1962H20.0096C19.8108 11.1962 19.6176 11.2678 19.4661 11.3962C19.3141 11.5272 19.2135 11.7062 19.1826 11.902L19.1617 12.0159L18.8097 14.2461L18.7937 14.328C18.7896 14.354 18.7823 14.3669 18.7717 14.3757C18.7621 14.3836 18.7484 14.389 18.7351 14.389H17.0183Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M23.03 6.20709C23.0193 6.27527 23.0072 6.34498 22.9935 6.41659C22.5222 8.83577 20.9102 9.6715 18.8514 9.6715H17.8031C17.5514 9.6715 17.3392 9.85433 17.2999 10.1027L16.7632 13.5066L16.6112 14.4714C16.5857 14.6344 16.7114 14.7815 16.8759 14.7815H18.7352C18.9554 14.7815 19.1424 14.6215 19.177 14.4044L19.1953 14.3099L19.5454 12.0884L19.5679 11.9665C19.6021 11.7487 19.7895 11.5887 20.0097 11.5887H20.2878C22.0891 11.5887 23.4993 10.8573 23.9115 8.74092C24.0836 7.85682 23.9945 7.11862 23.5389 6.59943C23.401 6.44287 23.23 6.31298 23.03 6.20709Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M22.5365 6.00903C22.4646 5.98807 22.3902 5.96903 22.314 5.95189C22.2375 5.93514 22.159 5.92028 22.0783 5.90733C21.7956 5.86162 21.486 5.8399 21.1542 5.8399H18.3537C18.2847 5.8399 18.2193 5.85552 18.1606 5.88371C18.0314 5.94579 17.9355 6.06807 17.9123 6.21777L17.3164 9.9911L17.2993 10.1012C17.3386 9.85282 17.5507 9.66998 17.8025 9.66998H18.8507C20.9096 9.66998 22.5217 8.83388 22.9929 6.41508C23.0069 6.34347 23.0187 6.27377 23.0294 6.20559C22.9102 6.14235 22.781 6.08826 22.642 6.04216C22.6078 6.03074 22.5724 6.0197 22.5365 6.00903Z",
                    fill: "#222D65"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M17.9125 6.21793C17.9358 6.06822 18.0318 5.94595 18.1609 5.88424C18.22 5.85605 18.2851 5.84044 18.354 5.84044H21.1545C21.4863 5.84044 21.796 5.86215 22.0786 5.90786C22.1594 5.92081 22.2379 5.93567 22.3144 5.95242C22.3906 5.96957 22.4648 5.98862 22.5369 6.00956C22.5726 6.02023 22.6081 6.03127 22.6427 6.04232C22.7817 6.08841 22.9109 6.14288 23.0301 6.20574C23.1703 5.31173 23.029 4.70303 22.5457 4.15185C22.0128 3.54506 21.0509 3.28528 19.8202 3.28528H16.2472C15.9958 3.28528 15.7814 3.46811 15.7425 3.71685L14.2543 13.1502C14.2249 13.3368 14.3689 13.5052 14.557 13.5052H16.763L17.3168 9.99125L17.9125 6.21793Z",
                    fill: "#253B80"
                })
            ]
        })
    });
}
function ApplePay(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "37",
            height: "25",
            viewBox: "0 0 37 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "1.1665",
                    y: "0.781464",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.95529 9.30647C9.43792 9.34777 9.92056 9.05865 10.2222 8.69209C10.5188 8.31521 10.7149 7.80925 10.6646 7.29297C10.2373 7.31362 9.7094 7.58209 9.40776 7.95897C9.13125 8.28423 8.89496 8.81084 8.95529 9.30647ZM14.6958 15.9567V7.9079H17.6368C19.1551 7.9079 20.2159 8.98176 20.2159 10.5513C20.2159 12.1208 19.135 13.2049 17.5966 13.2049H15.9124V15.9567H14.6958ZM10.6591 9.40484C10.2339 9.37971 9.84598 9.53616 9.53261 9.66252C9.33094 9.74384 9.16017 9.81271 9.03025 9.81271C8.88446 9.81271 8.70664 9.74016 8.50698 9.65871C8.24537 9.55198 7.94628 9.42996 7.63263 9.43582C6.91371 9.44615 6.24507 9.86433 5.87807 10.5303C5.12396 11.8623 5.682 13.8345 6.41097 14.9187C6.76792 15.4557 7.19525 16.0442 7.75832 16.0236C8.00604 16.014 8.18423 15.9363 8.36864 15.856C8.58095 15.7634 8.80151 15.6673 9.14588 15.6673C9.47832 15.6673 9.68923 15.7609 9.89169 15.8508C10.0842 15.9362 10.2691 16.0183 10.5435 16.0132C11.1267 16.0029 11.4937 15.4763 11.8506 14.9394C12.2358 14.3631 12.4051 13.8007 12.4308 13.7153L12.4338 13.7055C12.4332 13.7048 12.4285 13.7026 12.4201 13.6987L12.4201 13.6987L12.42 13.6986C12.2913 13.6381 11.3071 13.1754 11.2976 11.9346C11.2881 10.8932 12.0783 10.3655 12.2026 10.2824C12.2102 10.2774 12.2153 10.274 12.2176 10.2722C11.7149 9.5081 10.9306 9.4255 10.6591 9.40484ZM22.4385 16.0174C23.2027 16.0174 23.9116 15.6199 24.2333 14.99H24.2585V15.9555H25.3846V11.9491C25.3846 10.7875 24.4797 10.0389 23.0871 10.0389C21.795 10.0389 20.8398 10.7978 20.8046 11.8407H21.9006C21.9911 11.3451 22.4385 11.0198 23.0519 11.0198C23.7959 11.0198 24.2132 11.376 24.2132 12.0317V12.4757L22.6949 12.5687C21.2822 12.6564 20.5181 13.2501 20.5181 14.2827C20.5181 15.3256 21.3074 16.0174 22.4385 16.0174ZM22.7651 15.0652C22.1166 15.0652 21.7043 14.7451 21.7043 14.2546C21.7043 13.7486 22.1015 13.4544 22.8606 13.4079L24.213 13.3201V13.7745C24.213 14.5282 23.5896 15.0652 22.7651 15.0652ZM29.1197 16.2711C28.6321 17.6805 28.074 18.1452 26.8876 18.1452C26.7971 18.1452 26.4954 18.1348 26.425 18.1142V17.1488C26.5004 17.1591 26.6865 17.1694 26.782 17.1694C27.3199 17.1694 27.6216 16.9371 27.8076 16.333L27.9182 15.9768L25.8569 10.117H27.1289L28.5617 14.872H28.5868L30.0196 10.117H31.2564L29.1197 16.2711ZM15.9126 8.96075H17.3152C18.371 8.96075 18.9743 9.53899 18.9743 10.5561C18.9743 11.5731 18.371 12.1565 17.3102 12.1565H15.9126V8.96075Z",
                    fill: "black"
                })
            ]
        })
    });
}
function Bancomat(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "36",
            height: "25",
            viewBox: "0 0 36 25",
            fill: "none",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("rect", {
                    x: "0.84375",
                    y: "0.781494",
                    width: "34.375",
                    height: "23.4375",
                    rx: "3.125",
                    fill: "white",
                    stroke: "#D9D9D9",
                    strokeWidth: "1.5625"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.92472 10.7023H6.2105C6.53412 10.7023 6.81384 11.0526 6.73518 11.5284C6.65638 12.0043 6.33291 12.1931 6.33291 12.1931C6.33291 12.1931 6.50908 12.2559 6.60261 12.4633C6.66934 12.6116 6.6907 12.8343 6.5954 13.1267C6.47387 13.4995 6.1451 13.7735 5.78628 13.7735H4.51817C4.43097 13.7735 4.33464 13.7554 4.3697 13.5668C4.39798 13.4147 4.67151 11.1336 4.70628 10.918C4.72513 10.8014 4.76402 10.7023 4.92472 10.7023ZM5.45809 11.3759L5.38386 11.8697H5.73796C5.86464 11.8697 5.92842 11.7411 5.95656 11.6545C5.99176 11.5465 5.99176 11.3761 5.81662 11.3761L5.45809 11.3759ZM5.28826 12.5195L5.19988 13.1244C5.19988 13.1244 5.51598 13.1276 5.61512 13.1244C5.74503 13.1199 5.8315 12.9837 5.86361 12.8734C5.90338 12.7362 5.90338 12.5195 5.70438 12.5195H5.28826ZM9.18552 13.6299C9.16357 13.4816 8.80092 10.9314 8.78339 10.8595C8.76601 10.7876 8.72211 10.7023 8.62593 10.7023H7.83021C7.7601 10.7023 7.69028 10.7113 7.64638 10.81C7.60278 10.9088 6.57507 13.5311 6.53559 13.6162C6.49626 13.7015 6.5353 13.7734 6.63193 13.7734H7.22672C7.3098 13.7734 7.36681 13.7866 7.41041 13.6701C7.42956 13.6191 7.51381 13.3625 7.61692 13.0472C7.62605 13.0351 7.64329 13.0233 7.67702 13.0233H8.18005C8.19419 13.0233 8.20303 13.0327 8.21025 13.0444C8.23735 13.3749 8.25885 13.6415 8.25885 13.661C8.25885 13.7149 8.29818 13.7734 8.39864 13.7734H9.08535C9.15488 13.7735 9.20334 13.7464 9.18552 13.6299ZM8.13174 12.35C8.08195 12.3479 7.94363 12.35 7.89119 12.35C7.86173 12.35 7.85496 12.3332 7.85555 12.3158C7.92426 12.1042 7.99364 11.8929 8.06368 11.6817C8.08195 11.6272 8.09697 11.6811 8.09697 11.6811C8.09697 11.6811 8.12142 11.9726 8.15118 12.3314C8.14735 12.3419 8.14205 12.3506 8.13174 12.35ZM9.61946 10.8415C9.60179 10.9853 9.29143 13.468 9.27817 13.5534C9.26521 13.6387 9.28716 13.7735 9.42709 13.7735H9.82937C9.88622 13.7735 10.0347 13.7823 10.0653 13.5668C10.096 13.3515 10.2028 12.5736 10.2184 12.4985C10.2316 12.4356 10.2926 12.4444 10.3015 12.4761C10.3103 12.5073 10.6987 13.5135 10.73 13.5805C10.7868 13.7018 10.8307 13.7738 10.9223 13.7738H11.3552C11.4383 13.7738 11.5258 13.7557 11.5476 13.585C11.5694 13.4145 11.8801 10.999 11.8975 10.8822C11.9148 10.7655 11.845 10.7026 11.7357 10.7026H11.294C11.1979 10.7026 11.1409 10.6758 11.1147 10.8282C11.0885 10.981 10.9774 11.7274 10.9662 11.7801C10.9574 11.8205 10.9094 11.8205 10.8961 11.7845C10.8602 11.6861 10.5725 10.9495 10.5289 10.8374C10.485 10.725 10.4547 10.7026 10.3583 10.7026H9.82937C9.69356 10.7023 9.63685 10.6979 9.61946 10.8415ZM13.7827 10.7H12.6764C12.2653 10.7 12.0947 10.938 11.9766 11.4183C11.8838 11.7967 11.7862 12.8283 11.7929 13.0302C11.8061 13.421 11.8499 13.771 12.2172 13.771C12.5845 13.771 13.2535 13.7754 13.3761 13.771C13.4985 13.7666 13.5683 13.7171 13.6078 13.6006C13.6493 13.4771 13.6555 13.3939 13.6646 13.2862C13.6735 13.183 13.6776 13.0887 13.5465 13.0887H12.9037C12.7841 13.0887 12.6107 13.0796 12.6063 12.8776C12.6018 12.6755 12.6151 12.4424 12.6499 12.2132C12.6849 11.9844 12.7344 11.7109 12.7854 11.5533C12.8556 11.3376 12.9474 11.3423 13.1006 11.3423H13.7652C13.8701 11.3423 13.9184 11.2791 13.9443 11.1853C13.9708 11.0909 13.9894 10.9431 13.9927 10.8484C13.9971 10.7179 13.9574 10.7 13.7827 10.7ZM23.6026 10.7023H21.8975C21.7726 10.7023 21.7131 10.697 21.6919 10.8303C21.6684 10.9836 21.6457 11.1371 21.624 11.2906C21.611 11.3846 21.6458 11.3937 21.7333 11.3937H22.1794C22.2186 11.3937 22.2229 11.4161 22.2142 11.479C22.2055 11.5419 21.9555 13.5478 21.9432 13.625C21.9214 13.7598 21.9342 13.7734 22.0482 13.7734C22.1442 13.7734 22.4811 13.776 22.5727 13.7734C22.7218 13.7687 22.7433 13.8046 22.7786 13.6206C22.8131 13.4365 23.0537 11.4834 23.0537 11.4431C23.0537 11.4027 23.0669 11.389 23.1285 11.389C23.1892 11.389 23.5568 11.3846 23.6178 11.389C23.6791 11.3937 23.7053 11.3578 23.7141 11.3083C23.7231 11.2591 23.7423 10.9381 23.7423 10.8751C23.7424 10.7584 23.7296 10.7023 23.6026 10.7023ZM15.9174 13.192C15.8043 13.6623 15.5196 13.7712 15.2525 13.7712H14.251C13.8838 13.7712 13.8115 13.4168 13.8182 13.026C13.8244 12.6531 13.9125 11.8443 14.0019 11.4183C14.1033 10.934 14.2993 10.7 14.7104 10.7H15.6851C15.9653 10.7 16.1684 10.8524 16.1708 11.2031C16.1745 11.7243 16.0918 12.4645 15.9174 13.192ZM14.9825 11.3579C14.8557 11.3668 14.7978 11.4329 14.7727 11.5375C14.7121 11.7891 14.6053 12.5316 14.5889 12.8934C14.582 13.0425 14.6599 13.0713 14.7507 13.0911C14.8384 13.1096 14.9357 13.117 15.009 13.0999C15.0924 13.0805 15.1488 13.0563 15.1837 12.9202C15.2718 12.5767 15.3413 12.0128 15.3715 11.6091C15.3776 11.5312 15.3701 11.3868 15.2538 11.3666C15.1498 11.349 15.1093 11.3487 14.9825 11.3579ZM16.6237 10.7023C16.5624 10.7023 16.4749 10.7291 16.4442 10.9088C16.4137 11.0884 16.0736 13.5042 16.0551 13.6299C16.0419 13.7195 16.0989 13.7735 16.1907 13.7735H16.7068C16.8336 13.7735 16.8728 13.7554 16.9033 13.5894C16.9341 13.4231 17.0784 12.3456 17.0829 12.3007C17.0871 12.2557 17.1223 12.2691 17.1266 12.3051C17.1309 12.341 17.2621 12.9561 17.271 13.0102C17.2794 13.064 17.2972 13.1179 17.3409 13.1223C17.3844 13.1267 17.7385 13.1223 17.765 13.1223C17.7912 13.1223 17.835 13.1314 17.8786 13.064C17.9289 12.9865 18.2417 12.3323 18.2502 12.3052C18.2592 12.2784 18.3069 12.2649 18.3025 12.3008C18.2985 12.3367 18.1256 13.5358 18.1147 13.6072C18.1014 13.6926 18.1542 13.7735 18.2415 13.7735C18.3287 13.7735 18.7314 13.7762 18.7968 13.7735C18.9061 13.7688 18.9499 13.742 18.9936 13.5084C19.0196 13.3706 19.2912 10.9853 19.2997 10.9044C19.313 10.7832 19.2732 10.7023 19.1509 10.7023H18.4603C18.3815 10.7023 18.3115 10.7247 18.2677 10.8011C18.1956 10.9268 17.8108 11.6764 17.7867 11.7171C17.7516 11.7754 17.6949 11.771 17.6774 11.7035C17.6598 11.6362 17.5286 10.9582 17.5114 10.873C17.4935 10.7874 17.4981 10.703 17.3188 10.7022C17.0958 10.7011 16.6847 10.7023 16.6237 10.7023ZM21.7157 13.6275C21.6939 13.4795 21.3314 10.9292 21.3136 10.8571C21.2964 10.7854 21.2523 10.7 21.1563 10.7H20.3606C20.2906 10.7 20.2208 10.7091 20.1767 10.8079C20.133 10.9066 19.1057 13.5287 19.0662 13.6138C19.0268 13.6991 19.066 13.771 19.1623 13.771H19.7569C19.84 13.771 19.897 13.7846 19.9408 13.6677C19.9598 13.6171 20.044 13.3605 20.1473 13.0453C20.1563 13.0332 20.1735 13.0214 20.2074 13.0214H20.7103C20.7244 13.0214 20.7332 13.0308 20.7405 13.0425C20.7676 13.373 20.7891 13.6393 20.7891 13.6588C20.7891 13.7127 20.8283 13.7712 20.9289 13.7712H21.6153C21.6852 13.7712 21.7336 13.7443 21.7157 13.6275ZM20.6618 12.3479C20.612 12.3456 20.474 12.3479 20.4216 12.3479C20.3919 12.3479 20.385 12.3307 20.3856 12.3133C20.4545 12.1019 20.524 11.8907 20.5939 11.6796C20.612 11.6248 20.627 11.6789 20.627 11.6789C20.627 11.6789 20.6518 11.9704 20.6814 12.3291C20.6777 12.3397 20.6723 12.3485 20.6618 12.3479Z",
                    fill: "#1A4678"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("mask", {
                    id: "mask0_3361_5052",
                    style: {
                        maskType: "alpha"
                    },
                    maskUnits: "userSpaceOnUse",
                    x: "24",
                    y: "9",
                    width: "8",
                    height: "7",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                        d: "M31.7622 12.5C31.7622 14.433 30.1952 16 28.2622 16C26.3292 16 24.7622 14.433 24.7622 12.5C24.7622 10.567 26.3292 9 28.2622 9C30.1952 9 31.7622 10.567 31.7622 12.5Z",
                        fill: "#D9D9D9"
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("g", {
                    mask: "url(#mask0_3361_5052)",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M24.7622 9H31.7622V12.5H24.7622V9Z",
                            fill: "#1A4678"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                            d: "M24.7622 12.5H31.7622V16H24.7622V12.5Z",
                            fill: "#A09EA9"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M30.342 12.934C30.3897 12.9569 30.4343 12.9851 30.4749 13.0183C30.5227 12.9136 30.5389 12.775 30.5101 12.6523C30.4865 12.5532 30.4403 12.4653 30.3562 12.3753C30.2968 12.3067 30.2107 12.2497 30.119 12.209C30.0314 12.173 29.924 12.1514 29.8273 12.1514H29.3951C29.5938 12.0215 29.755 11.8454 29.8638 11.6394C29.939 11.4934 29.9979 11.3382 30.0065 11.1745C30.0156 11.0127 29.979 10.8552 29.915 10.7058C29.8553 10.5665 29.7668 10.4403 29.6548 10.3349C29.5169 10.2059 29.34 10.1217 29.1575 10.0649C29.0019 10.0178 28.839 10 28.6764 10H26.91L26.5984 10.7206L28.2931 10.7177C28.436 10.7119 28.5785 10.771 28.6335 10.8059C28.72 10.8516 28.783 10.9236 28.839 11.0023C28.933 11.1311 28.9621 11.2888 28.952 11.4427C28.9438 11.5878 28.8915 11.7273 28.8018 11.8441C28.7414 11.9213 28.6655 11.986 28.5787 12.0345C28.446 12.1127 28.2906 12.1607 28.1316 12.1607H26.8715L26.5661 12.8802H28.1264C28.2818 12.8802 28.4571 12.9317 28.5871 13.0101C28.6854 13.0691 28.7667 13.162 28.8305 13.2544C28.9057 13.3616 28.9268 13.4702 28.9343 13.6006C28.9431 13.7544 28.9057 13.894 28.8241 14.0231C28.7816 14.0954 28.6964 14.1722 28.6211 14.2182C28.5224 14.2773 28.3997 14.3072 28.2817 14.3072H26.8527L26.5244 15H28.7051C28.8618 15 29.0154 14.9807 29.1648 14.9361C29.3087 14.8927 29.4503 14.8349 29.5693 14.7425C29.7212 14.6239 29.8287 14.466 29.899 14.2915C29.9594 14.1392 29.9845 13.9761 29.9726 13.8136C29.9601 13.6242 29.8952 13.4436 29.7938 13.2823C29.69 13.1197 29.5485 12.9823 29.3803 12.8809H30.0705C30.1818 12.8822 30.257 12.8955 30.342 12.934Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M32.289 9.69093C32.1643 9.69093 32.0579 9.73528 31.9695 9.82398C31.8816 9.91221 31.8377 10.0188 31.8377 10.1437C31.8377 10.2696 31.8814 10.3769 31.9688 10.4656C32.0567 10.5543 32.1634 10.5987 32.289 10.5987C32.4146 10.5987 32.5213 10.5543 32.6092 10.4656C32.697 10.3769 32.741 10.2696 32.741 10.1437C32.741 10.0188 32.697 9.91221 32.6092 9.82398C32.5208 9.73528 32.4141 9.69093 32.289 9.69093ZM32.8155 10.1437C32.8155 10.2892 32.7641 10.4134 32.6614 10.5164C32.5588 10.6194 32.4346 10.6709 32.289 10.6709C32.1433 10.6709 32.0194 10.6194 31.9172 10.5164C31.8155 10.4139 31.7646 10.2897 31.7646 10.1437C31.7646 9.99924 31.816 9.87572 31.9187 9.7732C32.0208 9.67114 32.1443 9.62012 32.289 9.62012C32.4346 9.62012 32.5588 9.67114 32.6614 9.7732C32.7641 9.87525 32.8155 9.99876 32.8155 10.1437ZM32.4265 10.0293C32.4265 9.98731 32.4136 9.95918 32.3878 9.94487C32.3625 9.93057 32.3217 9.92341 32.2653 9.92341H32.1787V10.1323H32.2704C32.3133 10.1323 32.3456 10.128 32.3671 10.1194C32.4067 10.1037 32.4265 10.0736 32.4265 10.0293ZM32.2789 9.85403C32.3506 9.85403 32.4031 9.86094 32.4365 9.87477C32.4962 9.89957 32.5261 9.94821 32.5261 10.0207C32.5261 10.0722 32.5072 10.1101 32.4695 10.1344C32.4494 10.1473 32.4215 10.1566 32.3857 10.1623C32.431 10.1695 32.4642 10.1883 32.4852 10.2188C32.5063 10.2494 32.5168 10.2792 32.5168 10.3083V10.3505C32.5168 10.3638 32.5172 10.3781 32.5182 10.3934C32.5191 10.4086 32.5208 10.4187 32.5232 10.4234L32.5268 10.4306H32.4315C32.431 10.4287 32.4306 10.4268 32.4301 10.4249C32.4296 10.4229 32.4291 10.4208 32.4287 10.4184L32.4265 10.3998V10.354C32.4265 10.2873 32.4084 10.2432 32.3721 10.2217C32.3506 10.2093 32.3129 10.2031 32.2589 10.2031H32.1787V10.4306H32.077V9.85403H32.2789Z",
                    fill: "#1A4678"
                })
            ]
        })
    });
}
const AcceptedPaymentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])({
    ".inner-label": {
        width: "auto",
        padding: `0 ${Spacing["250"]}`,
        position: positioning_Positioning.relative,
        background: "inherit"
    }
});
const CommonBorder = `1px solid ${Primary.main}`;
const accepted_payment_BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.spaceBetween,
    padding: `0 ${Spacing["750"]} ${Spacing["1000"]}`,
    borderRadius: `0 0 ${BorderRadius.brand} ${BorderRadius.brand}`,
    border: CommonBorder,
    borderTop: "0",
    width: "auto"
});
const LeftRadiusStyle = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderRadius: `${BorderRadius.brand} 0 0 0`,
    borderTop: CommonBorder,
    borderLeft: CommonBorder
});
const RightRadiusStyle = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderRadius: `0 ${BorderRadius.brand} 0 0`,
    borderTop: CommonBorder,
    borderRight: CommonBorder
});
const FlexSpaceBetween = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    justifyContent: "space-between"
});
const FlexRow = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row
});
const accepted_payment_fullWidth = {
    width: "100%"
};
function AcceptedPayment({ label, labelIcon, id }) {
    const largeFontSize = "large";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AcceptedPaymentContainer, {
            className: "accepted-payment",
            "data-testid": id ?? "id",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlexSpaceBetween, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftRadiusStyle, {
                                    children: "\xa0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlexRow, {
                            style: accepted_payment_fullWidth,
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        display: displaying_Displaying.flex,
                                        alignItems: alignment_Alignment.center
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InnerLabel, {
                                        className: "inner-label",
                                        label: label,
                                        icon: labelIcon
                                    })
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                        style: {
                                            borderBottom: CommonBorder
                                        },
                                        children: "\xa0"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: accepted_payment_fullWidth,
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightRadiusStyle, {
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(accepted_payment_BoxWrapper, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Visa, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Amex, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MasterCard, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Maestro, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Paypal, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ApplePay, {
                            fontSize: largeFontSize
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Bancomat, {
                            fontSize: largeFontSize
                        })
                    ]
                })
            ]
        })
    });
}
const SMALL_ICON_FONT_SIZE = Spacing["1000"];
const icon_button_IconButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, isLoading = false, color, disabled, variant = "default", size, ...otherProps }, ref) {
    const isPurpleLightColor = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "purpleLight" === color;
    }, [
        color
    ]);
    const isButtonLoadingOrDisabled = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return isLoading || disabled;
    }, [
        isLoading,
        disabled
    ]);
    const isSmallIconVariant = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "small-icon" === variant;
    }, [
        variant
    ]);
    const buttonStyles = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const purpleLightStyles = isPurpleLightColor ? {
            color: PurpleLight.contrastText,
            ...!isButtonLoadingOrDisabled && {
                backgroundColor: PurpleLight.main,
                "&:hover": {
                    backgroundColor: `${PurpleLight.dark} !important`
                },
                "& .MuiTouchRipple-child": {
                    backgroundColor: `${PurpleLight.contrastText} !important`
                }
            }
        } : {};
        const smallIconStyles = isSmallIconVariant ? {
            width: Spacing["2500"],
            height: Spacing["2500"],
            minWidth: Spacing["2500"],
            minHeight: Spacing["2500"],
            "& .MuiSvgIcon-root": {
                fontSize: SMALL_ICON_FONT_SIZE
            }
        } : {};
        return {
            ...purpleLightStyles,
            ...smallIconStyles
        };
    }, [
        isPurpleLightColor,
        isButtonLoadingOrDisabled,
        isSmallIconVariant
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
        disabled: isButtonLoadingOrDisabled,
        ref: ref,
        color: isPurpleLightColor ? "inherit" : color,
        size: isSmallIconVariant ? "medium" : size,
        sx: buttonStyles,
        ...otherProps,
        children: isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
            color: "inherit",
            size: Spacing["1000"]
        }) : children
    });
});
var mui_class_collection_MuiClassCollection = /*#__PURE__*/ function(MuiClassCollection) {
    MuiClassCollection["disabled"] = "Mui-disabled";
    MuiClassCollection["selected"] = "Mui-selected";
    MuiClassCollection["hovered"] = "Mui-hovered";
    MuiClassCollection["expanded"] = "Mui-expanded";
    MuiClassCollection["readOnly"] = "Mui-readOnly";
    return MuiClassCollection;
}({});
const DEFAULT_FONT_FAMILY = "DM Sans";
var typography_FontSize = /*#__PURE__*/ function(FontSize) {
    FontSize["xs"] = "0.75rem";
    FontSize["sm"] = "0.875rem";
    FontSize["normal"] = "1rem";
    FontSize["lg"] = "1.25rem";
    FontSize["xl"] = "1.5rem";
    FontSize["2xl"] = "2.125rem";
    FontSize["3xl"] = "3rem";
    FontSize["4xl"] = "3.75rem";
    FontSize["5xl"] = "6rem";
    return FontSize;
}({});
var typography_FontWeight = /*#__PURE__*/ function(FontWeight) {
    FontWeight[FontWeight["normal"] = 400] = "normal";
    FontWeight[FontWeight["medium"] = 500] = "medium";
    FontWeight[FontWeight["bold"] = 700] = "bold";
    return FontWeight;
}({});
var typography_LineHeight = /*#__PURE__*/ function(LineHeight) {
    LineHeight[LineHeight["3xs"] = 1.17] = "3xs";
    LineHeight[LineHeight["2xs"] = 1.2] = "2xs";
    LineHeight[LineHeight["xs"] = 1.24] = "xs";
    LineHeight[LineHeight["sm"] = 1.33] = "sm";
    LineHeight[LineHeight["md"] = 1.5] = "md";
    LineHeight[LineHeight["lg"] = 1.57] = "lg";
    LineHeight[LineHeight["xl"] = 1.6] = "xl";
    LineHeight[LineHeight["2xl"] = 1.66] = "2xl";
    LineHeight[LineHeight["3xl"] = 1.75] = "3xl";
    LineHeight[LineHeight["4xl"] = 2.66] = "4xl";
    return LineHeight;
}({});
var typography_LetterSpacing = /*#__PURE__*/ function(LetterSpacing) {
    LetterSpacing["tighter"] = "-0.0938rem";
    LetterSpacing["tight"] = "-0.0313rem";
    LetterSpacing["normal"] = "0rem";
    LetterSpacing["wide"] = "0.0011rem";
    LetterSpacing["wider"] = "0.025rem";
    LetterSpacing["widerMedium"] = "0.029rem";
    LetterSpacing["widerPlus"] = "0.0625rem";
    LetterSpacing["widest"] = "0.0094rem";
    return LetterSpacing;
}({});
const typography = {
    fontFamily: [
        DEFAULT_FONT_FAMILY,
        "Open Sans",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"'
    ].join(","),
    allVariants: {
        fontFamily: DEFAULT_FONT_FAMILY
    },
    h1: {
        fontSize: "6rem",
        fontWeight: 500,
        lineHeight: 1.17,
        letterSpacing: "-0.0938rem"
    },
    h2: {
        fontSize: "3.75rem",
        fontWeight: 500,
        lineHeight: 1.2,
        letterSpacing: "-0.0313rem"
    },
    h3: {
        fontSize: "3rem",
        fontWeight: 500,
        lineHeight: 1.17,
        letterSpacing: "0rem"
    },
    h4: {
        fontSize: "2.125rem",
        fontWeight: 700,
        lineHeight: 1.24,
        letterSpacing: "0rem"
    },
    h5: {
        fontSize: "1.5rem",
        fontWeight: 700,
        lineHeight: 1.33,
        letterSpacing: "0rem"
    },
    h6: {
        fontSize: "1.25rem",
        fontWeight: 700,
        lineHeight: 1.6,
        letterSpacing: "0rem"
    },
    subtitle1: {
        fontSize: "1rem",
        fontWeight: 700,
        lineHeight: 1.75,
        letterSpacing: "0.0094rem"
    },
    subtitle2: {
        fontSize: "0.875rem",
        fontWeight: 700,
        lineHeight: 1.57,
        letterSpacing: "0.0094rem"
    },
    body1: {
        fontSize: "1rem",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.0094rem"
    },
    body2: {
        fontSize: "0.875rem",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.0011rem"
    },
    overline: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 2.66,
        letterSpacing: "0.0625rem"
    },
    caption: {
        fontSize: "0.75rem",
        fontWeight: 400,
        lineHeight: 1.66,
        letterSpacing: "0.025rem"
    },
    button: {
        fontWeight: 500,
        textTransform: "none"
    }
};
const accordionStyleOverrides = {
    root: {
        fontSize: typography_FontSize.xs,
        fontWeight: typography_FontWeight.medium,
        letterSpacing: typography_LetterSpacing.widerMedium,
        boxShadow: "none",
        border: `1px solid ${Action.focus}`,
        borderRadius: `${Spacing["750"]} !important`,
        ":hover": {
            borderColor: Border.dark
        },
        ":before": {
            content: "none"
        }
    }
};
const accordionSummaryStyleOverrides = {
    root: {
        display: displaying_Displaying.flex,
        padding: Spacing["0"],
        ".MuiAccordionSummary-content": {
            display: displaying_Displaying.flex,
            flexDirection: direction_Direction.row,
            gap: `0 ${Spacing["500"]}`,
            margin: 0,
            alignItems: alignment_Alignment.center,
            wordBreak: "break-all"
        },
        ".MuiTypography-root": {
            lineHeight: Spacing["1500"],
            display: displaying_Displaying.flex
        },
        "#accordion-icon": {
            paddingLeft: 0
        }
    }
};
const accordionDetailsStyleOverrides = {
    root: {
        paddingBottom: Spacing["1500"]
    }
};
const TYPOGRAPHY_SUCCESS_COLOR = "#1E4620";
const TYPOGRAPHY_ERROR_COLOR = "#5F2120";
const TYPOGRAPHY_WARNING_COLOR = "#663C00";
const SUCCESS_SHADE_COLOR = "#EDF7ED";
const ERROR_SHADE_COLOR = "#FDEDED";
const WARNING_SHADE_COLOR = "#FFF4E5";
const INFO_SHADE_COLOR = "#F1F4FC";
const alertStylesOverride = {
    root: {
        width: "100%",
        padding: `${Spacing["500"]} ${Spacing["1000"]}`
    },
    filledWarning: {
        color: Common.white.main
    },
    filledInfo: {
        color: Common.white.main,
        backgroundColor: Primary.main
    },
    standardSuccess: {
        backgroundColor: SUCCESS_SHADE_COLOR,
        color: TYPOGRAPHY_SUCCESS_COLOR
    },
    standardError: {
        backgroundColor: ERROR_SHADE_COLOR,
        color: TYPOGRAPHY_ERROR_COLOR
    },
    standardWarning: {
        backgroundColor: WARNING_SHADE_COLOR,
        color: TYPOGRAPHY_WARNING_COLOR
    },
    standardInfo: {
        backgroundColor: INFO_SHADE_COLOR,
        color: Primary.dark,
        "& .MuiAlert-icon": {
            color: Primary.dark
        }
    },
    outlinedSuccess: {
        borderColor: Success.main,
        color: TYPOGRAPHY_SUCCESS_COLOR
    },
    outlinedError: {
        borderColor: ErrorToken.main,
        color: TYPOGRAPHY_ERROR_COLOR
    },
    outlinedWarning: {
        borderColor: Warning.main,
        color: TYPOGRAPHY_WARNING_COLOR
    },
    outlinedInfo: {
        borderColor: Primary.main,
        color: Primary.dark,
        "& .MuiAlert-icon": {
            color: Primary.dark
        }
    },
    icon: {
        alignItems: alignment_Alignment.center
    },
    message: {
        ...typography.body2
    }
};
const alertDefaultProps = {
    iconMapping: {
        success: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {
            fontSize: "inherit"
        }),
        info: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BookTextSolid, {
            fontSize: "inherit"
        }),
        error: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ExclamationCircleOutlined, {
            fontSize: "inherit"
        }),
        warning: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TriangleExclamationOutlined, {
            fontSize: "inherit"
        })
    }
};
const alertTitleStylesOverride = {
    root: {
        marginBottom: Spacing["0"],
        fontWeight: typography_FontWeight.medium
    }
};
const badgeStylesOverride = {
    colorSecondary: {
        color: Common.white.main
    }
};
var cursor_style_CursorStyle = /*#__PURE__*/ function(CursorStyle) {
    CursorStyle["pointer"] = "pointer";
    CursorStyle["notAllowed"] = "not-allowed";
    CursorStyle["default"] = "default";
    return CursorStyle;
}({});
const styles_tealDuskStyle = tealDusk.getButtonStylesOverride();
const styles_pinkHazeStyle = pinkHaze.getButtonStylesOverride();
const styles_goldenUmberStyle = goldenUmber.getButtonStylesOverride();
const buttonStyleOverrides = {
    root: function({ ownerState }) {
        return {
            ...styles_buttonStyles[ownerState.size || "medium"],
            [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                pointerEvents: "initial",
                cursor: cursor_style_CursorStyle.notAllowed
            },
            ..."white" === ownerState.color && {
                color: White.main,
                backgroundColor: TRANSPARENT_COLOR,
                ..."contained" === ownerState.variant && {
                    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                        backgroundColor: TRANSPARENT_COLOR,
                        pointerEvents: "initial",
                        cursor: cursor_style_CursorStyle.notAllowed
                    }
                },
                ..."outlined" === ownerState.variant && {
                    borderColor: TRANSPARENT_COLOR,
                    [`&:hover,&:active,&:focus,&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                        borderColor: TRANSPARENT_COLOR
                    }
                }
            },
            ...styles_tealDuskStyle,
            ...styles_pinkHazeStyle,
            ...styles_goldenUmberStyle
        };
    },
    startIcon: {
        marginLeft: Spacing["0"]
    },
    endIcon: {
        marginRight: Spacing["0"]
    }
};
const styles_buttonStyles = {
    large: {
        padding: `${Spacing["500"]} ${Spacing["1000"]}`,
        lineHeight: typography_LineHeight.xl,
        letterSpacing: typography_LetterSpacing.widerMedium,
        minWidth: Spacing["5000"],
        minHeight: Spacing["3000"]
    },
    medium: {
        padding: `${Spacing["500"]} ${Spacing["750"]}`,
        lineHeight: typography_LineHeight.md,
        letterSpacing: typography_LetterSpacing.wider,
        minWidth: Spacing["4000"],
        minHeight: Spacing["2500"]
    },
    small: {
        padding: `${Spacing["250"]} ${Spacing["500"]}`,
        lineHeight: typography_LineHeight.sm,
        letterSpacing: typography_LetterSpacing.widerMedium,
        minWidth: Spacing["3500"],
        minHeight: Spacing["2000"]
    }
};
const checkboxStylesOverride = {
    root: {
        padding: Spacing["500"],
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    }
};
const CHIP_SMALL_DELETE_ICON_SIZE = "0.833rem";
const chip_styles_tealDuskStyle = tealDusk.getButtonStylesOverride();
const chip_styles_pinkHazeStyle = pinkHaze.getButtonStylesOverride();
const chip_styles_goldenUmberStyle = goldenUmber.getButtonStylesOverride();
const chipStyleOverrides = {
    root: {
        padding: `${Spacing["750"]} ${Spacing["1000"]}`,
        gap: Spacing["250"],
        fontSize: typography_FontSize.xs,
        fontWeight: typography_FontWeight.bold,
        letterSpacing: typography_LetterSpacing.widerMedium,
        ...chip_styles_tealDuskStyle,
        ...chip_styles_pinkHazeStyle,
        ...chip_styles_goldenUmberStyle
    },
    icon: {
        marginLeft: Spacing["0"],
        marginRight: Spacing["0"]
    },
    deleteIcon: {
        height: Spacing["1500"],
        width: Spacing["1500"],
        marginLeft: Spacing["0"],
        marginRight: Spacing["0"],
        "&.MuiChip-deleteIconSmall": {
            width: CHIP_SMALL_DELETE_ICON_SIZE,
            height: CHIP_SMALL_DELETE_ICON_SIZE
        }
    },
    label: {
        paddingLeft: Spacing["0"],
        paddingRight: Spacing["0"]
    }
};
const dialogActionsStylesOverrides = {
    root: {
        padding: Spacing["0"]
    }
};
const dialogContentStylesOverrides = {
    root: {
        padding: Spacing["0"],
        textAlign: "initial"
    }
};
const dialogTitleStylesOverrides = {
    root: {
        padding: Spacing["0"]
    }
};
const EXTRA_SMALL_DIALOG_MAX_WIDTH = 328;
const SMALL_DIALOG_MAX_WIDTH = 512;
const dialogStyleOverrides = {
    root: {
        ".MuiPaper-root": {
            padding: Spacing["1500"],
            border: `1px solid ${DIVIDER_COLOR}`
        },
        ".align-end": {
            width: "100%"
        },
        ".align-center": {
            width: "100%",
            margin: "0 auto"
        },
        ".inner-icon > .MuiSvgIcon-root": {
            width: Spacing["3000"],
            height: Spacing["3000"]
        }
    },
    paperWidthXs: {
        maxWidth: EXTRA_SMALL_DIALOG_MAX_WIDTH
    },
    paperWidthSm: {
        maxWidth: SMALL_DIALOG_MAX_WIDTH
    }
};
const iconButtonStyleOverrides = {
    root: {
        padding: Spacing["500"],
        "& .MuiSvgIcon-root": {
            fontSize: "inherit"
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: cursor_style_CursorStyle.notAllowed
        }
    },
    sizeSmall: {
        fontSize: Spacing["1000"]
    },
    sizeMedium: {
        fontSize: Spacing["1500"]
    },
    sizeLarge: {
        fontSize: Spacing["2000"]
    }
};
const inputStyleOverrides = {
    root: {
        ".MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border.main
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border.dark
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled} .MuiOutlinedInput-notchedOutline, &.${mui_class_collection_MuiClassCollection.disabled}:hover .MuiOutlinedInput-notchedOutline`]: {
            borderColor: palette.border.light
        }
    }
};
const DASH_DOT_WIDTH = 0.625;
const DASH_DOT_HEIGHT = 0.66875;
const linearProgressStylesOverride = {
    root: {
        height: Spacing["500"]
    },
    dashed: {
        backgroundSize: `${DASH_DOT_WIDTH}rem ${DASH_DOT_HEIGHT}rem`
    },
    colorSecondary: {
        background: Secondary.light
    }
};
const menuItemStylesOverrides = {
    root: {
        whiteSpace: "initial"
    }
};
const paperStyleOverrides = {
    root: {}
};
const radioStylesOverride = {
    root: {
        padding: Spacing["500"],
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            pointerEvents: "initial",
            cursor: "not-allowed",
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    }
};
const LIST_ITEM_LIGHT_DARK_BACKGROUND_COLOR = "rgba(0, 0, 0, 0.04)";
const listItemButtonOverrides = {
    root: {
        borderRadius: BorderRadius.brand,
        [`&.${mui_class_collection_MuiClassCollection.selected}, &.${mui_class_collection_MuiClassCollection.selected}:hover`]: {
            backgroundColor: LIST_ITEM_LIGHT_DARK_BACKGROUND_COLOR,
            color: Primary.main
        }
    }
};
const switchStylesOverride = {
    root: {
        "& .MuiSwitch-switchBase": {
            [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
                pointerEvents: "initial",
                cursor: "not-allowed",
                "&:hover": {
                    backgroundColor: "initial"
                }
            }
        }
    }
};
const textFieldStyleOverrides = {
    root: {
        fontFamily: DEFAULT_FONT_FAMILY,
        color: palette.text?.secondary,
        "& .MuiOutlinedInput-root": {
            borderRadius: Spacing["500"],
            backgroundColor: Common.white.main,
            "&:has([readonly])": {
                backgroundColor: palette.action?.selected,
                cursor: cursor_style_CursorStyle.notAllowed
            },
            "&.blocked": {
                backgroundColor: Primary.light,
                color: Primary.main,
                "& fieldset": {
                    borderColor: Primary.main
                }
            },
            "&:has(.adornment-start)": {
                paddingLeft: 0
            },
            "&:has(.adornment-end)": {
                paddingRight: 0
            },
            "&.MuiInputBase-multiline": {
                backgroundColor: Common.white.main
            }
        },
        [`& .${mui_class_collection_MuiClassCollection.disabled}, & .${mui_class_collection_MuiClassCollection.readOnly}`]: {
            cursor: cursor_style_CursorStyle.notAllowed
        },
        "&.MuiTextField-sizeMedium": {
            "& .MuiInputBase-input": {
                padding: `${Spacing["1000"]} ${Spacing["750"]}`
            }
        },
        "&.MuiTextField-sizeSmall": {
            "& .MuiInputBase-input": {
                padding: `${Spacing["500"]} ${Spacing["750"]}`
            }
        },
        "& .adornment": {
            backgroundColor: palette.background?.default,
            "&.MuiInputAdornment-positionEnd": {
                borderTopRightRadius: Spacing["500"],
                borderBottomRightRadius: Spacing["500"]
            },
            "&.MuiInputAdornment-positionStart": {
                borderTopLeftRadius: Spacing["500"],
                borderBottomLeftRadius: Spacing["500"]
            },
            "&.small": {
                paddingBottom: Spacing["1250"],
                paddingTop: Spacing["1250"],
                paddingRight: Spacing["750"],
                paddingLeft: Spacing["750"]
            },
            "&.medium": {
                paddingBottom: Spacing["1750"],
                paddingTop: Spacing["1750"],
                paddingRight: Spacing["1000"],
                paddingLeft: Spacing["1000"]
            }
        }
    }
};
const commonStyle = {
    padding: `${Spacing["250"]} ${Spacing["1000"]}`,
    background: Common.dark.main
};
const toolTipStyleOverrides = {
    tooltipArrow: {
        ...commonStyle
    },
    tooltip: {
        ...commonStyle
    },
    arrow: {
        color: Common.dark.main
    }
};
const theme_theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.createTheme)({
    palette: palette,
    typography: typography,
    spacing: 4,
    shape: {
        borderRadius: 8
    },
    components: {
        MuiButton: {
            styleOverrides: buttonStyleOverrides
        },
        MuiOutlinedInput: {
            styleOverrides: inputStyleOverrides
        },
        MuiListItemButton: {
            styleOverrides: listItemButtonOverrides
        },
        MuiChip: {
            styleOverrides: chipStyleOverrides
        },
        MuiPaper: {
            styleOverrides: paperStyleOverrides
        },
        MuiAlert: {
            styleOverrides: alertStylesOverride,
            defaultProps: alertDefaultProps
        },
        MuiAlertTitle: {
            styleOverrides: alertTitleStylesOverride
        },
        MuiAccordion: {
            styleOverrides: accordionStyleOverrides
        },
        MuiAccordionSummary: {
            styleOverrides: accordionSummaryStyleOverrides
        },
        MuiAccordionDetails: {
            styleOverrides: accordionDetailsStyleOverrides
        },
        MuiIconButton: {
            styleOverrides: iconButtonStyleOverrides
        },
        MuiCheckbox: {
            styleOverrides: checkboxStylesOverride
        },
        MuiSwitch: {
            styleOverrides: switchStylesOverride
        },
        MuiRadio: {
            styleOverrides: radioStylesOverride
        },
        MuiDialog: {
            styleOverrides: dialogStyleOverrides
        },
        MuiDialogTitle: {
            styleOverrides: dialogTitleStylesOverrides
        },
        MuiDialogContent: {
            styleOverrides: dialogContentStylesOverrides
        },
        MuiDialogActions: {
            styleOverrides: dialogActionsStylesOverrides
        },
        MuiTextField: {
            styleOverrides: textFieldStyleOverrides
        },
        MuiTooltip: {
            styleOverrides: toolTipStyleOverrides
        },
        MuiLinearProgress: {
            styleOverrides: linearProgressStylesOverride
        },
        MuiMenuItem: {
            styleOverrides: menuItemStylesOverrides
        },
        MuiBadge: {
            styleOverrides: badgeStylesOverride
        }
    }
});
const INVALD_PROPS = [
    "color",
    "active",
    "isActive",
    "shouldBeExpandable",
    "isMobile",
    "collapsed",
    "isSelected",
    "elevated",
    "disablepadding",
    "variant",
    "turnBorderColor",
    "turn",
    "maxWidth",
    "gap",
    "accentColor",
    "isSmall"
];
function isStyledValidProp(prop) {
    const includeProp = INVALD_PROPS.includes(prop);
    return !includeProp;
}
const styledOptions = {
    shouldForwardProp: isStyledValidProp
};
function dontForwardTheseProps(keys) {
    return function(prop) {
        return !keys.includes(prop);
    };
}
const MuiAccordionSummaryContentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.spaceBetween,
    width: "100%",
    alignItems: alignment_Alignment.center
});
const ContainerWithMarginRight = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginRight: Spacing["500"],
    display: displaying_Displaying.inherit,
    alignItems: alignment_Alignment.center
});
const ContainerWithTopSpacing = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginTop: Spacing["250"],
    display: displaying_Displaying.inherit,
    alignItems: alignment_Alignment.center
});
const EndItemsContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ shouldBeExpandable })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        pointerEvents: "auto",
        marginRight: shouldBeExpandable ? Spacing["500"] : Spacing["0"]
    }));
const components_shouldForwardProp = dontForwardTheseProps([
    "isMobile"
]);
const MuiAccordionContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Accordion_4220dc4d__["default"], {
    shouldForwardProp: components_shouldForwardProp
})(({ isMobile })=>({
        padding: isMobile ? `${Spacing["750"]} ${Spacing["1000"]}` : `${Spacing["500"]} ${Spacing["1500"]}`
    }));
const MuiAccordionSummaryContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_AccordionSummary_85088446__["default"], styledOptions)(({ isMobile, shouldBeExpandable })=>({
        pointerEvents: shouldBeExpandable ? displaying_Displaying.initial : displaying_Displaying.none,
        ".MuiAccordionSummary-content": {
            [`&.${mui_class_collection_MuiClassCollection.expanded}`]: {
                margin: isMobile ? `${Spacing["500"]} 0` : displaying_Displaying.inherit
            }
        }
    }));
const AccordionContainerStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(MuiAccordionContainer)({
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        backgroundColor: "transparent",
        cursor: "not-allowed !important",
        "> *": {
            cursor: "not-allowed !important"
        }
    }
});
function Accordion(props) {
    const { title, isMobile, subtitle, startIcon, endAction, endChip, iconButtonId, accordionDetailsProps, children, ...muiAccordionProps } = props;
    const flexDirection = isMobile ? direction_Direction.column : direction_Direction.row;
    const shouldBeExpandable = void 0 === endAction;
    const secondaryTypographyVariant = isMobile ? theme_theme.typography.body2 : theme_theme.typography.body1;
    const subtitleElement = "string" == typeof subtitle ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        sx: {
            ...secondaryTypographyVariant,
            marginLeft: isMobile ? Spacing["0"] : Spacing["500"]
        },
        children: subtitle
    }) : subtitle;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AccordionContainerStyled, {
        "data-testid": muiAccordionProps.id,
        isMobile: isMobile,
        square: false,
        ...muiAccordionProps,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(MuiAccordionSummaryContainer, {
                expandIcon: shouldBeExpandable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    id: iconButtonId || "accordion-icon-id",
                    color: "default",
                    size: "medium",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleDownSmallOutlined, {})
                }),
                "aria-controls": "accordion-content",
                id: muiAccordionProps.id,
                isMobile: isMobile,
                shouldBeExpandable: shouldBeExpandable,
                children: [
                    startIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithMarginRight, {
                        children: startIcon
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(MuiAccordionSummaryContentContainer, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                style: {
                                    display: "inherit",
                                    flexDirection
                                },
                                children: [
                                    title,
                                    subtitle ? subtitleElement : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                                    isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithTopSpacing, {
                                        children: endChip
                                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(EndItemsContainer, {
                                shouldBeExpandable: shouldBeExpandable,
                                children: [
                                    isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ContainerWithMarginRight, {
                                        children: endChip
                                    }),
                                    endAction
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_AccordionDetails_d2db12ca__["default"], {
                ...accordionDetailsProps,
                children: children
            })
        ]
    });
}
const StyledVerticalAlert = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__["default"])({
    "& .MuiAlert-message": {
        width: "100%"
    }
});
const StyledActionContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    width: "100%",
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.end,
    marginTop: Spacing["750"]
});
const StyledChildrenContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.start,
    alignItems: alignment_Alignment.center,
    gap: Spacing["750"]
});
const DEFAULT_ICON_SIZE = 22;
const vertical_alert_VerticalAlert = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, action, icon, severity, ...rest }, ref) {
    const displayedIcon = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (icon) return icon;
        if (!severity) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
        const severityAsIconIndex = severity;
        const severityIcon = alertDefaultProps.iconMapping ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
            className: "MuiAlert-icon",
            fontSize: DEFAULT_ICON_SIZE,
            display: displaying_Displaying.flex,
            children: alertDefaultProps.iconMapping[severityAsIconIndex]
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
        return severityIcon;
    }, [
        severity,
        icon
    ]);
    const displayedContent = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (!children) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledChildrenContainer, {
            children: displayedIcon
        });
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(StyledChildrenContainer, {
            children: [
                displayedIcon,
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                    children: children
                })
            ]
        });
    }, [
        children,
        displayedIcon
    ]);
    const displayedAction = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (action) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledActionContainer, {
            children: action
        });
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    }, [
        action
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(StyledVerticalAlert, {
        ...rest,
        ref: ref,
        icon: false,
        severity: severity,
        children: [
            displayedContent,
            displayedAction
        ]
    });
});
const alert_Alert = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, vertical = false, ...rest }, ref) {
    if (vertical) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(vertical_alert_VerticalAlert, {
        ...rest,
        ref: ref,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Alert_759df34a__["default"], {
        ...rest,
        ref: ref,
        children: children
    });
});
const STORYBOOK_LARGE_MOBILE_WIDTH = 414;
function useIsMobile() {
    const isMobileMediaQuery = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useMediaQuery)(`@media only screen and (max-width:${STORYBOOK_LARGE_MOBILE_WIDTH}px)`);
    const codeRunningInStorybook = window?.IS_STORYBOOK ?? false;
    if (codeRunningInStorybook) return isMobileMediaQuery;
    return __WEBPACK_EXTERNAL_MODULE_react_device_detect_2985bda2__.isMobile;
}
const use_is_mobile = useIsMobile;
const APP_BAR_HEIGHT_DESKTOP = Spacing["4750"];
const APP_BAR_HEIGHT_MOBILE = Spacing["4000"];
const app_bar_AppBar = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    const isMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_AppBar_72083ef1__["default"], {
        ref: ref,
        color: "transparent",
        sx: {
            backgroundColor: theme_theme.palette.background.paper,
            zIndex: 10
        },
        elevation: 0,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Toolbar, {
            isMobile: isMobile,
            children: children
        })
    });
});
const app_bar_shouldForwardProp = dontForwardTheseProps([
    "isMobile"
]);
const Toolbar = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Toolbar_089287ec__["default"], {
    shouldForwardProp: app_bar_shouldForwardProp
})(({ isMobile, theme })=>({
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.spaceBetween,
        borderBottom: `1px solid ${Border.main}`,
        gap: isMobile ? Spacing["0"] : Spacing["1500"],
        padding: isMobile ? Spacing["750"] : `${Spacing["1000"]} ${Spacing["3000"]}`,
        minHeight: `${isMobile ? APP_BAR_HEIGHT_MOBILE : APP_BAR_HEIGHT_DESKTOP}!important`,
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(12),
            paddingRight: theme.spacing(12)
        }
    }));
const ChipStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Chip_305fde45__["default"])(({ color, variant })=>{
    const isVariantOutlined = "outlined" === variant;
    const needsTextColorAdjustment = [
        "secondary",
        "info"
    ].includes(color ?? "");
    if (isVariantOutlined && needsTextColorAdjustment) return {
        color: theme_theme.palette.text.primary
    };
});
const chip_Chip = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ChipStyled, {
        ref: ref,
        ...rest,
        children: children
    });
});
function Autocomplete({ multiple, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Autocomplete_7a50a8f5__["default"], {
        multiple: multiple,
        popupIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleDownSmallOutlined, {}),
        disableCloseOnSelect: multiple,
        renderTags: function(tags, getTagProps) {
            return tags.map(function(option, index) {
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_Chip, {
                    variant: "filled",
                    size: "small",
                    label: option,
                    color: "default",
                    ...getTagProps({
                        index
                    })
                });
            });
        },
        ...rest
    });
}
function AutocompleteTextField({ ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"], {
        ...rest
    });
}
const PROGRESS_BAR_COMPLETED_COLOR = "#00BB8C";
const PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR = "#FFECF2";
const PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR = "#DD4C77";
function getProgressBarFillColor(isCompleted) {
    return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_FILL_COLOR;
}
function getProgressBarStrokeColor(isCompleted) {
    return isCompleted ? PROGRESS_BAR_COMPLETED_COLOR : PROGRESS_BAR_NOT_COMPLETED_STROKE_COLOR;
}
function AvatarProgressBar({ numberBarCompleted }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        width: "84",
        height: "64",
        viewBox: "0 0 84 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M7.5314 28.5035C6.515 28.1224 5.99525 26.9905 6.4226 25.9972C9.15995 19.5985 13.549 14.0545 19.1392 9.90802C20.0054 9.26122 21.2297 9.51532 21.8303 10.4162C22.4309 11.3171 22.1884 12.5299 21.3106 13.1882C16.4018 16.8611 12.5441 21.7468 10.0955 27.3716C9.66815 28.3649 8.53625 28.8847 7.51985 28.5151L7.5314 28.5035Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 2)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.38621 27.3583C6.39077 27.3707 6.39547 27.3831 6.40029 27.3955C6.58814 27.8761 6.97354 28.2819 7.49382 28.489C7.50416 28.4931 7.51456 28.4971 7.52501 28.5011C7.52716 28.5019 7.52932 28.5027 7.53148 28.5035L7.51993 28.5151C7.52204 28.5158 7.52416 28.5166 7.52628 28.5174C7.53605 28.5209 7.54584 28.5243 7.55563 28.5277C8.23927 28.7617 8.97059 28.5977 9.50194 28.161C9.75332 27.9545 9.95993 27.6869 10.0956 27.3716C12.5442 21.7468 16.4019 16.8611 21.3106 13.1882C22.1884 12.5299 22.431 11.3171 21.8304 10.4162C21.2298 9.51533 20.0055 9.26123 19.1392 9.90803C13.549 14.0545 9.16003 19.5985 6.42268 25.9972C6.22778 26.4502 6.22987 26.932 6.38621 27.3583ZM4.58468 25.2087C3.73085 27.196 4.69 29.3618 6.49906 30.235C6.60527 30.298 6.71807 30.3516 6.83644 30.3947C8.89453 31.1431 11.1031 30.0838 11.9307 28.1668C14.2415 22.86 17.8803 18.2528 22.5088 14.7896L22.5106 14.7882C24.1801 13.5361 24.7229 11.1495 23.4945 9.30683C22.3059 7.5239 19.7985 6.92434 17.9477 8.30168C12.0749 12.6578 7.46212 18.4834 4.58468 25.2087Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 2),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M79.4381 38.3499C80.5119 38.2591 81.4734 39.0526 81.5178 40.1421C81.7716 47.0981 80.1704 53.9802 76.89 60.1156C76.3703 61.07 75.169 61.3683 74.2299 60.8175C73.2959 60.2563 73.008 59.0601 73.5069 58.0956C76.3692 52.6813 77.7801 46.6064 77.5895 40.4919C77.5555 39.4075 78.3438 38.4562 79.433 38.3602L79.4381 38.3499Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 5)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.9946 36.3996C79.0845 36.3792 79.1763 36.3649 79.2696 36.357C81.4072 36.1764 83.4225 37.7635 83.516 40.0608L83.5164 40.0692L83.5164 40.0692C83.7831 47.3805 82.1 54.6129 78.6536 61.0587L78.6464 61.0722C77.5549 63.0765 75.0733 63.6309 73.218 62.5427L73.1998 62.5319C71.288 61.3832 70.7869 59.0005 71.7304 57.1767L71.7387 57.1609C74.4393 52.0524 75.7701 46.3211 75.5904 40.5546M78.9946 36.3996C76.9235 36.7171 75.5282 38.5638 75.5904 40.5543ZM81.5177 40.1422C81.4733 39.0526 80.5118 38.2592 79.438 38.3499L79.4329 38.3603C78.3437 38.4563 77.5554 39.4075 77.5894 40.492C77.78 46.6065 76.3691 52.6813 73.5068 58.0956C73.0079 59.0601 73.2958 60.2564 74.2298 60.8175C75.1689 61.3683 76.3702 61.07 76.8899 60.1157C80.1703 53.9802 81.7715 47.0981 81.5177 40.1422Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 5),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M10.1302 60.8897C9.20618 61.4441 7.99343 61.1554 7.47368 60.1967C4.18193 54.0637 2.58803 47.1799 2.83058 40.2268C2.87678 39.1411 3.82388 38.3441 4.90958 38.425C5.99528 38.5174 6.78068 39.4645 6.75758 40.5502C6.57278 46.6717 7.98188 52.747 10.8463 58.1524C11.3545 59.111 11.0657 60.3122 10.1302 60.8782V60.8897Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 1)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.3873 62.4453C11.3156 62.5032 11.2395 62.5565 11.1592 62.6047C9.3197 63.7084 6.81132 63.1712 5.71547 61.1499L5.71145 61.1425L5.71146 61.1425C2.2516 54.6962 0.576982 47.4618 0.8318 40.157L0.832393 40.1417C0.929424 37.8615 2.9131 36.2707 5.05811 36.4305L5.07918 36.4322C7.30148 36.6213 8.80081 38.5397 8.75713 40.5927L8.75667 40.6105C8.58231 46.3862 9.912 52.1178 12.6133 57.2156M11.3873 62.4453C13.1069 61.248 13.5461 58.9755 12.6135 57.2159ZM7.47368 60.1967C7.99343 61.1553 9.20618 61.4441 10.1302 60.8897V60.8781C11.0657 60.3122 11.3545 59.111 10.8463 58.1523C7.98188 52.7469 6.57278 46.6716 6.75758 40.5501C6.78068 39.4644 5.99528 38.5173 4.90958 38.4249C3.82388 38.3441 2.87678 39.141 2.83058 40.2267C2.58803 47.1798 4.18193 54.0636 7.47368 60.1967Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 1),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M30.6249 6.46209C30.2899 5.43414 30.8443 4.31379 31.8954 4.02504C38.6059 2.17704 45.6745 2.15394 52.3966 3.94419C53.4477 4.22139 54.0136 5.33019 53.6787 6.36969C53.3437 7.39764 52.2465 7.96359 51.1954 7.69794C45.2703 6.15024 39.0333 6.18489 33.1197 7.76724C32.0686 8.04444 30.9598 7.49004 30.6249 6.46209Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 3)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.1197 7.76724C32.0687 8.04444 30.9599 7.49004 30.6249 6.46209C30.29 5.43414 30.8444 4.31379 31.8954 4.02504C38.606 2.17704 45.6746 2.15394 52.3967 3.94419C53.4477 4.22139 54.0137 5.33019 53.6787 6.36969C53.3438 7.39764 52.2465 7.96359 51.1955 7.69794C45.2703 6.15024 39.0333 6.18489 33.1197 7.76724ZM52.9114 2.01156C45.8481 0.13044 38.419 0.154303 31.3656 2.0965ZM52.9114 2.01156C55.1382 2.60169 56.246 4.92351 55.5823 6.98308L55.5803 6.98932C54.8997 9.07798 52.7141 10.1447 50.7054 9.63697L50.69 9.63302C45.1036 8.17381 39.219 8.20558 33.6367 9.69927L33.6298 9.70113C31.6346 10.2273 29.4121 9.19552 28.7233 7.08171C28.0589 5.04255 29.1403 2.70857 31.3644 2.09682",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 3),
                fillOpacity: "0.5"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M63.1919 10.4271C63.781 9.52623 65.0053 9.26058 65.8831 9.90738C71.5079 13.9961 75.9431 19.517 78.7382 25.8926C79.1771 26.8859 78.6574 28.0178 77.641 28.4105C76.6246 28.7916 75.4927 28.2834 75.0538 27.2901C72.559 21.6768 68.6551 16.8258 63.7232 13.1876C62.857 12.5523 62.5913 11.3396 63.1919 10.4271Z",
                fill: getProgressBarFillColor(numberBarCompleted >= 4)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.6409 28.4105C76.6245 28.7916 75.4926 28.2834 75.0537 27.2901C72.5589 21.6768 68.655 16.8258 63.7231 13.1876C62.8569 12.5523 62.5912 11.3396 63.1918 10.4271C63.7809 9.52621 65.0052 9.26056 65.883 9.90736C71.5078 13.9961 75.943 19.517 78.7381 25.8926C79.177 26.8859 78.6573 28.0178 77.6409 28.4105ZM67.0634 8.29282C72.9743 12.5907 77.6336 18.3921 80.5698 25.0895C81.503 27.2096 80.3538 29.5064 78.3617 30.2761L78.3431 30.2831C76.2846 31.055 74.0713 30.0123 73.2253 28.1006C70.8719 22.8063 67.1899 18.2309 62.5377 14.7984C60.8752 13.5771 60.2961 11.1917 61.5196 9.33004C62.6945 7.53608 65.2017 6.92636 67.0634 8.29282Z",
                fill: getProgressBarStrokeColor(numberBarCompleted >= 4),
                fillOpacity: "0.5"
            })
        ]
    });
}
const avatar_Avatar = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Avatar_eb4ee1a2__["default"], {
        ref: ref,
        variant: "circular",
        ...rest,
        children: children
    });
});
const AVATAR_STEPPER_SIZE = "3.625rem";
const AVATAR_STEPPER_ICON_SIZE = "4.375rem";
const AVATAR_STEPPER_BADGE_ICON_SIZE = "0.469rem";
function AvatarStepper({ numberBarCompleted, id, avatarProps, label, handleProfileImageUpdate, children }) {
    const { getRootProps, getInputProps } = (0, __WEBPACK_EXTERNAL_MODULE_react_dropzone_e9959fec__.useDropzone)({
        onDrop: handleProfileImageUpdate,
        maxFiles: 1,
        accept: {
            "image/*": []
        }
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AvatarStepperContainer, {
        id: id,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                position: positioning_Positioning.relative,
                display: displaying_Displaying.flex,
                alignItems: alignment_Alignment.center,
                justifyContent: alignment_Alignment.center,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AvatarProgressBar, {
                        numberBarCompleted: numberBarCompleted
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AvatarContainer, {
                        ...getRootProps(),
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                                ...getInputProps()
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledBadge, {
                                overlap: "circular",
                                badgeContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.PenSolid, {}),
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledAvatar, {
                                    ...avatarProps,
                                    children: children
                                })
                            })
                        ]
                    })
                ]
            }),
            label
        ]
    });
}
const StyledBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])(({ theme })=>({
        ".MuiBadge-overlapCircular": {
            border: `1px solid ${theme.palette.primary.main}`,
            height: theme.spacing(3),
            width: theme.spacing(3),
            minWidth: theme.spacing(3),
            padding: theme.spacing(0),
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.common.white
        },
        ".MuiSvgIcon-root": {
            width: AVATAR_STEPPER_BADGE_ICON_SIZE,
            height: AVATAR_STEPPER_BADGE_ICON_SIZE
        }
    }));
const StyledAvatar = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(avatar_Avatar)(({ theme })=>({
        width: AVATAR_STEPPER_SIZE,
        height: AVATAR_STEPPER_SIZE,
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        ".MuiSvgIcon-root": {
            width: AVATAR_STEPPER_ICON_SIZE,
            height: AVATAR_STEPPER_ICON_SIZE
        },
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    }));
const AvatarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ theme })=>({
        position: positioning_Positioning.absolute,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingTop: theme.spacing(2),
        height: AVATAR_STEPPER_SIZE,
        width: AVATAR_STEPPER_SIZE
    }));
const AvatarStepperContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ theme })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.center,
        gap: theme.spacing(3)
    }));
const MUI_BADGE_CLASS = "MuiBadge-badge";
const SmallBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])({
    [`& .${MUI_BADGE_CLASS}`]: {
        height: Spacing["1000"],
        padding: `${Spacing["0"]} 0.375rem`,
        minWidth: "auto"
    }
});
const MediumBadge = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"])({
    [`& .${MUI_BADGE_CLASS}`]: {
        padding: `${Spacing["0"]} 0.40625rem`
    }
});
const BADGE_MAX_VALUE = 99;
const badge_Badge = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, size, ...rest }, ref) {
    const badgeProps = {
        ref,
        max: BADGE_MAX_VALUE,
        ...rest
    };
    if ("dot" === rest.variant) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Badge_7b9e8682__["default"], {
        ...badgeProps,
        children: children
    });
    if ("small" === size) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SmallBadge, {
        ...badgeProps,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MediumBadge, {
        ...badgeProps,
        children: children
    });
});
var border_style_BorderStyle = /*#__PURE__*/ function(BorderStyle) {
    BorderStyle["solid"] = "solid";
    BorderStyle["dashed"] = "dashed";
    return BorderStyle;
}({});
const BlockNoticeContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    borderWidth: 1,
    borderStyle: border_style_BorderStyle.solid,
    borderRadius: BorderRadius.paper,
    overflow: "hidden",
    "&.primary": {
        borderColor: theme_theme.palette.primary.main
    },
    "&.warning": {
        borderColor: theme_theme.palette.warning.main
    }
});
const BlockNoticeIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
});
const BlockNoticeTitleContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: Spacing["500"],
        padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["1500"]}`,
        borderBottomLeftRadius: BorderRadius.brand,
        borderBottomRightRadius: BorderRadius.brand,
        "&.primary.high": {
            background: theme_theme.palette.primary.main,
            color: theme_theme.palette.primary.contrastText
        },
        "&.primary.light": {
            background: theme_theme.palette.primary.light,
            color: theme_theme.palette.primary.dark
        },
        "&.warning.high": {
            background: theme_theme.palette.warning.main,
            color: theme_theme.palette.warning.contrastText
        },
        "&.warning.light": {
            background: theme_theme.palette.warning.light,
            color: theme_theme.palette.warning.dark
        }
    }));
const BlockNoticeBodyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isMobile })=>({
        padding: isMobile ? Spacing["1000"] : `${Spacing["1000"]} ${Spacing["2500"]}`,
        backgroundColor: Background.paper
    }));
function BlockNotice({ title, body, color, contrast, icon, id, isMobile }) {
    const className = `${color} ${contrast}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BlockNoticeContainer, {
        id: id,
        className: className,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BlockNoticeTitleContainer, {
                isMobile: isMobile,
                className: className,
                "data-testid": "block-notice-title-container",
                children: [
                    icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlockNoticeIconContainer, {
                        children: icon
                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlockNoticeBodyContainer, {
                isMobile: isMobile,
                children: body
            })
        ]
    });
}
function NavigationListItemCollapsible({ label, icon, children, selected, disabled }) {
    const [isCollapsedMenuOpen, setIsCollapsedMenuOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const endIcon = isCollapsedMenuOpen ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleUpSmallOutlined, {
        color: "action"
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleDownSmallOutlined, {
        color: "action"
    });
    function handleToggleCollapsedMenu() {
        setIsCollapsedMenuOpen((prevOpen)=>!prevOpen);
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
                onClick: handleToggleCollapsedMenu,
                selected: selected,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                        sx: {
                            minWidth: Spacing["3000"]
                        },
                        children: icon
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                        primary: label
                    }),
                    endIcon
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Collapse_1f7ec3cf__["default"], {
                in: isCollapsedMenuOpen,
                timeout: "auto",
                unmountOnExit: true,
                children: children
            })
        ]
    });
}
function NavigationListItem({ label, selected, onClickRoute, path, icon, iconSelected, disabled, isSectionDivider, isNestedItem }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
        sx: {
            padding: `${isNestedItem ? Spacing["250"] : Spacing["500"]} ${Spacing["1000"]}`
        },
        onClick: ()=>onClickRoute?.(path),
        selected: selected,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemIcon_69bbaed8__["default"], {
                sx: {
                    color: selected ? Common.white.main : Action.active,
                    minWidth: Spacing["3000"]
                },
                children: selected ? iconSelected : icon
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                primary: label,
                primaryTypographyProps: isSectionDivider || isNestedItem ? {
                    variant: "body2"
                } : void 0
            })
        ]
    });
}
const NestedNavigation = function({ navigationItems }) {
    function renderNavigationItems(items, isParent = false) {
        return items.map(function(item) {
            const isNestedItem = isParent;
            return item.subpaths ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationListItemCollapsible, {
                ...item,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                    children: renderNavigationItems(item.subpaths, true)
                })
            }, item.label) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationListItem, {
                ...item,
                isNestedItem: isNestedItem
            }, item.label);
        });
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: renderNavigationItems(navigationItems)
    });
};
const List = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_List_e42ad5de__["default"], styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: isMobile ? Spacing["250"] : Spacing["500"]
    }));
const NavigationList = function(props) {
    const isMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(List, {
        ...props,
        isMobile: isMobile
    });
};
const BOTTOM_NAVIGATION_HEIGHT = Spacing["4500"];
const MuiBottomNavigationActionElement = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigationAction_261e3421__["default"], styledOptions)(({ isSelected })=>({
        ".MuiBottomNavigationAction-label": {
            color: isSelected ? Primary.main : Text.secondary,
            "&.Mui-selected": {
                fontSize: Spacing["750"]
            }
        }
    }));
function BottomNavigation({ items, children, ref, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(BottomNavigationContainer, {
        showLabels: true,
        ref: ref,
        ...rest,
        children: [
            items.map(function(item) {
                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MuiBottomNavigationActionElement, {
                    isSelected: item.selected ?? false,
                    label: item.label,
                    icon: item.selected ? item.iconSelected : item.icon,
                    onClick: ()=>item.onClickRoute?.(item?.path)
                }, item.label);
            }),
            children
        ]
    });
}
const BottomNavigationContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_BottomNavigation_918bb977__["default"])(({ theme })=>({
        position: positioning_Positioning.fixed,
        width: "100vw",
        borderTop: `1px solid ${Border.main}`,
        height: BOTTOM_NAVIGATION_HEIGHT,
        left: Spacing["0"],
        bottom: Spacing["0"],
        zIndex: theme.zIndex.drawer + 1,
        paddingLeft: Spacing["1000"],
        paddingRight: Spacing["1000"]
    }));
function BottomNavigationDrawer({ items, children, ref, paperPropsSx, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SwipeableDrawer_b1c2876e__["default"], {
        anchor: "bottom",
        ref: ref,
        ...rest,
        PaperProps: {
            sx: {
                borderTopRightRadius: BorderRadius.paper,
                borderTopLeftRadius: BorderRadius.paper,
                minWidth: "100%",
                ...paperPropsSx ?? {}
            }
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
            spacing: 2,
            paddingX: 1,
            paddingTop: 4,
            sx: {
                paddingBottom: BOTTOM_NAVIGATION_HEIGHT
            },
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                    children: items && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NestedNavigation, {
                        navigationItems: items
                    })
                }),
                children
            ]
        })
    });
}
const bottomNavigationRoutes = [
    {
        label: "Profilo",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UserCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UserCircleDuotone, {}),
        path: ""
    },
    {
        label: "Bonus",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EuroCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EuroCircleDuotone, {}),
        path: ""
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileTextEditOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileTextEditDuotone, {}),
        path: ""
    },
    {
        label: "Upgrade",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileWandOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileWandDuotone, {}),
        path: ""
    },
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalSolid, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalDuotone, {}),
        path: ""
    }
];
const bottomNavigationDrawerRoutes = [
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalDuotone, {}),
        disabled: true
    },
    {
        label: "Documenti",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FolderOpenOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FolderOpenDuotone, {}),
        path: "/documents",
        onClickRoute (path) {
            console.log(path);
        },
        selected: true
    },
    {
        label: "Impostazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsDuotone, {})
    },
    {
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BoxOutlined, {}),
        label: "Scartoffie",
        subpaths: [
            {
                label: "Termini di utilizzo",
                path: "/tos",
                onClickRoute: (path)=>console.log(path)
            },
            {
                label: "Condizioni Generali di Servizio"
            },
            {
                label: "Privacy Policy"
            },
            {
                label: "Cookies Policy"
            }
        ]
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutDuotone, {})
    }
];
function isError(value) {
    return value instanceof Error;
}
function isFunction(value) {
    return "function" == typeof value;
}
const CustomBreadcrumbsLink = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Link_317b0bd9__["default"], styledOptions)(({ theme, active })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: theme.spacing(2),
        color: active ? theme.palette.text.secondary : displaying_Displaying.inherit,
        fontWeight: active ? typography_FontWeight.bold : typography_FontWeight.normal
    }));
function BreadcrumbsLinkBuilder({ children, lastElement, onClick, href, sx, ...rest }) {
    const isClickable = isFunction(onClick) || href;
    const onHoverTextDecoration = isClickable ? "hover" : displaying_Displaying.none;
    const cursorStyle = isClickable ? cursor_style_CursorStyle.pointer : cursor_style_CursorStyle["default"];
    if (lastElement) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
        noWrap: true,
        textOverflow: "ellipsis",
        overflow: "hidden",
        color: Text.secondary,
        fontWeight: typography_FontWeight.bold,
        onClick: onClick,
        sx: {
            cursor: cursorStyle,
            ...sx
        },
        ...rest,
        children: children
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomBreadcrumbsLink, {
        sx: {
            cursor: cursorStyle,
            ...sx
        },
        underline: onHoverTextDecoration,
        href: href,
        onClick: onClick,
        ...rest,
        children: children
    });
}
const BreadcrumbsLink = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(BreadcrumbsLinkBuilder);
var wrapping_Wrapping = /*#__PURE__*/ function(Wrapping) {
    Wrapping["noWrap"] = "nowrap";
    Wrapping["wrap"] = "wrap";
    Wrapping["wrapReverse"] = "wrap-reverse";
    return Wrapping;
}({});
const BREADCRUMBS_MAX_ITEMS = 5;
const StyledBreadcrumbs = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Breadcrumbs_3d9c9a2c__["default"])({
    maxWidth: "100%",
    ol: {
        flexWrap: wrapping_Wrapping.noWrap
    },
    "li:last-of-type": {
        overflow: "hidden"
    }
});
const breadcrumbs_Breadcrumbs = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, maxItems = BREADCRUMBS_MAX_ITEMS, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledBreadcrumbs, {
        ref: ref,
        color: "primary",
        maxItems: maxItems,
        separator: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {}),
        ...rest,
        children: children
    });
});
const button_Button = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ loading, children, disabled, endIcon, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Button_4aba319b__["default"], {
        ref: ref,
        disableElevation: true,
        endIcon: loading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
            color: "inherit",
            size: "1rem"
        }) : endIcon,
        disabled: disabled,
        "aria-disabled": disabled,
        ...rest,
        children: children
    });
});
const ChatInputBottomBar = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
    shouldForwardProp: (prop)=>"shouldShow" !== prop
})(({ shouldShow })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        overflow: "hidden",
        transition: "height 0.3s, opacity 0.3s",
        height: shouldShow ? "40px" : 0,
        opacity: shouldShow ? 1 : 0,
        padding: `0 ${Spacing["500"]} ${shouldShow ? Spacing["500"] : 0}`
    }));
const ChatInputInnerBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(()=>({
        display: displaying_Displaying.flex,
        position: positioning_Positioning.relative,
        backgroundColor: TRANSPARENT_COLOR,
        padding: `${Spacing["1000"]} ${Spacing["750"]}`
    }));
const PRIMARY_COLOR = "primary";
const SECONDARY_OPTION = "secondary";
const NONE_OPTION = "none";
const INITIAL_OPTION = "initial";
const CONTAIN_OPTION = "contain";
const AUTO_OPTION = "auto";
const STABLE_OPTION = "stable";
const ChatInputOuterBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])(()=>({
        position: positioning_Positioning.relative,
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        backgroundColor: Greyx["0"],
        borderRadius: Spacing["1000"],
        minWidth: Spacing["15000"],
        minHeight: AUTO_OPTION,
        boxSizing: "border-box"
    }));
function computeLabelProps({ readonly, InputLabelProps }) {
    return {
        shrink: readonly,
        ...InputLabelProps
    };
}
function computeInputProps({ size, readonly, blocked, startIcon, endIcon, startAdornment, endAdornment, onStartIconClick, onEndIconClick, onStartAdornmentClick, onEndAdornmentClick, InputProps }) {
    const isNotEditable = readonly ?? blocked;
    let generatedInputProps = {
        readOnly: isNotEditable
    };
    if (blocked) return {
        ...generatedInputProps,
        endAdornment: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LockSolid, {
            color: "primary"
        }),
        className: "blocked"
    };
    if (startIcon || startAdornment) generatedInputProps = {
        ...generatedInputProps,
        startAdornment: getAdornmentAndIcon({
            position: "start",
            size,
            icon: startIcon,
            adornment: startAdornment,
            onIconClick: onStartIconClick,
            onAdornmentClick: onStartAdornmentClick
        })
    };
    if (endIcon || endAdornment) generatedInputProps = {
        ...generatedInputProps,
        endAdornment: getAdornmentAndIcon({
            position: "end",
            size,
            icon: endIcon,
            adornment: endAdornment,
            onIconClick: onEndIconClick,
            onAdornmentClick: onEndAdornmentClick
        })
    };
    return {
        ...generatedInputProps,
        ...InputProps
    };
}
function getAdornmentAndIcon({ position, size, icon, adornment, onIconClick, onAdornmentClick }) {
    if ("start" === position) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick),
            getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick)
        ]
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            getTextFieldInputAdornmentProperty("icon", position, size, icon, onIconClick),
            getTextFieldInputAdornmentProperty("adornment", position, size, adornment, onAdornmentClick)
        ]
    });
}
function getTextFieldInputAdornmentProperty(type, position, size, icon, onClick) {
    if (icon) {
        const adornmentClass = "icon" === type ? "icon" : "adornment";
        const adornmentSize = size ?? "medium";
        const inputAdornmentClassName = `${adornmentClass} ${adornmentSize} ${adornmentClass}-${position}`;
        const testID = `text-field-${position}-${adornmentClass}-${adornmentSize}`;
        const testIDForIconButton = `${testID}-button`;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputAdornment_9b9419b5__["default"], {
            className: inputAdornmentClassName,
            position: position,
            "data-testid": testID,
            children: isFunction(onClick) ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                "data-testid": testIDForIconButton,
                size: size,
                onClick: onClick,
                children: icon
            }) : icon
        });
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
}
const text_field_TextField = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ size, readonly, disabled, blocked, startIcon, endIcon, startAdornment, endAdornment, onStartIconClick, onStartAdornmentClick, onEndIconClick, onEndAdornmentClick, InputProps, InputLabelProps, ...rest }, ref) {
    const isTextFieldDisabled = readonly ?? disabled ?? blocked;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_TextField_4cf233bd__["default"], {
        ref: ref,
        size: size ?? "medium",
        variant: "outlined",
        disabled: isTextFieldDisabled,
        InputProps: computeInputProps({
            size,
            readonly,
            blocked,
            startIcon,
            endIcon,
            startAdornment,
            endAdornment,
            onStartIconClick,
            onEndIconClick,
            onStartAdornmentClick,
            onEndAdornmentClick,
            InputProps
        }),
        InputLabelProps: computeLabelProps({
            readonly,
            InputLabelProps
        }),
        ...rest
    });
});
const chatInputBoxStyles = {
    position: positioning_Positioning.relative,
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    backgroundColor: Greyx["0"],
    borderRadius: Spacing["1000"],
    minWidth: Spacing["15000"],
    minHeight: AUTO_OPTION,
    boxSizing: "border-box"
};
const chatInputInnerBoxStyles = {
    display: displaying_Displaying.flex,
    position: positioning_Positioning.relative,
    backgroundColor: TRANSPARENT_COLOR,
    padding: `${Spacing["1000"]} ${Spacing["750"]}`
};
const textFieldStyles = {
    flexGrow: 1,
    justifyContent: alignment_Alignment.center,
    backgroundColor: TRANSPARENT_COLOR,
    padding: 0,
    boxShadow: "none",
    scrollbarColor: `${Greyx["400"]} ${TRANSPARENT_COLOR}`,
    "&::-webkit-scrollbar": {
        width: Spacing["250"]
    },
    "&::-webkit-scrollbar-track": {
        background: TRANSPARENT_COLOR
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: Greyx["400"],
        borderRadius: Spacing["500"],
        transition: "background-color 0.3s, width 0.3s"
    },
    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: Greyx["600"],
        width: Spacing["500"]
    }
};
const sendButtonBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const leftActionsBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const rightActionsBoxStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
};
const bottomBarStyles = (shouldBottomBarBeVisible)=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        overflow: "hidden",
        transition: "height 0.3s, opacity 0.3s",
        height: shouldBottomBarBeVisible ? "40px" : 0,
        opacity: shouldBottomBarBeVisible ? 1 : 0,
        padding: `0 ${Spacing["500"]} ${shouldBottomBarBeVisible ? Spacing["500"] : 0}`
    });
const sendButtonStyles = (isChatInputDisabled)=>({
        "&:hover": {
            color: isChatInputDisabled ? "disabled" : Primary.dark
        }
    });
const LeftActionsBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const SendButtonBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"])(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const RightActionsBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)(()=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center
    }));
const DEFAULT_PLACEHOLDER = "Type a message...";
const ENTER_KEY = "Enter";
const BACKSPACE_KEY = "Backspace";
const chat_input_ChatInput = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ readonly = false, blocked = false, isMobile = false, placeholder = DEFAULT_PLACEHOLDER, leftActions, rightActions, onSubmit, onChange, onKeyDown, onBlur, onFocus, inputRef: externalInputRef, ...rest }, ref) {
    const [prompt, setPrompt] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const [isFocused, setIsFocused] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const combinedInputRef = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useForkRef)(inputRef, externalInputRef);
    const isTextFieldDisabled = readonly || blocked;
    const maxRows = isMobile ? 4 : 8;
    const isChatInputDisabled = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>0 === prompt.trim().length || readonly || blocked, [
        prompt,
        readonly,
        blocked
    ]);
    const shouldBottomBarBeVisible = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>isFocused || prompt.trim().length > 0, [
        isFocused,
        prompt
    ]);
    const hasLeftActions = leftActions && leftActions.length > 0;
    const hasRightActions = rightActions && rightActions.length > 0;
    const clearPrompt = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        setPrompt("");
    }, []);
    const handleSubmit = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (onSubmit && prompt.length > 0) {
            onSubmit(prompt);
            if (isMobile) handleFocusAway();
            clearPrompt();
        }
    }, [
        prompt,
        onSubmit,
        clearPrompt,
        isMobile
    ]);
    const handleChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const newValue = event.target.value;
        setPrompt(newValue);
        if (onChange) onChange(event);
    }, [
        onChange
    ]);
    const handleKeyDown = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const isCtrlOrMetaPressed = event.metaKey || event.ctrlKey;
        function handleEnterKey() {
            if (!isCtrlOrMetaPressed && (isMobile || event.shiftKey)) createNewLine();
            else handleSubmit();
            event.preventDefault();
        }
        function handleBackspaceKey() {
            if (isCtrlOrMetaPressed) {
                clearPrompt();
                event.preventDefault();
            }
        }
        switch(event.key){
            case ENTER_KEY:
                handleEnterKey();
                break;
            case BACKSPACE_KEY:
                handleBackspaceKey();
                break;
            default:
                break;
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        handleSubmit,
        onKeyDown,
        clearPrompt,
        isMobile
    ]);
    const handleBlur = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event, fromAway = false)=>{
        if (fromAway) setIsFocused(false);
        const textAreaElement = inputRef.current?.querySelector("textarea");
        if (textAreaElement) textAreaElement.blur();
        if (onBlur && "currentTarget" in event) onBlur(event);
    }, [
        onBlur
    ]);
    const handleFocus = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        setIsFocused(true);
        const textAreaElement = inputRef.current?.querySelector("textarea");
        if (textAreaElement) textAreaElement.focus();
        if (onFocus) onFocus(event);
    }, [
        onFocus
    ]);
    const handleFocusAway = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        handleBlur({}, true);
    }, []);
    const createNewLine = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        const textAreaElement = inputRef.current;
        if (textAreaElement) {
            const cursorPosition = textAreaElement.selectionStart ?? 0;
            setPrompt((prevPrompt)=>{
                const newPrompt = prevPrompt.slice(0, cursorPosition) + "\n" + prevPrompt.slice(cursorPosition);
                setTimeout(()=>{
                    textAreaElement.selectionStart = textAreaElement.selectionEnd = cursorPosition + 1;
                    textAreaElement.scrollTop = textAreaElement.scrollHeight;
                    textAreaElement.focus();
                }, 0);
                return newPrompt;
            });
        }
    }, []);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useImperativeHandle)(ref, ()=>({
            ...inputRef,
            textAreaElement: inputRef.current?.querySelector("textarea"),
            focus: ()=>{
                inputRef.current?.focus();
                if (!isFocused) handleFocus({});
            },
            blur: ()=>{
                inputRef.current?.blur();
                if (isFocused) handleBlur({});
            }
        }));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ClickAwayListener_a7328dbe__["default"], {
        onClickAway: (event)=>handleBlur(event, true),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ChatInputOuterBox, {
            onFocus: handleFocus,
            onClick: handleFocus,
            ...rest,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ChatInputInnerBox, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
                        inputRef: combinedInputRef,
                        variant: "standard",
                        size: "medium",
                        placeholder: placeholder,
                        value: prompt,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        onBlur: handleBlur,
                        disabled: isTextFieldDisabled,
                        multiline: true,
                        maxRows: maxRows,
                        "data-testid": "chat-input-text-field",
                        focused: isFocused,
                        InputProps: {
                            disableUnderline: true,
                            sx: {
                                padding: 0
                            }
                        },
                        sx: textFieldStyles
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ChatInputBottomBar, {
                    shouldShow: shouldBottomBarBeVisible,
                    children: [
                        hasLeftActions ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftActionsBox, {
                            children: leftActions
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SendButtonBox, {
                            children: [
                                hasRightActions && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(RightActionsBox, {
                                    children: rightActions
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_IconButton_ea601170__["default"], {
                                    onClick: handleSubmit,
                                    disabled: isChatInputDisabled,
                                    "data-testid": "chat-input-send-button",
                                    disableRipple: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ArrowUpCircleSolid, {
                                        color: isChatInputDisabled ? "disabled" : "primary",
                                        sx: sendButtonStyles(isChatInputDisabled)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
const LargeCheckbox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__["default"])({
    "& .MuiSvgIcon-root": {
        fontSize: Spacing["1750"]
    }
});
const checkbox_Checkbox = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isLarge, ...rest }, ref) {
    if (isLarge) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LargeCheckbox, {
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Checkbox_a38238a1__["default"], {
        ref: ref,
        ...rest
    });
});
function CompanyData() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "caption",
        color: "text.disabled",
        sx: {
            paddingX: 4
        },
        children: "SimplifAI Ted Srl \u2022 P.I. 11237050965 | Milano (MI) \u2013 Via Roberto Lepetit, 18"
    });
}
const conversationBubbleContainerStyles = (isInteractive)=>({
        display: displaying_Displaying.flex,
        flexDirection: "row",
        alignItems: alignment_Alignment.center,
        padding: `${Spacing["750"]} ${Spacing["1000"]}`,
        gap: Spacing["1000"],
        width: "fit-content",
        maxWidth: "75%",
        backgroundColor: DeepBlue.light,
        borderRadius: Spacing["750"],
        border: `1px solid ${TRANSPARENT_COLOR}`,
        cursor: isInteractive ? "pointer" : "default",
        "&:hover": isInteractive ? {
            borderColor: PurpleLight.outlinedBorder
        } : {},
        "&:focus": isInteractive ? {
            borderColor: PurpleLight.contrastText
        } : {},
        "&:active": isInteractive ? {
            borderColor: PurpleLight.contrastText
        } : {}
    });
const conversationBubbleStartIconStyles = {
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.center,
    color: PurpleLight.contrastText
};
const conversationBubbleTextStyles = {
    flexGrow: 1,
    wordBreak: "break-word"
};
const renderTextWithSpecialChars = (text)=>text.split("\n").map((line, lineIndex, lines)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
            children: [
                line.split("\t").map((segment, segmentIndex, segments)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                        children: [
                            segment,
                            segmentIndex < segments.length - 1 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                style: {
                                    display: "inline-block",
                                    width: "1em"
                                }
                            })
                        ]
                    }, segmentIndex)),
                lineIndex < lines.length - 1 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("br", {})
            ]
        }, lineIndex));
const conversation_bubble_ConversationBubble = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ text, startIcon, fullWidth = false, maxWidth = "100%", onClick, sx = {}, ...rest }, ref) {
    const isInteractive = Boolean(onClick);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ref: ref,
        onClick: onClick,
        ...rest,
        sx: {
            ...conversationBubbleContainerStyles(isInteractive),
            width: fullWidth ? "100%" : "fit-content",
            maxWidth: fullWidth ? "none" : maxWidth,
            ...sx
        },
        children: [
            startIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                sx: conversationBubbleStartIconStyles,
                children: startIcon
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "body1",
                sx: conversationBubbleTextStyles,
                children: renderTextWithSpecialChars(text)
            })
        ]
    });
}));
const DesktopDatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slots, slotProps, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_DesktopDatePicker_970824af__.DesktopDatePicker, {
        slots: {
            openPickerIcon: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CalendarOutlined,
            ...slots
        },
        slotProps: {
            textField: {
                id
            },
            ...slotProps
        },
        ...rest,
        ref: ref
    });
});
const mobileDatePickerTextFieldStyleOverrides = {
    "& .MuiOutlinedInput-root": {
        "&:has([readonly])": {
            backgroundColor: Background.paper,
            cursor: cursor_style_CursorStyle.pointer
        }
    },
    "& .Mui-readOnly": {
        cursor: cursor_style_CursorStyle.pointer
    }
};
const mobileDatePickerTextFieldDisabledStyleOverrides = {
    "& .MuiOutlinedInput-root": {
        "&:has([readonly])": {
            backgroundColor: Background.paper
        }
    }
};
function generateCustomTextFieldStyle(disabled) {
    const iconColor = disabled ? "disabled" : "action";
    return {
        sx: disabled ? mobileDatePickerTextFieldDisabledStyleOverrides : mobileDatePickerTextFieldStyleOverrides,
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CalendarOutlined, {
                color: iconColor
            })
        }
    };
}
const mobile_date_picker_MobileDatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slotProps, disabled, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_MobileDatePicker_8c47fa9b__.MobileDatePicker, {
        slotProps: {
            textField: {
                id,
                ...generateCustomTextFieldStyle(disabled)
            },
            ...slotProps
        },
        disabled: disabled,
        ...rest,
        ref: ref
    });
});
const date_picker_DatePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isMobile, ...rest }, ref) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(mobile_date_picker_MobileDatePicker, {
        ...rest,
        ref: ref
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DesktopDatePicker, {
        ...rest,
        ref: ref
    });
});
const desktop_date_time_picker_DesktopDateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slots, slotProps, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__.DesktopDateTimePicker, {
        slots: {
            openPickerIcon: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CalendarOutlined,
            ...slots
        },
        slotProps: {
            textField: {
                id
            },
            ...slotProps
        },
        viewRenderers: {
            hours: __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__.renderTimeViewClock,
            minutes: __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__.renderTimeViewClock,
            seconds: __WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__.renderTimeViewClock
        },
        ...rest,
        ref: ref
    });
});
const mobile_date_time_picker_MobileDateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ id, slotProps, disabled, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_x_date_pickers_53f203a2__.MobileDateTimePicker, {
        slotProps: {
            textField: {
                id,
                ...generateCustomTextFieldStyle(disabled)
            },
            tabs: {
                hidden: false,
                dateIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CalendarOutlined, {}),
                timeIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ClockOutlined, {})
            },
            ...slotProps
        },
        disabled: disabled,
        ...rest,
        ref: ref
    });
});
const date_time_picker_DateTimePicker = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isMobile, ...rest }, ref) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(mobile_date_time_picker_MobileDateTimePicker, {
        ...rest,
        ref: ref
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(desktop_date_time_picker_DesktopDateTimePicker, {
        ...rest,
        ref: ref
    });
});
const DialogGridContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    gap: Spacing["1500"],
    textAlign: alignment_Alignment.center
});
const DialogIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    textAlign: alignment_Alignment.center
});
function Dialog({ id, children, title, description, primaryButton, secondaryButton, icon, iconAlignment = "center", maxWidth, onCloseButtonClick, closeButtonWrappperProps, centerButtons, customDialogActions, customTitle, ...rest }) {
    const titleVariant = "sm" === maxWidth || "xs" === maxWidth ? "h6" : "h5";
    const descriptionVariant = "sm" === maxWidth || "xs" === maxWidth ? "body2" : "body1";
    const buttonAlignment = centerButtons ? "align-center" : "align-end";
    const dialogActions = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (customDialogActions) return customDialogActions;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogActions_c3764e69__["default"], {
            children: [
                secondaryButton && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    ...secondaryButton
                }),
                primaryButton && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    ...primaryButton
                })
            ]
        });
    }, [
        customDialogActions,
        primaryButton,
        secondaryButton
    ]);
    const dialogTitle = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (customTitle) return customTitle;
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogTitle_112a25af__["default"], {
            component: titleVariant,
            children: title
        });
    }, [
        customTitle,
        title
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Dialog_802ecffd__["default"], {
        ...rest,
        maxWidth: maxWidth,
        id: id,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                justifyContent: alignment_Alignment.flexEnd,
                ...closeButtonWrappperProps,
                children: onCloseButtonClick ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    size: "small",
                    onClick: onCloseButtonClick,
                    id: "dialog-close-button",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TimesSolid, {})
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DialogGridContainer, {
                container: true,
                children: [
                    icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "inner-icon",
                            style: {
                                textAlign: iconAlignment
                            },
                            children: icon
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: dialogTitle
                    }),
                    description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                            variant: descriptionVariant,
                            color: "textSecondary",
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_DialogContent_37fd6d87__["default"], {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        className: buttonAlignment,
                        item: true,
                        children: dialogActions
                    })
                ]
            })
        ]
    });
}
function isArrayPopulated(collection) {
    const MIN_LENGTH = 1;
    const collectionSize = collection.length;
    return collectionSize >= MIN_LENGTH;
}
var dropzone_enum_DropzonePhase = /*#__PURE__*/ function(DropzonePhase) {
    DropzonePhase["Empty"] = "empty";
    DropzonePhase["Loading"] = "loading";
    DropzonePhase["SelectedFiles"] = "selected";
    DropzonePhase["ConfirmedFiles"] = "confirmed";
    DropzonePhase["Invalid"] = "error";
    DropzonePhase["Valid"] = "success";
    return DropzonePhase;
}({});
const CustomDropzone = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(function({ theme, status }) {
    const dropzoneStyle = computeDropzoneStyle(theme, status);
    return dropzoneStyle;
});
function computeDropzoneStyle(theme, status) {
    const isStatusValid = status?.phase === dropzone_enum_DropzonePhase.Valid;
    const isStatusInvalid = status?.phase === dropzone_enum_DropzonePhase.Invalid;
    const isStatusError = status?.phase === dropzone_enum_DropzonePhase.Invalid;
    const isBackgroundTransparent = status?.phase === dropzone_enum_DropzonePhase.Empty;
    const isStatusValidOrInvalid = isStatusInvalid || isStatusValid;
    let borderColor = theme.palette.primary.main;
    let borderColorHovered = theme.palette.primary.dark;
    const borderStyle = isStatusValidOrInvalid ? border_style_BorderStyle.solid : border_style_BorderStyle.dashed;
    if (isStatusValid) {
        borderColor = theme.palette.success.main;
        borderColorHovered = theme.palette.success.dark;
    } else if (isStatusError) {
        borderColor = theme.palette.error.main;
        borderColorHovered = theme.palette.error.dark;
    }
    const borderStyled = getBorderStyle(borderStyle, borderColor);
    const borderHovered = getBorderStyle(borderStyle, borderColorHovered);
    const backgroundColor = isBackgroundTransparent ? TRANSPARENT_COLOR : theme.palette.background.paper;
    const dropzoneStyle = {
        border: borderStyled,
        flex: "1 0 0",
        borderRadius: theme.spacing(2),
        padding: theme.spacing(7),
        textAlign: alignment_Alignment.center,
        backgroundColor,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer,
            border: borderHovered
        }
    };
    return dropzoneStyle;
}
function getBorderStyle(style, borderColor) {
    return `${ONE_PIXEL_REM} ${style} ${borderColor}`;
}
function parseErrorMessage(error) {
    return `${isError(error) ? error.message : error}`;
}
function handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.SelectedFiles, mapAcceptedFiles(acceptedFiles));
    if (!isFunction(onDrop)) return newStatus;
    try {
        onDrop(acceptedFiles, fileRejections, event);
        return newStatus;
    } catch (onDropCallbackError) {
        handleCallbackError(onDropCallbackError, onDropError);
        return createNewStatus(dropzone_enum_DropzonePhase.Invalid, mapAcceptedFiles(acceptedFiles), parseErrorMessage(onDropCallbackError));
    }
}
async function handleOnConfirmEventAndReturnNewStatus(files, onConfirm, onConfirmError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.ConfirmedFiles, mapAcceptedFiles(files ?? []));
    if (!isFunction(onConfirm)) return newStatus;
    try {
        await onConfirm(files);
        return newStatus;
    } catch (onConfirmCallbackError) {
        handleCallbackError(onConfirmCallbackError, onConfirmError);
        return createNewStatus(dropzone_enum_DropzonePhase.Invalid, mapAcceptedFiles(files ?? []), parseErrorMessage(onConfirmCallbackError));
    }
}
async function handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError) {
    event.stopPropagation();
    event.preventDefault();
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.Empty);
    if (!isFunction(onClear)) return newStatus;
    try {
        onClear();
    } catch (onClearCallbackError) {
        handleCallbackError(onClearCallbackError, onClearError);
    }
    return null;
}
function handleModifyButtonEventAndReturnNewStatus(dropzoneStatus, onModify, onModifyError) {
    const newStatus = createNewStatus(dropzone_enum_DropzonePhase.SelectedFiles, dropzoneStatus.acceptedFiles);
    if (isFunction(onModify)) try {
        onModify();
    } catch (onModifyCallbackError) {
        handleCallbackError(onModifyCallbackError, onModifyError);
    }
    return newStatus;
}
function createNewStatus(phase, acceptedFiles, message) {
    return {
        phase,
        acceptedFiles: acceptedFiles ?? [],
        message
    };
}
function handleCallbackError(error, errorCallback) {
    if (isFunction(errorCallback)) errorCallback(error);
}
function mapAcceptedFiles(acceptedFiles) {
    return acceptedFiles.map((f)=>({
            file: f,
            url: URL.createObjectURL(f)
        }));
}
const CustomTrashIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.end
});
function DropzoneClearButton({ onClick, clearButtonId }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomTrashIconContainer, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            id: clearButtonId,
            className: "clear-button",
            color: "default",
            size: "small",
            onClick: onClick,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TrashOutlined, {
                color: "action"
            })
        })
    });
}
function Progress({ hideLabel, value, labelSize, ...rest }) {
    if (hideLabel) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
        value: value,
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        position: positioning_Positioning.relative,
        display: displaying_Displaying.inlineFlex,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CircularProgress_60f00cb3__["default"], {
                value: value,
                ...rest
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                display: displaying_Displaying.flex,
                alignItems: alignment_Alignment.center,
                justifyContent: alignment_Alignment.center,
                position: positioning_Positioning.absolute,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                    variant: "caption",
                    component: "div",
                    color: "textSecondary",
                    fontSize: labelSize,
                    children: `${Math.round(value)}%`
                })
            })
        ]
    });
}
const modifyButtonDefaultText = "Modifica Documento";
const confirmButtonDefaultText = "Conferma Documento";
const defaultUploadButtonText = "Carica Documento";
const defaultLoadingText = "Caricamento...";
const SEE_FILE_PREVIEW = "Vedi anteprima";
const LETTER_SPACING_0_1 = "0.1px";
const TooltipTitleTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    lineHeight: "157%",
    fontSize: Spacing["875"],
    letterSpacing: LETTER_SPACING_0_1,
    fontWeight: typography_FontWeight.bold
});
const TooltipDescriptionTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    letterSpacing: typography_LetterSpacing.wider
});
function TooltipContainerText({ title, description }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipTitleTypographyContainer, {
                className: "tooltip-title",
                variant: "subtitle2",
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipDescriptionTypographyContainer, {
                className: "tooltip-description",
                variant: "caption",
                children: description
            })
        ]
    });
}
function Tooltip({ children, title, description, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tooltip_69cc2f11__["default"], {
        title: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TooltipContainerText, {
            title: title,
            description: description
        }),
        ...rest,
        children: children
    });
}
function FileIcon({ fileType, fileUrl, fileName }) {
    if (fileType.includes("image") && fileUrl) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
        src: fileUrl,
        alt: `file preview ${fileName}`,
        style: {
            maxWidth: Spacing["12500"],
            maxHeight: Spacing["12500"]
        },
        "data-testid": "file-image-preview"
    });
    if (fileType.includes("pdf")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.PDFFileOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "pdf-file-outlined-icon"
    });
    if (fileType.includes("zip")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ZipOutlined, {
        style: {
            fontSize: Spacing["2180"]
        },
        color: Primary.main,
        "data-testid": "zip-file-outlined-icon"
    });
    if (fileType.includes("video")) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.VideoPlayOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "video-play-outlined-icon"
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileOutlined, {
        color: "primary",
        style: {
            width: Spacing["2180"],
            height: Spacing["2180"]
        },
        "data-testid": "file-outlined-icon"
    });
}
function FileDetailsPreview({ file, url, shouldShowTooltip }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        placement: "bottom",
        description: SEE_FILE_PREVIEW,
        open: shouldShowTooltip,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FileIcon, {
                    fileType: file.type,
                    fileUrl: url,
                    fileName: file.name
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                    color: "textSecondary",
                    fontSize: typography_FontSize.xs,
                    "data-testid": `${file.name}-typography-file-details-preview`,
                    children: file.name
                })
            ]
        }, `${file.name}-${file.size}-${file.type}`)
    }, `see-file-preview-tooltip_${file.name}`);
}
const file_details_preview = FileDetailsPreview;
function FilePreview({ fileWithUrl, shouldShowTooltip }) {
    const { file, url } = fileWithUrl;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(file_details_preview, {
        shouldShowTooltip: shouldShowTooltip,
        file: file,
        url: url
    }, `file-details-preview-${file.name}`);
}
const file_preview = FilePreview;
const FilePreviewContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    padding: `${Spacing["1500"]} 0px`,
    flexDirection: direction_Direction.row,
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center,
    gap: Spacing["2000"]
});
function DropzonePreviewer({ acceptedFiles, shouldShowTooltip }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilePreviewContainer, {
        "data-testid": "styled-dropzone-previewer",
        children: acceptedFiles.map((acceptedFile)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(file_preview, {
                fileWithUrl: acceptedFile,
                shouldShowTooltip: shouldShowTooltip
            }, keyFromFile(acceptedFile.file)))
    });
}
function keyFromFile(file) {
    return `${file.name}-${file.size}-${file.type}-${file.lastModified}`;
}
const CustomDropzoneContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    padding: `${Spacing["1500"]} 0px`,
    flexDirection: direction_Direction.column,
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center,
    gap: Spacing["2000"]
});
const MemoizedLoadingPhase = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(function({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Progress, {
                variant: "indeterminate",
                value: 0,
                hideLabel: true,
                size: Spacing["2000"],
                color: "secondary"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                fontSize: typography_FontSize.xs,
                children: children
            })
        ]
    });
});
const MemoizeDropPhase = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(function({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UploadAltSolid, {
                color: "primary",
                scale: Spacing["2000"]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                color: "primary",
                variant: "outlined",
                size: "small",
                endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.InboxUploadOutlined, {}),
                children: children
            })
        ]
    });
});
function DropzoneContainer({ uploadButtonText, isLoading, loadingText, acceptedFiles, shouldShowTooltip }) {
    const hasFiles = acceptedFiles && acceptedFiles.length > 0;
    const showOnlyFilePreview = !isLoading && hasFiles;
    if (showOnlyFilePreview) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzonePreviewer, {
        acceptedFiles: acceptedFiles,
        shouldShowTooltip: shouldShowTooltip
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneContainer, {
        children: isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizedLoadingPhase, {
            children: loadingText ?? defaultLoadingText
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizeDropPhase, {
            children: uploadButtonText ?? defaultUploadButtonText
        })
    });
}
const CustomDropzoneMessageContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ theme, color })=>{
    const selectedColor = color === dropzone_enum_DropzonePhase.Valid ? theme.palette.success.main : theme.palette.error.main;
    return {
        color: selectedColor,
        display: displaying_Displaying.flex,
        padding: `${theme.spacing(2)} 0px`,
        flexDirection: direction_Direction.row,
        justifyContent: alignment_Alignment.center,
        alignItems: alignment_Alignment.center
    };
});
function DropzoneMessage({ message, color }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneMessageContainer, {
        className: "dropzone-message",
        color: color,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "caption",
            children: message
        })
    });
}
function Dropzone({ status, uploadButtonText, loadingText, modifyButtonText, confirmButtonText, onDrop, onDropError, onClear, onClearError, onConfirm, onConfirmError, onModify, onModifyError, onClickMobile, clearButtonId, id, onClickPreviewHandler, enableShowFilePreviewTooltip = true, ...rest }) {
    const [dropzoneStatus, setDropzoneStatus] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)({
        phase: status?.phase ?? dropzone_enum_DropzonePhase.Empty,
        message: status?.message,
        acceptedFiles: status?.acceptedFiles ?? []
    });
    const [shouldShowTooltip, setShouldShowTooltip] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        setDropzoneStatus({
            phase: status?.phase ?? dropzone_enum_DropzonePhase.Empty,
            message: status?.message,
            acceptedFiles: status?.acceptedFiles ?? []
        });
    }, [
        status
    ]);
    const handleMouseEnterCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        setShouldShowTooltip(true);
    }, []);
    const handleMouseLeaveCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        setShouldShowTooltip(false);
    }, []);
    const isInputDisabled = isInputDisabledCheck(dropzoneStatus);
    const isClearButtonDisabled = isClearButtonDisabledCheck(dropzoneStatus);
    const isFileCollectedFromDropzone = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        const DEFAULT_FILES_COLLESTION = [];
        const filesCollection = dropzoneStatus.acceptedFiles ?? DEFAULT_FILES_COLLESTION;
        const containsFiles = isArrayPopulated(filesCollection);
        return containsFiles;
    }, [
        dropzoneStatus.acceptedFiles
    ]);
    const onDropHandler = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(acceptedFiles, fileRejections, event) {
        const newStatus = handleOnDropEventAndReturnNewStatus(acceptedFiles, fileRejections, event, onDrop, onDropError);
        setDropzoneStatus(newStatus);
    }, [
        setDropzoneStatus,
        onDrop,
        onDropError
    ]);
    const isDropzoneClickDisabled = isInputDisabled || isFileCollectedFromDropzone;
    const { getRootProps, getInputProps, open } = (0, __WEBPACK_EXTERNAL_MODULE_react_dropzone_e9959fec__.useDropzone)({
        noClick: isDropzoneClickDisabled,
        noDrag: isInputDisabled,
        noDragEventsBubbling: isInputDisabled,
        noKeyboard: true,
        onDrop: onDropHandler,
        ...rest
    });
    const isPhaseLoading = dropzoneStatus.phase === dropzone_enum_DropzonePhase.Loading;
    const onClearClickHandler = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async function(event) {
        const newStatus = await handleClearButtonClickEventAndReturnNewStatus(event, onClear, onClearError);
        if (newStatus) setDropzoneStatus(newStatus);
    }, [
        setDropzoneStatus,
        onClear,
        onClearError
    ]);
    const onClickPipeline = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(async function(event) {
        event.preventDefault();
        event.stopPropagation();
        const filesCollection = dropzoneStatus.acceptedFiles;
        let isShowFilePreviewEnabled = false;
        let canOpenDefaultDialog = true;
        if (isFunction(onClickMobile)) canOpenDefaultDialog = await onClickMobile(event);
        if (isFunction(onClickPreviewHandler)) isShowFilePreviewEnabled = onClickPreviewHandler(isDropzoneClickDisabled, filesCollection);
        if (canOpenDefaultDialog && !isShowFilePreviewEnabled) open();
    }, [
        isInputDisabled,
        isFileCollectedFromDropzone
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(CustomDropzone, {
                id: id,
                ...getRootProps({
                    onClick: onClickPipeline
                }),
                status: dropzoneStatus,
                onMouseOver: handleMouseEnterCallback,
                onMouseLeave: handleMouseLeaveCallback,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
                        ...getInputProps(),
                        className: "dropzone-input"
                    }),
                    !isClearButtonDisabled && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneClearButton, {
                        clearButtonId: clearButtonId,
                        onClick: onClearClickHandler
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneContainer, {
                        uploadButtonText: uploadButtonText,
                        loadingText: loadingText,
                        isLoading: isPhaseLoading,
                        acceptedFiles: dropzoneStatus.acceptedFiles,
                        shouldShowTooltip: enableShowFilePreviewTooltip && shouldShowTooltip
                    })
                ]
            }),
            dropzoneStatus.message && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DropzoneMessage, {
                color: dropzoneStatus.phase,
                message: dropzoneStatus.message
            })
        ]
    });
}
const dropzoneStatusesWithoutClearButton = [
    dropzone_enum_DropzonePhase.Valid,
    dropzone_enum_DropzonePhase.Loading,
    dropzone_enum_DropzonePhase.ConfirmedFiles,
    dropzone_enum_DropzonePhase.Empty
];
function isClearButtonDisabledCheck(dropzoneStatus) {
    const isDropzoneStatusNotAllowed = dropzoneStatusesWithoutClearButton.includes(dropzoneStatus.phase);
    return isDropzoneStatusNotAllowed;
}
const dropzoneStatusesWithInputDisabled = [
    dropzone_enum_DropzonePhase.Valid,
    dropzone_enum_DropzonePhase.ConfirmedFiles
];
function isInputDisabledCheck(dropzoneStatus) {
    return dropzoneStatusesWithInputDisabled.includes(dropzoneStatus.phase);
}
const CustomDropzoneActionButtonContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginTop: Spacing["750"],
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center
});
function DropzoneActionButton({ onClick, text, icon }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomDropzoneActionButtonContainer, {
        onClick: onClick,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
            color: "primary",
            variant: "contained",
            size: "medium",
            endIcon: icon,
            children: text
        })
    });
}
const COUNTRY_CODE_WITH_PREFIX = [
    {
        country: "it",
        prefix: "39"
    },
    {
        country: "fr",
        prefix: "590"
    }
];
const FLAG_EXT = "jpg";
function FlagImage({ children, countryCode }) {
    const imageSrc = `${countryCode.toLowerCase()}.${FLAG_EXT}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(FlagImageContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
                alt: countryCode,
                src: imageSrc,
                width: 22,
                height: 14
            }),
            children
        ]
    });
}
const FlagImageContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        display: displaying_Displaying.flex,
        gap: theme.spacing(1),
        alignItems: alignment_Alignment.center
    }));
function FormControlLabel(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControlLabel_8c33cd98__["default"], {
        ...props
    });
}
function Color({ color, title, token }) {
    const paletteStyle = {
        background: color,
        width: "100%",
        height: Spacing["2500"],
        padding: "5px 10px",
        fontWeight: typography_FontWeight.bold
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        container: true,
        xs: 12,
        md: 12,
        sx: {
            boxShadow: "grey 0 0 1px",
            margin: `${Spacing["1000"]} 0`
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    rowSpacing: 1,
                    sx: {
                        display: displaying_Displaying.flex,
                        justifyContent: alignment_Alignment.spaceBetween,
                        padding: "10px",
                        fontSize: "0.9rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 6,
                            children: title
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 6,
                            sx: {
                                display: displaying_Displaying.flex,
                                justifyContent: alignment_Alignment.flexEnd
                            },
                            children: token ?? color
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
                    sx: paletteStyle
                })
            })
        ]
    });
}
const tealDuskPalette = {
    main: tealDusk.getMainColor(100),
    light: tealDusk.getMainColor(10),
    dark: tealDusk.getDarkColor(100),
    contrastText: Common.white.main
};
const pinkHazePalette = {
    main: pinkHaze.getMainColor(100),
    light: pinkHaze.getMainColor(10),
    dark: pinkHaze.getDarkColor(100),
    contrastText: Common.white.main
};
const goldenUmberPalette = {
    main: goldenUmber.getMainColor(100),
    light: goldenUmber.getMainColor(10),
    dark: goldenUmber.getDarkColor(100),
    contrastText: Common.white.main
};
const colorMapper = {
    Bluex: Bluex,
    Tealx: Tealx,
    Pinkx: Pinkx,
    DeepBluex: DeepBluex,
    Nudex: Nudex,
    Purplex: Purplex,
    Napolix: Napolix,
    Celestex: Celestex,
    Orangex: Orangex,
    Redx: Redx,
    Greenx: Greenx,
    Greyx: Greyx,
    Goldenx: Goldenx,
    AlphaDeep: AlphaDeep
};
const paletteMapper = {
    Primary: {
        ...Primary,
        main: {
            token: "Bluex 400",
            color: Bluex["400"]
        },
        light: {
            token: "Bluex 50",
            color: Bluex["50"]
        },
        dark: {
            token: "Bluex 500",
            color: Bluex["500"]
        }
    },
    Secondary: {
        ...Secondary,
        main: {
            token: "Tealx 400",
            color: Tealx["400"]
        },
        light: {
            token: "Tealx 0",
            color: Tealx["0"]
        },
        dark: {
            token: "Tealx 500",
            color: Tealx["500"]
        }
    },
    Tertiary: {
        ...Tertiary,
        main: {
            token: "Pinkx 400",
            color: Pinkx["400"]
        },
        light: {
            token: "Pinkx 0",
            color: Pinkx["0"]
        },
        dark: {
            token: "Pinkx 500",
            color: Pinkx["500"]
        }
    },
    Error: {
        ...ErrorToken,
        main: {
            token: "Redx 400",
            color: Redx["400"]
        },
        light: {
            token: "Redx 200",
            color: Redx["200"]
        },
        dark: {
            token: "Redx 600",
            color: Redx["600"]
        }
    },
    Warning: {
        ...Warning,
        main: {
            token: "Orangex 400",
            color: Orangex["400"]
        },
        light: {
            token: "Orangex 100",
            color: Orangex["100"]
        },
        dark: {
            token: "Orangex 600",
            color: Orangex["600"]
        }
    },
    Info: {
        ...Info,
        main: {
            token: "Napolix 500",
            color: Napolix["500"]
        },
        light: {
            token: "Napolix 0",
            color: Napolix["0"]
        },
        dark: {
            token: "Napolix 600",
            color: Napolix["600"]
        }
    },
    Success: {
        ...Success,
        main: {
            token: "Greenx 400",
            color: Greenx["400"]
        },
        light: {
            token: "Greenx 0",
            color: Greenx["0"]
        },
        dark: {
            token: "Greenx 500",
            color: Greenx["500"]
        }
    },
    Purple: {
        ...Purple,
        main: {
            token: "Purplex 400",
            color: Purplex["400"]
        },
        light: {
            token: "Purplex 100",
            color: Purplex["100"]
        },
        dark: {
            token: "Purplex 700",
            color: Purplex["700"]
        }
    },
    DeepBlue: {
        ...DeepBlue,
        main: {
            token: "DeepBluex 300",
            color: DeepBluex["300"]
        },
        light: {
            token: "DeepBluex 0",
            color: DeepBluex["0"]
        },
        dark: {
            token: "DeepBluex 700",
            color: DeepBluex["700"]
        }
    },
    Text: {
        ...Text,
        primary: {
            token: "DeepBluex 600",
            color: DeepBluex["600"]
        },
        secondary: {
            token: "AlphaDeep 70",
            color: AlphaDeep["70"]
        },
        disabled: {
            token: "AlphaDeep 38",
            color: AlphaDeep["38"]
        }
    },
    Action: {
        ...Action,
        active: {
            token: "AlphaDeep 56",
            color: AlphaDeep["56"]
        },
        disabled: {
            token: "AlphaDeep 24",
            color: AlphaDeep["24"]
        },
        disabledBackground: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        focus: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        hover: {
            token: "AlphaDeep 4",
            color: AlphaDeep["4"]
        },
        selected: {
            token: "AlphaDeep 8",
            color: AlphaDeep["8"]
        }
    },
    Border: {
        ...Border,
        main: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        light: {
            token: "AlphaDeep 10",
            color: AlphaDeep["10"]
        },
        dark: {
            token: "AlphaDeep 30",
            color: AlphaDeep["30"]
        },
        outlinedBorder: {
            token: "AlphaDeep 50",
            color: AlphaDeep["50"]
        },
        selected: {
            token: "AlphaDeep 8",
            color: AlphaDeep["8"]
        },
        focus: {
            token: "AlphaDeep 12",
            color: AlphaDeep["12"]
        },
        focusVisible: {
            token: "AlphaDeep 30",
            color: AlphaDeep["30"]
        },
        fillBackdrop: {
            token: "AlphaDeep 50",
            color: AlphaDeep["50"]
        }
    },
    PurpleLight: {
        ...PurpleLight,
        main: {
            token: "Purplex 0",
            color: PurpleLight.main
        },
        dark: {
            token: "Purplex 100",
            color: PurpleLight.dark
        },
        contrastText: {
            token: "Purplex 600",
            color: PurpleLight.contrastText
        }
    },
    Goldenx: {
        main: {
            token: "Goldenx 500",
            color: Goldenx["500"]
        },
        light: {
            token: "Goldenx 100",
            color: Goldenx["100"]
        },
        dark: {
            token: "Goldenx 700",
            color: Goldenx["700"]
        }
    },
    Tier1: {
        main: {
            token: "Main",
            color: tealDuskPalette.main
        },
        dark: {
            token: "Dark",
            color: tealDuskPalette.dark
        },
        light: {
            token: "Light",
            color: tealDuskPalette.light
        }
    },
    Tier2: {
        main: {
            token: "Main",
            color: pinkHazePalette.main
        },
        dark: {
            token: "Dark",
            color: pinkHazePalette.dark
        },
        light: {
            token: "Light",
            color: pinkHazePalette.light
        }
    },
    Tier3: {
        main: {
            token: "Main",
            color: goldenUmberPalette.main
        },
        dark: {
            token: "Dark",
            color: goldenUmberPalette.dark
        },
        light: {
            token: "Light",
            color: goldenUmberPalette.light
        }
    },
    Background: {
        ...Background,
        default: {
            token: "Greyx 0",
            color: Greyx["0"]
        }
    }
};
function isColorPaletteWithToken(value) {
    return void 0 !== value.token;
}
function GradientPaletteBox({ background, color, text, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        sx: {
            display: displaying_Displaying.flex,
            justifyContent: alignment_Alignment.center,
            alignItems: alignment_Alignment.center,
            background,
            height: "100%",
            minHeight: "3rem",
            width: "100%",
            color,
            borderRadius: "0.3rem"
        },
        ...props,
        children: text
    });
}
const gradient_box_tealDuskStyle = tealDusk.getBoxStylesOverride();
const gradient_box_pinkHazeStyle = pinkHaze.getBoxStylesOverride();
const gradient_box_goldenUmberStyle = goldenUmber.getBoxStylesOverride();
const GradientBoxStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])`
  ${gradient_box_tealDuskStyle}
  ${gradient_box_pinkHazeStyle}
  ${gradient_box_goldenUmberStyle}
`;
function GradientBox(props) {
    const gradientClassName = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = "";
        if (props.gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(props.gradient);
            gradientClassName = ` box-gradient${colorNameCapitalized}`;
        }
        return gradientClassName;
    }, [
        props.gradient
    ]);
    const defaultClassname = "";
    const propsClassName = props.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GradientBoxStyled, {
        ...props,
        children: void 0,
        className: propsClassName + gradientClassName,
        sx: {
            position: positioning_Positioning.relative,
            ...props.sx
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBoxStyled, {
                gradient: props.gradient,
                className: "background",
                sx: {
                    width: "100%",
                    height: "100%"
                }
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                className: "content",
                sx: {
                    position: positioning_Positioning.relative,
                    zIndex: 2,
                    padding: Spacing["1000"]
                },
                children: props.children
            })
        ]
    });
}
const tealDuskBorderStyle = tealDusk.getBoxOutlinedStylesOverride();
const pinkHazeBorderStyle = pinkHaze.getBoxOutlinedStylesOverride();
const goldenUmberBorderStyle = goldenUmber.getBoxOutlinedStylesOverride();
const boxContentClassName = "content";
const defaultGradientBox = "&.box-gradientOutlinedDefault";
const defaultBorderStyle = {
    [defaultGradientBox]: {
        background: Background.paper,
        border: `1px solid ${Border.main}`
    }
};
const darkGradientBox = "&.box-gradientOutlinedDark";
const darkBorderStyle = {
    [darkGradientBox]: {
        background: Background.paper,
        border: `1px solid ${Border.dark}`
    }
};
const BoxOutlinedWithGradient = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    ...tealDuskBorderStyle,
    ...pinkHazeBorderStyle,
    ...goldenUmberBorderStyle,
    ...defaultBorderStyle,
    ...darkBorderStyle
});
function GradientBoxOutlined({ children, size, gradient, withLabel = false, hasDarkBorders = false, ...otherProps }) {
    const gradientClassName = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        let gradientClassName = hasDarkBorders ? " box-gradientOutlinedDark" : " box-gradientOutlinedDefault";
        if (gradient) {
            const colorNameCapitalized = capitalizeFirstLetter(gradient);
            gradientClassName = ` box-gradientOutlined${colorNameCapitalized}`;
        }
        return gradientClassName;
    }, [
        gradient,
        hasDarkBorders
    ]);
    const borderRadiusConfig = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const defaultContentBoxRadius = "0.7rem";
        let gradientBoxValue = Spacing["750"];
        let contentBoxValue = defaultContentBoxRadius;
        if (withLabel) {
            const noTopLeftBorder = "0%";
            gradientBoxValue = `${noTopLeftBorder} ${Spacing["750"]} ${Spacing["750"]} ${Spacing["750"]}`;
            contentBoxValue = `${noTopLeftBorder} ${defaultContentBoxRadius} ${defaultContentBoxRadius} ${defaultContentBoxRadius}`;
        }
        return {
            gradientBoxValue,
            contentBoxValue
        };
    }, [
        withLabel
    ]);
    const contentBoxPadding = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if ("small" === size) return Spacing["750"];
        return `${Spacing["1500"]} ${Spacing["1000"]}`;
    }, [
        size
    ]);
    const defaultClassname = "";
    const propsClassName = otherProps.className ?? defaultClassname;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxOutlinedWithGradient, {
        ...otherProps,
        sx: {
            ...otherProps.sx,
            borderRadius: borderRadiusConfig.gradientBoxValue
        },
        className: propsClassName + gradientClassName,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
            className: boxContentClassName,
            sx: {
                padding: contentBoxPadding,
                borderRadius: borderRadiusConfig.contentBoxValue
            },
            children: children
        })
    });
}
const noResultsText = "Prova a cercare di nuovo";
const noResultsTitle = "Nessun risultato trovato";
const defaultStartTypingText = "Inizia a digitare per cercare";
const defaultMultipleSelectionInstructionText = "Per favore, seleziona almeno un elemento";
const defaultSingleSelectionInstructionText = "Per favore, seleziona un elemento";
const NO_GAP = 0;
const sampleItems = [
    {
        id: 1,
        label: "Option 1",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 2,
        label: "Option 2",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 3,
        label: "Option 3",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 4,
        label: "Disabled Option",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {}),
        disabled: true
    }
];
const searchableSampleItems = [
    {
        id: 1,
        label: "Apple",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 2,
        label: "Banana",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 3,
        label: "Cherry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 4,
        label: "Date",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    },
    {
        id: 5,
        label: "Elderberry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 6,
        label: "Fig",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 7,
        label: "Grape",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 8,
        label: "Honeydew",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    }
];
const searchableSampleItemsLongList = [
    {
        id: 1,
        label: "Apple",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 2,
        label: "Banana",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 3,
        label: "Cherry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 4,
        label: "Date",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    },
    {
        id: 5,
        label: "Elderberry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 6,
        label: "Fig",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 7,
        label: "Grape",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 8,
        label: "Honeydew",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    },
    {
        id: 9,
        label: "Kiwi",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 10,
        label: "Lemon",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 11,
        label: "Mango",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 12,
        label: "Nectarine",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    },
    {
        id: 13,
        label: "Orange",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 14,
        label: "Papaya",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 15,
        label: "Quince",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 16,
        label: "Raspberry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {})
    },
    {
        id: 17,
        label: "Strawberry",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    },
    {
        id: 18,
        label: "Tangerine",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {})
    },
    {
        id: 19,
        label: "Ugli",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {})
    },
    {
        id: 20,
        label: "Watermelon",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {})
    }
];
const countryItems = [
    {
        id: "italy",
        label: "Italy",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FlagImage, {
            countryCode: "IT"
        })
    },
    {
        id: "france",
        label: "France",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FlagImage, {
            countryCode: "FR"
        })
    }
];
const emojiItems = [
    {
        id: 1,
        label: "Happy",
        emoji: "\uD83D\uDE0A"
    },
    {
        id: 2,
        label: "Sad",
        emoji: "\uD83D\uDE22"
    },
    {
        id: 3,
        label: "Excited",
        emoji: "\uD83C\uDF89"
    }
];
const IconListSelectorItemEndIconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ selected })=>({
        display: displaying_Displaying.flex,
        visibility: selected ? "visible" : "hidden",
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        padding: Spacing["500"],
        fontSize: typography_FontSize.normal
    }));
function IconListSelectorItemEndIcon({ selected, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemEndIconWrapper, {
        selected: selected,
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
            fontSize: "inherit",
            color: PRIMARY_COLOR
        })
    });
}
const icon_list_selector_item_end_icon = IconListSelectorItemEndIcon;
function IconListSelectorItemLabel({ label, ...props }) {
    const isSingleWord = 1 === label.trim().split(/\s+/).length;
    const truncateSingleWordSxProps = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    };
    const sxProps = isSingleWord ? truncateSingleWordSxProps : {};
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ...props,
        sx: {
            flex: 1,
            minWidth: 0
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "subtitle1",
            sx: sxProps,
            children: label
        })
    });
}
const icon_list_selector_item_label = IconListSelectorItemLabel;
const IconListSelectorItemIconEmojiWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("span")({
    lineHeight: 1
});
function IconListSelectorItemStartIcon({ icon, emoji, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.baseline,
        padding: Spacing["500"],
        ...props,
        children: [
            emoji && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemIconEmojiWrapper, {
                children: emoji
            }),
            icon ?? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const icon_list_selector_item_wrapper_defaultBorderStyle = `1px solid ${Border.main}`;
const hiddenBorderStyle = "none";
const IconListSelectorItemWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
    shouldForwardProp: (prop)=>"hideBorder" !== prop
})(({ selected, disabled, hideBorder })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        borderRadius: Spacing["750"],
        border: hideBorder ? hiddenBorderStyle : icon_list_selector_item_wrapper_defaultBorderStyle,
        padding: Spacing["750"],
        alignItems: alignment_Alignment.center,
        backgroundColor: selected && !disabled ? Background["default"] : White.main,
        opacity: disabled ? 0.5 : 1,
        ...!disabled && {
            "&:hover": {
                cursor: cursor_style_CursorStyle.pointer,
                backgroundColor: Background["default"]
            }
        }
    }));
function IconListSelectorItem({ selected, disabled, label, icon, emoji, onClick, hideBorder = false, ...props }) {
    const handleClick = disabled ? void 0 : onClick;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorItemWrapper, {
        ...props,
        selected: selected,
        disabled: disabled,
        hideBorder: hideBorder,
        onClick: handleClick,
        children: [
            (icon || emoji) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemStartIcon, {
                icon: icon,
                emoji: emoji
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_item_label, {
                label: label
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_item_end_icon, {
                selected: selected
            })
        ]
    });
}
const IconListSelectorContentWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    flex: "1 1 auto",
    minHeight: 0,
    overflowY: "auto",
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    paddingBottom: Spacing["500"]
});
const IconListSelectorSearchInfoWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.center
});
function IconListSelectorSearchInfo({ subtitle, title }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorSearchInfoWrapper, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SearchTextDuotone, {
                fontSize: "large"
            }),
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "h5",
                marginTop: Spacing["500"],
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "body1",
                marginTop: Spacing["1000"],
                children: subtitle
            })
        ]
    });
}
const icon_list_selector_search_info = IconListSelectorSearchInfo;
const ZERO_MIN_HEIGHT = 0;
const FLEX_1_1_AUTO = "1 1 auto";
const IconListSelectorWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    flex: FLEX_1_1_AUTO,
    minHeight: ZERO_MIN_HEIGHT,
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column
});
function IconListSelector({ items, multiple, value, defaultValue, searchValue, listWrapperSxProps, onChange, onSearchChange, disabled = false, searchable = false, searchPlaceholder = "Cerca", startTypingText = defaultStartTypingText, noResultsText: customNoResultsText = noResultsText, loading = false, loadingText = "Ricerca in corso...", selectionInstructionText, forceCheck, scrollContainerId, disableLocalFiltering = false, hideBorder = false, ...props }) {
    const [internalValue, setInternalValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(function() {
        if (void 0 !== value) return value;
        if (void 0 !== defaultValue) return defaultValue;
        return multiple ? [] : "";
    });
    const [internalSearchValue, setInternalSearchValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const currentSearchValue = void 0 !== searchValue ? searchValue : internalSearchValue;
    const currentValue = value ?? internalValue;
    const selectedIds = [];
    if (Array.isArray(currentValue)) selectedIds.push(...currentValue);
    else if (currentValue) selectedIds.push(currentValue);
    const hasSelection = selectedIds.length > 0;
    const defaultSelectionInstruction = multiple ? defaultMultipleSelectionInstructionText : defaultSingleSelectionInstructionText;
    const currentSelectionInstructionText = selectionInstructionText ?? defaultSelectionInstruction;
    const filteredItems = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        let result = [
            ...items
        ];
        if (searchable && !disableLocalFiltering && currentSearchValue.trim()) {
            const searchQuery = currentSearchValue.toLowerCase().trim();
            result = items.filter((item)=>item.label.toLowerCase().includes(searchQuery));
        }
        if (searchable) result = [
            ...result
        ].sort((a, b)=>{
            const aSelected = selectedIds.includes(a.id);
            const bSelected = selectedIds.includes(b.id);
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return 0;
        });
        return result;
    }, [
        items,
        searchable,
        currentSearchValue,
        disableLocalFiltering,
        selectedIds
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (forceCheck) {
            const timeoutId = setTimeout(()=>{
                forceCheck();
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        filteredItems,
        forceCheck
    ]);
    const handleItemClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((itemId)=>{
        if (disabled) return;
        let newValue;
        if (multiple) {
            const currentArray = Array.isArray(currentValue) ? currentValue : [];
            newValue = currentArray.includes(itemId) ? currentArray.filter((id)=>id !== itemId) : [
                ...currentArray,
                itemId
            ];
        } else newValue = selectedIds.includes(itemId) ? "" : itemId;
        if (void 0 === value) setInternalValue(newValue);
        onChange?.(newValue);
    }, [
        multiple,
        currentValue,
        selectedIds,
        disabled,
        value,
        onChange
    ]);
    const handleSearchChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const newSearchValue = event.target.value;
        if (void 0 === searchValue) setInternalSearchValue(newSearchValue);
        onSearchChange?.(newSearchValue);
    }, [
        searchValue,
        onSearchChange
    ]);
    const handleClearSearch = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (void 0 === searchValue) setInternalSearchValue("");
        onSearchChange?.("");
    }, [
        searchValue,
        onSearchChange
    ]);
    const renderContent = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (loading) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info, {
            subtitle: loadingText
        });
        if (0 === filteredItems.length && searchable) {
            if (currentSearchValue.trim()) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info, {
                subtitle: customNoResultsText,
                title: noResultsTitle
            });
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info, {
                subtitle: startTypingText
            });
        }
        return filteredItems.map((item)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItem, {
                label: item.label,
                icon: item.icon,
                emoji: item.emoji,
                selected: selectedIds.includes(item.id),
                disabled: disabled || item.disabled,
                hideBorder: hideBorder,
                onClick: ()=>handleItemClick(item.id)
            }, item.id));
    }, [
        loading,
        loadingText,
        filteredItems,
        searchable,
        currentSearchValue,
        customNoResultsText,
        noResultsTitle,
        startTypingText,
        selectedIds,
        disabled,
        hideBorder,
        handleItemClick
    ]);
    const computedGap = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (multiple) return Spacing["750"];
        return hideBorder ? NO_GAP : Spacing["750"];
    }, [
        multiple,
        hideBorder
    ]);
    const shouldShowSelectionInstruction = searchable && !loading && filteredItems.length > 0 && !hasSelection;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorWrapper, {
        ...props,
        children: [
            searchable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
                startIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SearchOutlined, {
                    color: "action"
                }),
                endIcon: currentSearchValue ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TimesSolid, {
                    color: "action"
                }) : void 0,
                onEndIconClick: currentSearchValue ? handleClearSearch : void 0,
                placeholder: searchPlaceholder ?? "Cerca",
                value: currentSearchValue,
                onChange: handleSearchChange,
                disabled: disabled,
                size: "medium",
                sx: {
                    marginBottom: Spacing["1500"]
                }
            }),
            shouldShowSelectionInstruction && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                marginBottom: Spacing["750"],
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "subtitle2",
                    children: currentSelectionInstructionText
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorContentWrapper, {
                id: scrollContainerId,
                gap: computedGap,
                sx: listWrapperSxProps,
                onScroll: ()=>{
                    forceCheck?.();
                },
                children: renderContent()
            })
        ]
    });
}
const IconListSelectorItemContentWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    alignItems: alignment_Alignment.center,
    gap: Spacing["500"],
    flex: 1
});
var lodash_isFunction = __webpack_require__("./node_modules/lodash/isFunction.js");
var isFunction_default = /*#__PURE__*/ __webpack_require__.n(lodash_isFunction);
function IconListSelectorItemEndSlotV2Wrapper({ children, disabled }) {
    const handleClick = (event)=>{
        event.stopPropagation();
        if (children.props.onClick && isFunction_default()(children.props.onClick)) children.props.onClick(event);
    };
    const enhancedProps = {
        ...children.props,
        onClick: disabled ? void 0 : handleClick,
        disabled
    };
    const childrenWithClickHandlerOverride = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(children, enhancedProps);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.center,
        marginLeft: Spacing["250"],
        children: childrenWithClickHandlerOverride
    });
}
function IconListSelectorItemLabelV2({ label, ...props }) {
    const isSingleWord = 1 === label.trim().split(/\s+/).length;
    const truncateSingleWordSxProps = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    };
    const sxProps = isSingleWord ? truncateSingleWordSxProps : {};
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ...props,
        sx: {
            flex: 1,
            minWidth: 0
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "subtitle1",
            sx: sxProps,
            children: label
        })
    });
}
const components_icon_list_selector_item_label = IconListSelectorItemLabelV2;
const IconListSelectorItemIconEmojiWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("span")({
    lineHeight: 1,
    fontSize: typography_FontSize.normal
});
function IconListSelectorItemMainIconV2({ icon, emoji, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.baseline,
        padding: Spacing["500"],
        ...props,
        children: [
            emoji && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemIconEmojiWrapperV2, {
                children: emoji
            }),
            icon ?? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const IconListSelectorItemSelectedIconWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.center,
    fontSize: typography_FontSize.normal
});
function IconListSelectorItemSelectedIconV2({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemSelectedIconWrapperV2, {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
            fontSize: "inherit",
            color: PRIMARY_COLOR
        })
    });
}
const icon_list_selector_item_selected_icon = IconListSelectorItemSelectedIconV2;
const BORDER_STYLES = {
    default: `1px solid ${Border.main}`,
    hidden: "none",
    dark: `1px solid ${Border.dark}`
};
const OPACITY = {
    disabled: 0.5,
    enabled: 1
};
const icon_list_selector_item_wrapper_getBorderStyle = (hideBorder, selected)=>{
    if (hideBorder) return selected ? BORDER_STYLES.dark : BORDER_STYLES.hidden;
    return BORDER_STYLES.default;
};
const getBackgroundColor = (selected, disabled)=>{
    if (selected && !disabled) return Background["default"];
    return White.main;
};
const IconListSelectorItemWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
    shouldForwardProp: (prop)=>"hideBorder" !== prop
})(({ selected = false, disabled = false, hideBorder = false })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.row,
        alignItems: alignment_Alignment.center,
        padding: Spacing["750"],
        borderRadius: Spacing["750"],
        border: icon_list_selector_item_wrapper_getBorderStyle(hideBorder, selected),
        backgroundColor: getBackgroundColor(selected, disabled),
        opacity: disabled ? OPACITY.disabled : OPACITY.enabled,
        ...!disabled && {
            "&:hover": {
                cursor: cursor_style_CursorStyle.pointer,
                backgroundColor: Background["default"]
            }
        }
    }));
function IconListSelectorItemV2({ selected, disabled, label, icon, emoji, endSlot, onClick, hideBorder = false, ...props }) {
    const handleClick = disabled ? void 0 : onClick;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorItemWrapperV2, {
        ...props,
        selected: selected,
        disabled: disabled,
        hideBorder: hideBorder,
        onClick: handleClick,
        gap: Spacing["500"],
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                flexDirection: direction_Direction.row,
                alignItems: alignment_Alignment.center,
                gap: Spacing["250"],
                children: [
                    selected && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_item_selected_icon, {}),
                    (icon || emoji) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemMainIconV2, {
                        icon: icon,
                        emoji: emoji
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(components_icon_list_selector_item_label, {
                label: label
            }),
            endSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemEndSlotV2Wrapper, {
                disabled: disabled,
                children: endSlot
            })
        ]
    });
}
const IconListSelectorItemContentWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box)({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.row,
    alignItems: alignment_Alignment.center,
    gap: Spacing["500"],
    flex: 1
});
const CHECK_CIRCLE_OUTLINED_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleOutlined, {
    fontSize: "inherit"
});
const CHECK_CIRCLE_SOLID_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
    fontSize: "inherit"
});
const STAR_OUTLINED_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarOutlined, {
    fontSize: "inherit"
});
const HOME_OUTLINED_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {
    fontSize: "inherit"
});
const FLAG_IT_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FlagIT, {
    fontSize: "inherit"
});
const FLAG_FR_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FlagFR, {
    fontSize: "inherit"
});
const FLAG_ES_ICON = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FlagES, {
    fontSize: "inherit"
});
const noResultsTextV2 = "Prova a cercare di nuovo";
const noResultsTitleV2 = "Nessun risultato trovato";
const defaultStartTypingTextV2 = "Inizia a digitare per cercare";
const defaultMultipleSelectionInstructionTextV2 = "Per favore, seleziona almeno un elemento";
const defaultSingleSelectionInstructionTextV2 = "Per favore, seleziona un elemento";
const NO_GAP_V2 = 0;
const createIconItem = (id, label, icon, disabled)=>({
        id,
        label,
        icon,
        ...disabled && {
            disabled
        }
    });
const createEmojiItem = (id, label, emoji)=>({
        id,
        label,
        emoji
    });
const baseFruitItems = [
    createIconItem(1, "Apple", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(2, "Banana", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(3, "Cherry", STAR_OUTLINED_ICON),
    createIconItem(4, "Date", HOME_OUTLINED_ICON),
    createIconItem(5, "Elderberry", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(6, "Fig", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(7, "Grape", STAR_OUTLINED_ICON),
    createIconItem(8, "Honeydew", HOME_OUTLINED_ICON)
];
const sampleItemsV2 = [
    createIconItem(1, "Option 1", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(2, "Option 2", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(3, "Option 3", STAR_OUTLINED_ICON),
    createIconItem(4, "Disabled Option", HOME_OUTLINED_ICON, true)
];
const searchableSampleItemsV2 = baseFruitItems;
const searchableSampleItemsLongListV2 = [
    ...baseFruitItems,
    createIconItem(9, "Kiwi", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(10, "Lemon", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(11, "Mango", STAR_OUTLINED_ICON),
    createIconItem(12, "Nectarine", HOME_OUTLINED_ICON),
    createIconItem(13, "Orange", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(14, "Papaya", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(15, "Quince", STAR_OUTLINED_ICON),
    createIconItem(16, "Raspberry", HOME_OUTLINED_ICON),
    createIconItem(17, "Strawberry", CHECK_CIRCLE_OUTLINED_ICON),
    createIconItem(18, "Tangerine", CHECK_CIRCLE_SOLID_ICON),
    createIconItem(19, "Ugli", STAR_OUTLINED_ICON),
    createIconItem(20, "Watermelon", CHECK_CIRCLE_OUTLINED_ICON)
];
const countryItemsV2 = [
    createIconItem("italy", "Italy", FLAG_IT_ICON),
    createIconItem("france", "France", FLAG_FR_ICON),
    createIconItem("spain", "Spain", FLAG_ES_ICON)
];
const emojiItemsV2 = [
    createEmojiItem(1, "Happy", "\uD83D\uDE0A"),
    createEmojiItem(2, "Sad", "\uD83D\uDE22"),
    createEmojiItem(3, "Excited", "\uD83C\uDF89")
];
const endSlotElement = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
    variant: "small-icon",
    onClick: ()=>{
        alert("clicked icon");
    },
    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.QuestionCircleOutlined, {})
});
const endSlotItemsV2 = [
    {
        ...createIconItem("italy", "Italy", FLAG_IT_ICON),
        endSlot: endSlotElement
    },
    {
        ...createIconItem("france", "France", FLAG_FR_ICON),
        endSlot: endSlotElement
    }
];
const IconListSelectorContentWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    flex: "1 1 auto",
    minHeight: 0,
    overflowY: "auto",
    scrollBehavior: "smooth",
    scrollbarWidth: "none",
    paddingBottom: Spacing["500"]
});
const IconListSelectorSearchInfoWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.center
});
function IconListSelectorSearchInfoV2({ subtitle, title }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorSearchInfoWrapperV2, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SearchTextDuotone, {
                fontSize: "large"
            }),
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "h5",
                marginTop: Spacing["500"],
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                variant: "body1",
                marginTop: Spacing["1000"],
                children: subtitle
            })
        ]
    });
}
const icon_list_selector_search_info_icon_list_selector_search_info = IconListSelectorSearchInfoV2;
const icon_list_selector_wrapper_ZERO_MIN_HEIGHT = 0;
const icon_list_selector_wrapper_FLEX_1_1_AUTO = "1 1 auto";
const IconListSelectorWrapperV2 = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    flex: icon_list_selector_wrapper_FLEX_1_1_AUTO,
    minHeight: icon_list_selector_wrapper_ZERO_MIN_HEIGHT,
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column
});
function IconListSelectorV2({ items, multiple, value, defaultValue, searchValue, listWrapperSxProps, onChange, onSearchChange, disabled = false, searchable = false, searchPlaceholder = "Cerca", startTypingText = defaultStartTypingTextV2, noResultsText: customNoResultsText = noResultsTextV2, loading = false, loadingText = "Ricerca in corso...", selectionInstructionText, forceCheck, scrollContainerId, disableLocalFiltering = false, hideBorder = false, ...props }) {
    const [internalValue, setInternalValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(function() {
        if (void 0 !== value) return value;
        if (void 0 !== defaultValue) return defaultValue;
        return multiple ? [] : "";
    });
    const [internalSearchValue, setInternalSearchValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)("");
    const currentSearchValue = void 0 !== searchValue ? searchValue : internalSearchValue;
    const currentValue = value ?? internalValue;
    const selectedIds = [];
    if (Array.isArray(currentValue)) selectedIds.push(...currentValue);
    else if (currentValue) selectedIds.push(currentValue);
    const hasSelection = selectedIds.length > 0;
    const defaultSelectionInstruction = multiple ? defaultMultipleSelectionInstructionTextV2 : defaultSingleSelectionInstructionTextV2;
    const currentSelectionInstructionText = selectionInstructionText ?? defaultSelectionInstruction;
    const filteredItems = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        let result = [
            ...items
        ];
        if (searchable && !disableLocalFiltering && currentSearchValue.trim()) {
            const searchQuery = currentSearchValue.toLowerCase().trim();
            result = items.filter((item)=>item.label.toLowerCase().includes(searchQuery));
        }
        if (searchable) result = [
            ...result
        ].sort((a, b)=>{
            const aSelected = selectedIds.includes(a.id);
            const bSelected = selectedIds.includes(b.id);
            if (aSelected && !bSelected) return -1;
            if (!aSelected && bSelected) return 1;
            return 0;
        });
        return result;
    }, [
        items,
        searchable,
        currentSearchValue,
        disableLocalFiltering,
        selectedIds
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (forceCheck) {
            const timeoutId = setTimeout(()=>{
                forceCheck();
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        filteredItems,
        forceCheck
    ]);
    const handleItemClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((itemId)=>{
        if (disabled) return;
        let newValue;
        if (multiple) {
            const currentArray = Array.isArray(currentValue) ? currentValue : [];
            newValue = currentArray.includes(itemId) ? currentArray.filter((id)=>id !== itemId) : [
                ...currentArray,
                itemId
            ];
        } else newValue = selectedIds.includes(itemId) ? "" : itemId;
        if (void 0 === value) setInternalValue(newValue);
        onChange?.(newValue);
    }, [
        multiple,
        currentValue,
        selectedIds,
        disabled,
        value,
        onChange
    ]);
    const handleSearchChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((event)=>{
        const newSearchValue = event.target.value;
        if (void 0 === searchValue) setInternalSearchValue(newSearchValue);
        onSearchChange?.(newSearchValue);
    }, [
        searchValue,
        onSearchChange
    ]);
    const handleClearSearch = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (void 0 === searchValue) setInternalSearchValue("");
        onSearchChange?.("");
    }, [
        searchValue,
        onSearchChange
    ]);
    const renderContent = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(()=>{
        if (loading) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info_icon_list_selector_search_info, {
            subtitle: loadingText
        });
        if (0 === filteredItems.length && searchable) {
            if (currentSearchValue.trim()) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info_icon_list_selector_search_info, {
                subtitle: customNoResultsText,
                title: noResultsTitleV2
            });
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_list_selector_search_info_icon_list_selector_search_info, {
                subtitle: startTypingText
            });
        }
        return filteredItems.map((item)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorItemV2, {
                label: item.label,
                icon: item.icon,
                emoji: item.emoji,
                selected: selectedIds.includes(item.id),
                disabled: disabled || item.disabled,
                hideBorder: hideBorder,
                onClick: ()=>handleItemClick(item.id),
                endSlot: item.endSlot
            }, item.id));
    }, [
        loading,
        loadingText,
        filteredItems,
        searchable,
        currentSearchValue,
        customNoResultsText,
        noResultsTitleV2,
        startTypingText,
        selectedIds,
        disabled,
        hideBorder,
        handleItemClick
    ]);
    const computedGap = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (multiple) return Spacing["750"];
        return hideBorder ? NO_GAP_V2 : Spacing["750"];
    }, [
        multiple,
        hideBorder
    ]);
    const shouldShowSelectionInstruction = searchable && !loading && filteredItems.length > 0 && !hasSelection;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(IconListSelectorWrapperV2, {
        ...props,
        children: [
            searchable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
                startIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SearchOutlined, {
                    color: "action"
                }),
                endIcon: currentSearchValue ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TimesSolid, {
                    color: "action"
                }) : void 0,
                onEndIconClick: currentSearchValue ? handleClearSearch : void 0,
                placeholder: searchPlaceholder ?? "Cerca",
                value: currentSearchValue,
                onChange: handleSearchChange,
                disabled: disabled,
                size: "medium",
                sx: {
                    marginBottom: Spacing["1500"]
                }
            }),
            shouldShowSelectionInstruction && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                marginBottom: Spacing["750"],
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                    variant: "subtitle2",
                    children: currentSelectionInstructionText
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconListSelectorContentWrapperV2, {
                id: scrollContainerId,
                gap: computedGap,
                sx: listWrapperSxProps,
                onScroll: ()=>{
                    forceCheck?.();
                },
                children: renderContent()
            })
        ]
    });
}
const DEFAULT_CARD_BORDER = `1px solid ${theme_theme.palette.border.main}`;
const CustomCard = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(function({ isMobile, maxWidth }) {
    const selectedPadding = isMobile ? Spacing["1000"] : Spacing["1500"];
    return {
        maxWidth,
        borderRadius: BorderRadius.paper,
        boxShadow: NONE_OPTION,
        paddingLeft: selectedPadding,
        paddingRight: selectedPadding,
        paddingTop: selectedPadding,
        paddingBottom: selectedPadding,
        backgroundColor: theme_theme.palette.background.paper,
        border: DEFAULT_CARD_BORDER,
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.flexStart,
        flexWrap: wrapping_Wrapping.wrap,
        gap: Spacing["3000"]
    };
});
function CustomCardComponent({ isMobile, ...rest }) {
    const isCurrentlyMobile = use_is_mobile();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomCard, {
        isMobile: isMobile ?? isCurrentlyMobile,
        ...rest
    });
}
const DualGridCardLayourWrapper = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomCardComponent);
const CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column,
    gap: Spacing["1000"]
});
const DualGridCardLayoutColumn = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomBox);
const content_wrapper_CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], styledOptions)(({ gap })=>({
        display: displaying_Displaying.flex,
        flexWrap: wrapping_Wrapping.wrap,
        justifyContent: alignment_Alignment.flexStart,
        gap
    }));
const DualGridCardLayoutContentWrapper = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(content_wrapper_CustomBox);
const content_CustomBox = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    flexDirection: direction_Direction.column
});
const DualGridCardLayoutContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(content_CustomBox);
function GenerateDualGridCardLayoutElement({ titleContent, descriptionContent, startContent, endContent }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayoutColumn, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        children: titleContent
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        children: descriptionContent
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayoutContentWrapper, {
                gap: Spacing["2000"],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutContent, {
                        children: startContent
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutContent, {
                        children: endContent
                    })
                ]
            })
        ]
    });
}
const DualGridCardLayoutElement = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(GenerateDualGridCardLayoutElement);
function GenerateDualGridCardLayout({ startElement, endElement, maxWidth, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DualGridCardLayourWrapper, {
        maxWidth: maxWidth,
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutElement, {
                ...startElement
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayoutElement, {
                ...endElement
            })
        ]
    });
}
const DualGridCardLayout = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(GenerateDualGridCardLayout);
function formatCurrency(value, options) {
    const { locale = "it-IT", minimumFractionDigits = 2, maximumFractionDigits = 2 } = options ?? {};
    return value.toLocaleString(locale, {
        minimumFractionDigits,
        maximumFractionDigits
    });
}
var lodash_isNaN = __webpack_require__("./node_modules/lodash/isNaN.js");
var isNaN_default = /*#__PURE__*/ __webpack_require__.n(lodash_isNaN);
function GenerateIseeCardContent({ title, value, currency }) {
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useTheme)();
    const isValueParsableToNumber = !isNaN_default()(Number(value));
    if (isValueParsableToNumber) value = formatCurrency(Number(value));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                sx: theme.typography.body2,
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                component: "div",
                sx: theme.typography.body1,
                display: displaying_Displaying.flex,
                children: [
                    value,
                    isValueParsableToNumber && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        marginLeft: Spacing["250"],
                        color: "textSecondary",
                        children: currency
                    })
                ]
            })
        ]
    });
}
const IseeCardContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(GenerateIseeCardContent);
function GenerateIseeCard({ certificatedIseeTitle, certificatedIseeDescription, certificatedIseeValue, simulatedIseeTitle, simulatedIseeDescription, simulatedIseeValue, currentTitle = "Corrente", ordinaryTitle = "Ordinario", currency = "\u20AC", ...rest }) {
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useTheme)();
    const startElement = {
        titleContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
            sx: theme.typography.subtitle1,
            children: certificatedIseeTitle
        }),
        descriptionContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
            variant: "body2",
            children: certificatedIseeDescription
        }),
        startContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: ordinaryTitle,
            value: certificatedIseeValue.ordinary,
            currency: currency
        }),
        endContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: currentTitle,
            value: certificatedIseeValue.current,
            currency: currency
        })
    };
    const endElement = {
        titleContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
            sx: theme.typography.subtitle1,
            children: simulatedIseeTitle
        }),
        descriptionContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
            variant: "body2",
            children: simulatedIseeDescription
        }),
        startContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: ordinaryTitle,
            value: simulatedIseeValue.ordinary,
            currency: currency
        }),
        endContent: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IseeCardContent, {
            title: currentTitle,
            value: simulatedIseeValue.current,
            currency: currency
        })
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DualGridCardLayout, {
        startElement: startElement,
        endElement: endElement,
        ...rest
    });
}
const IseeCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(GenerateIseeCard);
function LinearProgress({ ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__["default"], {
        ...rest
    });
}
const containers_BoxWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"], styledOptions)(({ disablepadding = false })=>({
        padding: disablepadding ? "inherit" : Spacing["1000"]
    }));
const LeftSlotWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    minWidth: Spacing["3500"]
});
function NonInteractive({ primary, secondaryText, leftSlot, rightSlot, secondRightSlot, ...rest }) {
    const isPrimaryAString = "string" == typeof primary;
    const isSecondaryAString = "string" == typeof secondaryText;
    const primaryElement = isPrimaryAString ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "body1",
        children: primary
    }) : primary;
    const secondaryElement = isSecondaryAString ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "body2",
        children: secondaryText
    }) : secondaryText;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            leftSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemAvatar_037fd911__["default"], {
                "data-testid": rest?.buttonid,
                ...rest,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftSlotWrapper, {
                    children: leftSlot
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                disableTypography: true,
                primary: primaryElement,
                secondary: secondaryElement
            }),
            rightSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    rightSlot,
                    secondRightSlot
                ]
            })
        ]
    });
}
function Interactive({ primary, secondaryText, leftSlot, rightSlot, secondRightSlot, ...rest }) {
    const isPrimaryAString = "string" == typeof primary;
    const isSecondaryAString = "string" == typeof secondaryText;
    const primaryElement = isPrimaryAString ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "body1",
        children: primary
    }) : primary;
    const secondaryElement = isSecondaryAString ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
        variant: "body2",
        children: secondaryText
    }) : secondaryText;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemButton_105219b9__["default"], {
        "data-testid": rest?.buttonid,
        ...rest,
        children: [
            leftSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LeftSlotWrapper, {
                children: leftSlot
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItemText_b6429872__["default"], {
                disableTypography: true,
                primary: primaryElement,
                secondary: secondaryElement
            }),
            rightSlot && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                children: [
                    rightSlot,
                    secondRightSlot
                ]
            })
        ]
    });
}
function ListItem({ disablepadding, parentid, interactive = false, divider, ...rest }) {
    const { id = "listitem-id" } = rest;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(containers_BoxWrapper, {
        disablepadding: disablepadding,
        "data-testid": parentid,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_ListItem_695b112b__["default"], {
                alignItems: alignment_Alignment.center,
                id: id,
                "data-testid": id,
                children: [
                    !interactive && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NonInteractive, {
                        ...rest
                    }),
                    interactive && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Interactive, {
                        ...rest
                    })
                ]
            }),
            divider && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {})
        ]
    });
}
function AdminPanel() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
        width: "162",
        height: "22",
        viewBox: "0 0 162 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M5.088 19V7.8H9.232C10.128 7.8 10.8693 7.94933 11.456 8.248C12.0427 8.54667 12.48 8.95733 12.768 9.48C13.056 10.0027 13.2 10.5893 13.2 11.24C13.2 11.8587 13.0613 12.4293 12.784 12.952C12.5067 13.464 12.0747 13.88 11.488 14.2C10.9013 14.5093 10.1493 14.664 9.232 14.664H7.136V19H5.088ZM7.136 13H9.104C9.81867 13 10.3307 12.8453 10.64 12.536C10.96 12.216 11.12 11.784 11.12 11.24C11.12 10.6853 10.96 10.2533 10.64 9.944C10.3307 9.624 9.81867 9.464 9.104 9.464H7.136V13ZM17.1447 19.192C16.4621 19.192 15.9021 19.0853 15.4647 18.872C15.0274 18.648 14.7021 18.3547 14.4887 17.992C14.2754 17.6293 14.1687 17.2293 14.1687 16.792C14.1687 16.056 14.4567 15.4587 15.0327 15C15.6087 14.5413 16.4727 14.312 17.6247 14.312H19.6407V14.12C19.6407 13.576 19.4861 13.176 19.1767 12.92C18.8674 12.664 18.4834 12.536 18.0247 12.536C17.6087 12.536 17.2461 12.6373 16.9367 12.84C16.6274 13.032 16.4354 13.32 16.3607 13.704H14.3607C14.4141 13.128 14.6061 12.6267 14.9367 12.2C15.2781 11.7733 15.7154 11.448 16.2487 11.224C16.7821 10.9893 17.3794 10.872 18.0408 10.872C19.1714 10.872 20.0621 11.1547 20.7127 11.72C21.3634 12.2853 21.6888 13.0853 21.6888 14.12V19H19.9447L19.7527 17.72C19.5181 18.1467 19.1874 18.4987 18.7607 18.776C18.3447 19.0533 17.8061 19.192 17.1447 19.192ZM17.6087 17.592C18.1954 17.592 18.6487 17.4 18.9688 17.016C19.2994 16.632 19.5074 16.1573 19.5928 15.592H17.8487C17.3047 15.592 16.9154 15.6933 16.6807 15.896C16.4461 16.088 16.3287 16.328 16.3287 16.616C16.3287 16.9253 16.4461 17.1653 16.6807 17.336C16.9154 17.5067 17.2247 17.592 17.6087 17.592ZM23.7931 19V11.064H25.6011L25.7611 12.408C26.0065 11.9387 26.3585 11.5653 26.8171 11.288C27.2865 11.0107 27.8358 10.872 28.4651 10.872C29.4465 10.872 30.2091 11.1813 30.7531 11.8C31.2971 12.4187 31.5691 13.3253 31.5691 14.52V19H29.5211V14.712C29.5211 14.0293 29.3825 13.5067 29.1051 13.144C28.8278 12.7813 28.3958 12.6 27.8091 12.6C27.2331 12.6 26.7585 12.8027 26.3851 13.208C26.0225 13.6133 25.8411 14.1787 25.8411 14.904V19H23.7931ZM33.6775 19V11.064H35.4855L35.6455 12.408C35.8908 11.9387 36.2428 11.5653 36.7015 11.288C37.1708 11.0107 37.7202 10.872 38.3495 10.872C39.3308 10.872 40.0935 11.1813 40.6375 11.8C41.1815 12.4187 41.4535 13.3253 41.4535 14.52V19H39.4055V14.712C39.4055 14.0293 39.2668 13.5067 38.9895 13.144C38.7122 12.7813 38.2802 12.6 37.6935 12.6C37.1175 12.6 36.6428 12.8027 36.2695 13.208C35.9068 13.6133 35.7255 14.1787 35.7255 14.904V19H33.6775ZM47.4179 19.192C46.6179 19.192 45.9085 19.0213 45.2899 18.68C44.6712 18.3387 44.1859 17.8587 43.8339 17.24C43.4819 16.6213 43.3059 15.9067 43.3059 15.096C43.3059 14.2747 43.4765 13.544 43.8179 12.904C44.1699 12.264 44.6499 11.768 45.2579 11.416C45.8765 11.0533 46.6019 10.872 47.4339 10.872C48.2125 10.872 48.9005 11.0427 49.4979 11.384C50.0952 11.7253 50.5592 12.1947 50.8899 12.792C51.2312 13.3787 51.4019 14.0347 51.4019 14.76C51.4019 14.8773 51.3965 15 51.3859 15.128C51.3859 15.256 51.3805 15.3893 51.3699 15.528H45.3379C45.3805 16.1467 45.5939 16.632 45.9779 16.984C46.3725 17.336 46.8472 17.512 47.4019 17.512C47.8179 17.512 48.1645 17.4213 48.4419 17.24C48.7299 17.048 48.9432 16.8027 49.0819 16.504H51.1619C51.0125 17.0053 50.7619 17.464 50.4099 17.88C50.0685 18.2853 49.6419 18.6053 49.1299 18.84C48.6285 19.0747 48.0579 19.192 47.4179 19.192ZM47.4339 12.536C46.9325 12.536 46.4899 12.68 46.1059 12.968C45.7219 13.2453 45.4765 13.672 45.3699 14.248H49.3219C49.2899 13.7253 49.0979 13.3093 48.7459 13C48.3939 12.6907 47.9565 12.536 47.4339 12.536ZM53.2744 19V7.48H55.3224V19H53.2744ZM57.565 19V7.48H59.613V19H57.565ZM65.6636 19.192C64.8956 19.192 64.2023 19.016 63.5836 18.664C62.9756 18.312 62.4903 17.8267 62.1276 17.208C61.7756 16.5787 61.5996 15.8533 61.5996 15.032C61.5996 14.2107 61.781 13.4907 62.1436 12.872C62.5063 12.2427 62.9916 11.752 63.5996 11.4C64.2183 11.048 64.9116 10.872 65.6796 10.872C66.437 10.872 67.1196 11.048 67.7276 11.4C68.3463 11.752 68.8316 12.2427 69.1836 12.872C69.5463 13.4907 69.7276 14.2107 69.7276 15.032C69.7276 15.8533 69.5463 16.5787 69.1836 17.208C68.8316 17.8267 68.3463 18.312 67.7276 18.664C67.109 19.016 66.421 19.192 65.6636 19.192ZM65.6636 17.416C66.197 17.416 66.661 17.2187 67.0556 16.824C67.4503 16.4187 67.6476 15.8213 67.6476 15.032C67.6476 14.2427 67.4503 13.6507 67.0556 13.256C66.661 12.8507 66.2023 12.648 65.6796 12.648C65.1356 12.648 64.6663 12.8507 64.2716 13.256C63.8876 13.6507 63.6956 14.2427 63.6956 15.032C63.6956 15.8213 63.8876 16.4187 64.2716 16.824C64.6663 17.2187 65.1303 17.416 65.6636 17.416ZM78.4072 19.192C77.7246 19.192 77.1646 19.0853 76.7272 18.872C76.2899 18.648 75.9646 18.3547 75.7512 17.992C75.5379 17.6293 75.4312 17.2293 75.4312 16.792C75.4312 16.056 75.7192 15.4587 76.2952 15C76.8712 14.5413 77.7352 14.312 78.8872 14.312H80.9032V14.12C80.9032 13.576 80.7486 13.176 80.4392 12.92C80.1299 12.664 79.7459 12.536 79.2872 12.536C78.8712 12.536 78.5086 12.6373 78.1992 12.84C77.8899 13.032 77.6979 13.32 77.6232 13.704H75.6232C75.6766 13.128 75.8686 12.6267 76.1992 12.2C76.5406 11.7733 76.9779 11.448 77.5112 11.224C78.0446 10.9893 78.6419 10.872 79.3032 10.872C80.4339 10.872 81.3246 11.1547 81.9752 11.72C82.6259 12.2853 82.9512 13.0853 82.9512 14.12V19H81.2072L81.0152 17.72C80.7806 18.1467 80.4499 18.4987 80.0232 18.776C79.6072 19.0533 79.0686 19.192 78.4072 19.192ZM78.8712 17.592C79.4579 17.592 79.9112 17.4 80.2312 17.016C80.5619 16.632 80.7699 16.1573 80.8552 15.592H79.1112C78.5672 15.592 78.1779 15.6933 77.9432 15.896C77.7086 16.088 77.5912 16.328 77.5912 16.616C77.5912 16.9253 77.7086 17.1653 77.9432 17.336C78.1779 17.5067 78.4872 17.592 78.8712 17.592ZM88.7036 19.192C87.957 19.192 87.2903 19.0107 86.7036 18.648C86.117 18.2853 85.653 17.7893 85.3116 17.16C84.9703 16.5307 84.7996 15.816 84.7996 15.016C84.7996 14.216 84.9703 13.5067 85.3116 12.888C85.653 12.2587 86.117 11.768 86.7036 11.416C87.2903 11.0533 87.957 10.872 88.7036 10.872C89.301 10.872 89.8236 10.984 90.2716 11.208C90.7196 11.432 91.0823 11.7467 91.3596 12.152V7.48H93.4076V19H91.5836L91.3596 17.864C91.1036 18.216 90.7623 18.5253 90.3356 18.792C89.9196 19.0587 89.3756 19.192 88.7036 19.192ZM89.1356 17.4C89.797 17.4 90.3356 17.1813 90.7516 16.744C91.1783 16.296 91.3916 15.7253 91.3916 15.032C91.3916 14.3387 91.1783 13.7733 90.7516 13.336C90.3356 12.888 89.797 12.664 89.1356 12.664C88.485 12.664 87.9463 12.8827 87.5196 13.32C87.093 13.7573 86.8796 14.3227 86.8796 15.016C86.8796 15.7093 87.093 16.28 87.5196 16.728C87.9463 17.176 88.485 17.4 89.1356 17.4ZM95.6431 19V11.064H97.4511L97.6271 12.136C97.8831 11.752 98.2191 11.448 98.6351 11.224C99.0618 10.9893 99.5525 10.872 100.107 10.872C101.334 10.872 102.203 11.3467 102.715 12.296C103.003 11.8587 103.387 11.512 103.867 11.256C104.358 11 104.891 10.872 105.467 10.872C106.502 10.872 107.296 11.1813 107.851 11.8C108.406 12.4187 108.683 13.3253 108.683 14.52V19H106.635V14.712C106.635 14.0293 106.502 13.5067 106.235 13.144C105.979 12.7813 105.579 12.6 105.035 12.6C104.48 12.6 104.032 12.8027 103.691 13.208C103.36 13.6133 103.195 14.1787 103.195 14.904V19H101.147V14.712C101.147 14.0293 101.014 13.5067 100.747 13.144C100.48 12.7813 100.07 12.6 99.5151 12.6C98.9711 12.6 98.5285 12.8027 98.1871 13.208C97.8565 13.6133 97.6911 14.1787 97.6911 14.904V19H95.6431ZM111.882 9.832C111.508 9.832 111.199 9.72 110.954 9.496C110.719 9.272 110.602 8.98933 110.602 8.648C110.602 8.30667 110.719 8.02933 110.954 7.816C111.199 7.592 111.508 7.48 111.882 7.48C112.255 7.48 112.559 7.592 112.794 7.816C113.039 8.02933 113.162 8.30667 113.162 8.648C113.162 8.98933 113.039 9.272 112.794 9.496C112.559 9.72 112.255 9.832 111.882 9.832ZM110.858 19V11.064H112.906V19H110.858ZM115.193 19V11.064H117.001L117.161 12.408C117.406 11.9387 117.758 11.5653 118.217 11.288C118.686 11.0107 119.236 10.872 119.865 10.872C120.846 10.872 121.609 11.1813 122.153 11.8C122.697 12.4187 122.969 13.3253 122.969 14.52V19H120.921V14.712C120.921 14.0293 120.782 13.5067 120.505 13.144C120.228 12.7813 119.796 12.6 119.209 12.6C118.633 12.6 118.158 12.8027 117.785 13.208C117.422 13.6133 117.241 14.1787 117.241 14.904V19H115.193Z",
            fill: "#1246C8"
        })
    });
}
function Logo() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
        width: "150",
        height: "24",
        viewBox: "0 0 150 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M132.271 13.2899C131.48 15.0027 130.459 16.829 128.489 17.9615C125.057 19.9291 119.31 18.9657 119.818 13.534C121.576 14.7824 123.74 15.4126 125.936 15.3161C128.133 15.2196 130.225 14.4024 131.854 13.0051L132.286 13.262L132.271 13.2899Z",
                fill: "#00BB8C"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M133.515 10.6115C134.303 8.89871 135.327 7.07029 137.294 5.9377C140.727 3.97012 146.478 4.93357 145.966 10.376C144.208 9.12753 142.044 8.49738 139.847 8.59389C137.651 8.6904 135.558 9.50754 133.93 10.9048L133.898 10.9348L133.475 10.6864L133.515 10.6115Z",
                fill: "#DD4C77"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M145.713 18.6382H140.456L132.841 13.6496L131.883 13.0202L120.064 5.27405H125.32L145.713 18.6382Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M21.0444 10.9648C21.5312 11.0419 22.19 11.1168 22.8331 11.2539C23.8248 11.468 24.7055 11.8705 25.2829 12.7033C26.0618 13.8273 26.012 15.0113 25.4776 16.1931C24.898 17.4777 23.7183 18.0515 22.3712 18.362C21.1779 18.636 19.9576 18.6489 18.7349 18.6467C13.9801 18.6339 9.20951 18.6467 4.44795 18.6467H3.99512V5.27404C3.99512 5.27404 15.2934 5.25263 20.7183 5.27404C21.701 5.27404 22.6972 5.31472 23.6617 5.78574C25.1425 6.51582 25.9033 7.79614 25.2467 9.21134C24.8731 10.0014 24.135 10.3782 23.3176 10.5816C22.5002 10.785 21.6964 10.8556 21.0444 10.9648ZM13.7764 10.7165C15.5401 10.7165 17.0639 10.7165 18.8277 10.7165C19.3106 10.7176 19.7928 10.6833 20.27 10.6137C20.5525 10.5586 20.8062 10.4131 20.9885 10.2017C21.1708 9.99032 21.2705 9.72601 21.2708 9.45327C21.3047 8.86664 20.8836 8.38277 20.227 8.23933C19.7254 8.12986 19.2108 8.08307 18.6964 8.10016C15.205 8.08089 7.8578 8.08517 7.8578 8.08517V10.7229L13.7764 10.7165ZM13.7764 15.8741C15.5401 15.8741 17.7794 15.8741 19.5432 15.8741C20.0261 15.8754 20.5083 15.841 20.9855 15.7714C21.2699 15.7169 21.5256 15.5708 21.7089 15.358C21.8922 15.1453 21.9918 14.879 21.9908 14.6045C22.0247 14.0179 21.6036 13.534 20.947 13.3906C20.4454 13.2811 19.9308 13.2343 19.4164 13.2514C15.9251 13.2321 7.86912 13.2364 7.86912 13.2364V15.8891L13.7764 15.8741Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M116.593 7.3807C112.475 6.81975 101.758 5.61865 98.9848 8.8794C98.4756 9.53279 98.2611 10.3505 98.3884 11.1532C98.5158 11.9559 98.9745 12.6781 99.6641 13.1614C100.506 13.7437 101.586 13.9043 102.626 14.0028C104.84 14.2169 107.07 14.2169 109.294 14.3111C110.383 14.3539 111.485 14.3646 112.556 14.5766C112.9 14.6216 113.26 14.8164 113.29 15.1739C113.351 16.1417 111.544 16.101 110.836 16.1888C109.223 16.283 107.605 16.3151 105.988 16.2594C103.546 16.1589 101.12 15.8392 98.7426 15.3045C98.7426 16.238 98.7426 18.1713 98.7426 18.1713C101.301 18.683 103.928 18.7901 106.538 18.8757C109.269 18.9271 114.859 19.017 116.478 16.6405C117.223 15.6064 117.284 14.1056 116.437 13.1464C115.699 12.3093 114.483 12.0245 113.344 11.8618C110.797 11.5043 108.209 11.5471 105.646 11.4336C104.75 11.4262 103.857 11.3452 102.977 11.1917C102.792 11.1604 102.619 11.0869 102.472 10.9776C102.353 10.8765 102.278 10.7382 102.26 10.5885C102.242 10.4388 102.281 10.2879 102.372 10.164C102.59 9.94798 102.886 9.81604 103.201 9.7936C103.933 9.68686 104.671 9.61895 105.411 9.59021C107.929 9.46446 110.454 9.52746 112.962 9.77862C114.175 9.90494 115.384 10.0741 116.584 10.2753C116.584 9.41893 116.584 7.40639 116.584 7.40639",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M48.6384 9.41669C47.4769 8.18133 45.7244 7.50691 44.0467 7.15579C42.6889 6.89366 41.3071 6.75813 39.9213 6.75114C39.6225 6.75114 39.3236 6.73829 39.0157 6.73615C36.2239 6.71903 33.3145 6.96738 30.885 8.34404C29.3454 9.21543 28.4058 10.485 28.168 12.1829C28.016 13.2304 28.207 14.2968 28.7155 15.2385C29.2239 16.1802 30.0254 16.9519 31.0118 17.4497C33.3598 18.6979 36.1017 18.8542 38.7372 18.8885C40.424 18.9099 42.1335 18.8885 43.7908 18.5737C46.6301 18.0299 49.4739 16.6062 49.9426 13.6644C50.084 12.9092 50.04 12.1334 49.8138 11.3969C49.5877 10.6604 49.1855 9.98285 48.6384 9.41669ZM40.7138 15.9703H37.4874C34.6481 15.9703 32.3454 15.0411 32.3454 12.8937C32.3454 10.7462 34.6481 9.81705 37.4874 9.81705H40.7025C43.5214 9.83204 45.7991 10.7313 45.7991 12.8937C45.7991 15.0561 43.5282 15.951 40.7161 15.9703H40.7138Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M52.9697 18.6423V7.0509H57.0951V10.9646C57.0951 10.9646 58.1773 8.23915 61.0528 7.30996C63.6702 6.46855 65.9435 6.5392 68.4114 7.09586C70.739 7.61826 72.5571 9.56015 72.7337 11.7911C72.8537 13.2748 72.822 14.7692 72.8469 16.2593C72.8469 17.0429 72.8469 17.8437 72.8469 18.6444H68.7714V18.2697C68.7714 16.771 68.785 15.2616 68.7714 13.7587C68.7703 13.2818 68.7095 12.8068 68.5903 12.3435C68.4945 11.9632 68.3173 11.6055 68.0696 11.2925C67.822 10.9795 67.5091 10.7178 67.1503 10.5236C66.2242 10.0333 65.0559 9.93054 64.0144 9.8813C61.8408 9.80208 60.0317 10.2645 59.0332 10.6992C58.2453 11.0439 57.5502 11.5406 57.2218 12.3392C57.1266 12.5788 57.0775 12.8326 57.0769 13.0885C57.0769 14.8013 57.0769 18.6316 57.0769 18.6316L52.9697 18.6423Z",
                fill: "#1246C8"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                d: "M95.613 7.03613V18.6275H91.4899V14.7138C91.4899 14.7138 90.4076 17.4371 87.5254 18.3663C84.9057 19.2099 82.6325 19.1371 80.1668 18.5804C77.8347 18.0623 76.0188 16.1183 75.8377 13.8895C75.7199 12.4058 75.7516 10.9092 75.7267 9.41907C75.7132 8.6376 75.7267 7.83687 75.7267 7.03613H79.8023V7.40867C79.8023 8.90737 79.7864 10.4061 79.8023 11.9176C79.8041 12.3952 79.8656 12.871 79.9857 13.335C80.0813 13.7153 80.2584 14.073 80.5061 14.3861C80.7538 14.6991 81.0668 14.9607 81.4257 15.1548C82.3517 15.643 83.5178 15.7479 84.5593 15.7971C86.7329 15.8742 88.5442 15.4117 89.5405 14.9792C90.3284 14.6324 91.0258 14.1357 91.3518 13.3392C91.4479 13.0998 91.4977 12.846 91.499 12.5899C91.499 10.8771 91.499 7.04684 91.499 7.04684L95.613 7.03613Z",
                fill: "#1246C8"
            })
        ]
    });
}
function OperatorPanel() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
        width: "162",
        height: "23",
        viewBox: "0 0 162 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
            d: "M5.088 19V7.8H9.232C10.128 7.8 10.8693 7.94933 11.456 8.248C12.0427 8.54667 12.48 8.95733 12.768 9.48C13.056 10.0027 13.2 10.5893 13.2 11.24C13.2 11.8587 13.0613 12.4293 12.784 12.952C12.5067 13.464 12.0747 13.88 11.488 14.2C10.9013 14.5093 10.1493 14.664 9.232 14.664H7.136V19H5.088ZM7.136 13H9.104C9.81867 13 10.3307 12.8453 10.64 12.536C10.96 12.216 11.12 11.784 11.12 11.24C11.12 10.6853 10.96 10.2533 10.64 9.944C10.3307 9.624 9.81867 9.464 9.104 9.464H7.136V13ZM17.1447 19.192C16.4621 19.192 15.9021 19.0853 15.4647 18.872C15.0274 18.648 14.7021 18.3547 14.4887 17.992C14.2754 17.6293 14.1687 17.2293 14.1687 16.792C14.1687 16.056 14.4567 15.4587 15.0327 15C15.6087 14.5413 16.4727 14.312 17.6247 14.312H19.6407V14.12C19.6407 13.576 19.4861 13.176 19.1767 12.92C18.8674 12.664 18.4834 12.536 18.0247 12.536C17.6087 12.536 17.2461 12.6373 16.9367 12.84C16.6274 13.032 16.4354 13.32 16.3607 13.704H14.3607C14.4141 13.128 14.6061 12.6267 14.9367 12.2C15.2781 11.7733 15.7154 11.448 16.2487 11.224C16.7821 10.9893 17.3794 10.872 18.0408 10.872C19.1714 10.872 20.0621 11.1547 20.7127 11.72C21.3634 12.2853 21.6888 13.0853 21.6888 14.12V19H19.9447L19.7527 17.72C19.5181 18.1467 19.1874 18.4987 18.7607 18.776C18.3447 19.0533 17.8061 19.192 17.1447 19.192ZM17.6087 17.592C18.1954 17.592 18.6487 17.4 18.9688 17.016C19.2994 16.632 19.5074 16.1573 19.5928 15.592H17.8487C17.3047 15.592 16.9154 15.6933 16.6807 15.896C16.4461 16.088 16.3287 16.328 16.3287 16.616C16.3287 16.9253 16.4461 17.1653 16.6807 17.336C16.9154 17.5067 17.2247 17.592 17.6087 17.592ZM23.7931 19V11.064H25.6011L25.7611 12.408C26.0065 11.9387 26.3585 11.5653 26.8171 11.288C27.2865 11.0107 27.8358 10.872 28.4651 10.872C29.4465 10.872 30.2091 11.1813 30.7531 11.8C31.2971 12.4187 31.5691 13.3253 31.5691 14.52V19H29.5211V14.712C29.5211 14.0293 29.3825 13.5067 29.1051 13.144C28.8278 12.7813 28.3958 12.6 27.8091 12.6C27.2331 12.6 26.7585 12.8027 26.3851 13.208C26.0225 13.6133 25.8411 14.1787 25.8411 14.904V19H23.7931ZM33.6775 19V11.064H35.4855L35.6455 12.408C35.8908 11.9387 36.2428 11.5653 36.7015 11.288C37.1708 11.0107 37.7202 10.872 38.3495 10.872C39.3308 10.872 40.0935 11.1813 40.6375 11.8C41.1815 12.4187 41.4535 13.3253 41.4535 14.52V19H39.4055V14.712C39.4055 14.0293 39.2668 13.5067 38.9895 13.144C38.7122 12.7813 38.2802 12.6 37.6935 12.6C37.1175 12.6 36.6428 12.8027 36.2695 13.208C35.9068 13.6133 35.7255 14.1787 35.7255 14.904V19H33.6775ZM47.4179 19.192C46.6179 19.192 45.9085 19.0213 45.2899 18.68C44.6712 18.3387 44.1859 17.8587 43.8339 17.24C43.4819 16.6213 43.3059 15.9067 43.3059 15.096C43.3059 14.2747 43.4765 13.544 43.8179 12.904C44.1699 12.264 44.6499 11.768 45.2579 11.416C45.8765 11.0533 46.6019 10.872 47.4339 10.872C48.2125 10.872 48.9005 11.0427 49.4979 11.384C50.0952 11.7253 50.5592 12.1947 50.8899 12.792C51.2312 13.3787 51.4019 14.0347 51.4019 14.76C51.4019 14.8773 51.3965 15 51.3859 15.128C51.3859 15.256 51.3805 15.3893 51.3699 15.528H45.3379C45.3805 16.1467 45.5939 16.632 45.9779 16.984C46.3725 17.336 46.8472 17.512 47.4019 17.512C47.8179 17.512 48.1645 17.4213 48.4419 17.24C48.7299 17.048 48.9432 16.8027 49.0819 16.504H51.1619C51.0125 17.0053 50.7619 17.464 50.4099 17.88C50.0685 18.2853 49.6419 18.6053 49.1299 18.84C48.6285 19.0747 48.0579 19.192 47.4179 19.192ZM47.4339 12.536C46.9325 12.536 46.4899 12.68 46.1059 12.968C45.7219 13.2453 45.4765 13.672 45.3699 14.248H49.3219C49.2899 13.7253 49.0979 13.3093 48.7459 13C48.3939 12.6907 47.9565 12.536 47.4339 12.536ZM53.2744 19V7.48H55.3224V19H53.2744ZM57.565 19V7.48H59.613V19H57.565ZM65.6636 19.192C64.8956 19.192 64.2023 19.016 63.5836 18.664C62.9756 18.312 62.4903 17.8267 62.1276 17.208C61.7756 16.5787 61.5996 15.8533 61.5996 15.032C61.5996 14.2107 61.781 13.4907 62.1436 12.872C62.5063 12.2427 62.9916 11.752 63.5996 11.4C64.2183 11.048 64.9116 10.872 65.6796 10.872C66.437 10.872 67.1196 11.048 67.7276 11.4C68.3463 11.752 68.8316 12.2427 69.1836 12.872C69.5463 13.4907 69.7276 14.2107 69.7276 15.032C69.7276 15.8533 69.5463 16.5787 69.1836 17.208C68.8316 17.8267 68.3463 18.312 67.7276 18.664C67.109 19.016 66.421 19.192 65.6636 19.192ZM65.6636 17.416C66.197 17.416 66.661 17.2187 67.0556 16.824C67.4503 16.4187 67.6476 15.8213 67.6476 15.032C67.6476 14.2427 67.4503 13.6507 67.0556 13.256C66.661 12.8507 66.2023 12.648 65.6796 12.648C65.1356 12.648 64.6663 12.8507 64.2716 13.256C63.8876 13.6507 63.6956 14.2427 63.6956 15.032C63.6956 15.8213 63.8876 16.4187 64.2716 16.824C64.6663 17.2187 65.1303 17.416 65.6636 17.416ZM79.4792 19.192C78.7112 19.192 78.0179 19.016 77.3992 18.664C76.7912 18.312 76.3059 17.8267 75.9432 17.208C75.5912 16.5787 75.4152 15.8533 75.4152 15.032C75.4152 14.2107 75.5966 13.4907 75.9592 12.872C76.3219 12.2427 76.8072 11.752 77.4152 11.4C78.0339 11.048 78.7272 10.872 79.4952 10.872C80.2526 10.872 80.9352 11.048 81.5432 11.4C82.1619 11.752 82.6472 12.2427 82.9992 12.872C83.3619 13.4907 83.5432 14.2107 83.5432 15.032C83.5432 15.8533 83.3619 16.5787 82.9992 17.208C82.6472 17.8267 82.1619 18.312 81.5432 18.664C80.9246 19.016 80.2366 19.192 79.4792 19.192ZM79.4792 17.416C80.0126 17.416 80.4766 17.2187 80.8712 16.824C81.2659 16.4187 81.4632 15.8213 81.4632 15.032C81.4632 14.2427 81.2659 13.6507 80.8712 13.256C80.4766 12.8507 80.0179 12.648 79.4952 12.648C78.9512 12.648 78.4819 12.8507 78.0872 13.256C77.7032 13.6507 77.5112 14.2427 77.5112 15.032C77.5112 15.8213 77.7032 16.4187 78.0872 16.824C78.4819 17.2187 78.9459 17.416 79.4792 17.416ZM85.5244 22.52V11.064H87.3484L87.5724 12.2C87.8284 11.848 88.1644 11.5387 88.5804 11.272C89.007 11.0053 89.5564 10.872 90.2284 10.872C90.975 10.872 91.6417 11.0533 92.2284 11.416C92.815 11.7787 93.279 12.2747 93.6204 12.904C93.9617 13.5333 94.1324 14.248 94.1324 15.048C94.1324 15.848 93.9617 16.5627 93.6204 17.192C93.279 17.8107 92.815 18.3013 92.2284 18.664C91.6417 19.016 90.975 19.192 90.2284 19.192C89.631 19.192 89.1084 19.08 88.6604 18.856C88.2124 18.632 87.8497 18.3173 87.5724 17.912V22.52H85.5244ZM89.7964 17.4C90.447 17.4 90.9857 17.1813 91.4124 16.744C91.839 16.3067 92.0524 15.7413 92.0524 15.048C92.0524 14.3547 91.839 13.784 91.4124 13.336C90.9857 12.888 90.447 12.664 89.7964 12.664C89.135 12.664 88.591 12.888 88.1644 13.336C87.7484 13.7733 87.5404 14.3387 87.5404 15.032C87.5404 15.7253 87.7484 16.296 88.1644 16.744C88.591 17.1813 89.135 17.4 89.7964 17.4ZM99.9679 19.192C99.1679 19.192 98.4585 19.0213 97.8399 18.68C97.2212 18.3387 96.7359 17.8587 96.3839 17.24C96.0319 16.6213 95.8559 15.9067 95.8559 15.096C95.8559 14.2747 96.0265 13.544 96.3679 12.904C96.7199 12.264 97.1999 11.768 97.8079 11.416C98.4265 11.0533 99.1519 10.872 99.9839 10.872C100.763 10.872 101.451 11.0427 102.048 11.384C102.645 11.7253 103.109 12.1947 103.44 12.792C103.781 13.3787 103.952 14.0347 103.952 14.76C103.952 14.8773 103.947 15 103.936 15.128C103.936 15.256 103.931 15.3893 103.92 15.528H97.8879C97.9305 16.1467 98.1439 16.632 98.5279 16.984C98.9225 17.336 99.3972 17.512 99.9519 17.512C100.368 17.512 100.715 17.4213 100.992 17.24C101.28 17.048 101.493 16.8027 101.632 16.504H103.712C103.563 17.0053 103.312 17.464 102.96 17.88C102.619 18.2853 102.192 18.6053 101.68 18.84C101.179 19.0747 100.608 19.192 99.9679 19.192ZM99.9839 12.536C99.4825 12.536 99.0399 12.68 98.6559 12.968C98.2719 13.2453 98.0265 13.672 97.9199 14.248H101.872C101.84 13.7253 101.648 13.3093 101.296 13C100.944 12.6907 100.507 12.536 99.9839 12.536ZM105.824 19V11.064H107.648L107.84 12.552C108.128 12.04 108.518 11.6347 109.008 11.336C109.51 11.0267 110.096 10.872 110.768 10.872V13.032H110.192C109.744 13.032 109.344 13.1013 108.992 13.24C108.64 13.3787 108.363 13.6187 108.16 13.96C107.968 14.3013 107.872 14.776 107.872 15.384V19H105.824ZM115.054 19.192C114.371 19.192 113.811 19.0853 113.374 18.872C112.937 18.648 112.611 18.3547 112.398 17.992C112.185 17.6293 112.078 17.2293 112.078 16.792C112.078 16.056 112.366 15.4587 112.942 15C113.518 14.5413 114.382 14.312 115.534 14.312H117.55V14.12C117.55 13.576 117.395 13.176 117.086 12.92C116.777 12.664 116.393 12.536 115.934 12.536C115.518 12.536 115.155 12.6373 114.846 12.84C114.537 13.032 114.345 13.32 114.27 13.704H112.27C112.323 13.128 112.515 12.6267 112.846 12.2C113.187 11.7733 113.625 11.448 114.158 11.224C114.691 10.9893 115.289 10.872 115.95 10.872C117.081 10.872 117.971 11.1547 118.622 11.72C119.273 12.2853 119.598 13.0853 119.598 14.12V19H117.854L117.662 17.72C117.427 18.1467 117.097 18.4987 116.67 18.776C116.254 19.0533 115.715 19.192 115.054 19.192ZM115.518 17.592C116.105 17.592 116.558 17.4 116.878 17.016C117.209 16.632 117.417 16.1573 117.502 15.592H115.758C115.214 15.592 114.825 15.6933 114.59 15.896C114.355 16.088 114.238 16.328 114.238 16.616C114.238 16.9253 114.355 17.1653 114.59 17.336C114.825 17.5067 115.134 17.592 115.518 17.592ZM125.129 19C124.297 19 123.63 18.7973 123.129 18.392C122.628 17.9867 122.377 17.2667 122.377 16.232V12.776H121.017V11.064H122.377L122.617 8.936H124.425V11.064H126.569V12.776H124.425V16.248C124.425 16.632 124.505 16.8987 124.665 17.048C124.836 17.1867 125.124 17.256 125.529 17.256H126.521V19H125.129ZM132.082 19.192C131.314 19.192 130.621 19.016 130.002 18.664C129.394 18.312 128.909 17.8267 128.546 17.208C128.194 16.5787 128.018 15.8533 128.018 15.032C128.018 14.2107 128.2 13.4907 128.562 12.872C128.925 12.2427 129.41 11.752 130.018 11.4C130.637 11.048 131.33 10.872 132.098 10.872C132.856 10.872 133.538 11.048 134.146 11.4C134.765 11.752 135.25 12.2427 135.602 12.872C135.965 13.4907 136.146 14.2107 136.146 15.032C136.146 15.8533 135.965 16.5787 135.602 17.208C135.25 17.8267 134.765 18.312 134.146 18.664C133.528 19.016 132.84 19.192 132.082 19.192ZM132.082 17.416C132.616 17.416 133.08 17.2187 133.474 16.824C133.869 16.4187 134.066 15.8213 134.066 15.032C134.066 14.2427 133.869 13.6507 133.474 13.256C133.08 12.8507 132.621 12.648 132.098 12.648C131.554 12.648 131.085 12.8507 130.69 13.256C130.306 13.6507 130.114 14.2427 130.114 15.032C130.114 15.8213 130.306 16.4187 130.69 16.824C131.085 17.2187 131.549 17.416 132.082 17.416ZM138.127 19V11.064H139.951L140.143 12.552C140.431 12.04 140.821 11.6347 141.311 11.336C141.813 11.0267 142.399 10.872 143.071 10.872V13.032H142.495C142.047 13.032 141.647 13.1013 141.295 13.24C140.943 13.3787 140.666 13.6187 140.463 13.96C140.271 14.3013 140.175 14.776 140.175 15.384V19H138.127ZM148.337 19.192C147.537 19.192 146.827 19.0213 146.209 18.68C145.59 18.3387 145.105 17.8587 144.753 17.24C144.401 16.6213 144.225 15.9067 144.225 15.096C144.225 14.2747 144.395 13.544 144.737 12.904C145.089 12.264 145.569 11.768 146.177 11.416C146.795 11.0533 147.521 10.872 148.353 10.872C149.131 10.872 149.819 11.0427 150.417 11.384C151.014 11.7253 151.478 12.1947 151.809 12.792C152.15 13.3787 152.321 14.0347 152.321 14.76C152.321 14.8773 152.315 15 152.305 15.128C152.305 15.256 152.299 15.3893 152.289 15.528H146.257C146.299 16.1467 146.513 16.632 146.897 16.984C147.291 17.336 147.766 17.512 148.321 17.512C148.737 17.512 149.083 17.4213 149.361 17.24C149.649 17.048 149.862 16.8027 150.001 16.504H152.081C151.931 17.0053 151.681 17.464 151.329 17.88C150.987 18.2853 150.561 18.6053 150.049 18.84C149.547 19.0747 148.977 19.192 148.337 19.192ZM148.353 12.536C147.851 12.536 147.409 12.68 147.025 12.968C146.641 13.2453 146.395 13.672 146.289 14.248H150.241C150.209 13.7253 150.017 13.3093 149.665 13C149.313 12.6907 148.875 12.536 148.353 12.536Z",
            fill: "#1246C8"
        })
    });
}
function ModalBarIconBuilder({ onClick, icon, color, ...rest }) {
    if (!icon) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const isClickable = isFunction(onClick);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
        disableRipple: !isClickable,
        disableTouchRipple: !isClickable,
        sx: {
            cursor: isClickable ? "pointer" : "default"
        },
        color: color,
        onClick: onClick,
        ...rest,
        children: icon
    });
}
const ModalBarIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ModalBarIconBuilder);
const defaultTextStyle = {
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
};
function ModalBarHeaderBuilder({ title, description }) {
    const isMobile = use_is_mobile();
    const titleStyle = isMobile ? theme_theme.typography.subtitle1 : theme_theme.typography.h6;
    const descriptionStyle = isMobile ? theme_theme.typography.caption : theme_theme.typography.body1;
    const textAlignment = isMobile ? alignment_Alignment.start : alignment_Alignment.center;
    const leftPadding = isMobile ? Spacing["250"] : void 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
        textAlign: textAlignment,
        sx: defaultTextStyle,
        paddingLeft: leftPadding,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                sx: {
                    ...titleStyle,
                    ...defaultTextStyle
                },
                children: title
            }),
            description ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                color: "textSecondary",
                sx: {
                    ...descriptionStyle,
                    ...defaultTextStyle
                },
                children: description
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const ModalBarHeader = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ModalBarHeaderBuilder);
function ModalBar({ title, description, onStartIconClick, onEndIconClick, startIcon, startIconColor, endIcon, endIconColor, progressBar, progressValue, progressColor, ...rest }) {
    startIconColor = startIconColor ?? "primary";
    endIconColor = endIconColor ?? "default";
    progressColor = progressColor ?? "success";
    progressValue = progressValue ?? 0;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(app_bar_AppBar, {
                position: positioning_Positioning["static"],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarIcon, {
                        "data-testid": "modal-bar-start-icon",
                        color: startIconColor,
                        icon: startIcon,
                        onClick: onStartIconClick
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarHeader, {
                        "data-testid": "modal-bar-header",
                        title: title,
                        description: description
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ModalBarIcon, {
                        "data-testid": "modal-bar-end-icon",
                        color: endIconColor,
                        icon: endIcon,
                        onClick: onEndIconClick
                    })
                ]
            }),
            progressBar ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                width: "100%",
                "data-testid": "modal-bar-progress-container",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_LinearProgress_13636fa3__["default"], {
                    "data-testid": "modal-bar-progress",
                    variant: "determinate",
                    value: progressValue,
                    color: progressColor
                })
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
}
const IconElementStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)("div", styledOptions)(({ isMobile, isMarkedAsRead })=>{
    const iconButtonSize = isMobile ? Spacing["2000"] : Spacing["2500"];
    const iconButtonBackground = isMarkedAsRead ? Action.hover : Primary.light;
    const iconElementStyle = {
        backgroundColor: `${iconButtonBackground} !important`,
        "&:hover": {
            cursor: cursor_style_CursorStyle["default"]
        },
        width: iconButtonSize,
        height: iconButtonSize,
        borderRadius: BorderRadius.full,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        padding: Spacing["500"]
    };
    return iconElementStyle;
});
function IconElement({ isMobile, isMarkedAsRead, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconElementStyled, {
        isMobile: isMobile,
        isMarkedAsRead: isMarkedAsRead,
        children: children
    });
}
const BadgeStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(badge_Badge)({
    "&:hover": {
        cursor: cursor_style_CursorStyle["default"]
    }
});
function BadgeContainer({ isMarkedAsRead, isMobile }) {
    const badgeVariant = isMarkedAsRead ? "standard" : "dot";
    const iconColor = isMarkedAsRead ? "action" : "primary";
    const iconFontSize = isMobile ? Spacing["1000"] : Spacing["1500"];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeStyled, {
            color: "tertiary",
            variant: badgeVariant,
            "data-testid": "notification-card-badge-styled",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconElement, {
                isMobile: isMobile,
                isMarkedAsRead: isMarkedAsRead,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BellOutlined, {
                    color: iconColor,
                    sx: {
                        fontSize: `${iconFontSize} !important`
                    }
                })
            })
        })
    });
}
const ACTION_CONTENT_BORDER_RADIUS = "62.4375rem";
const ACTION_CONTENT_BACKGROUND_COLOR = "rgba(18, 70, 200, 0.04)";
const FILTER_GRAYSCALE = "grayscale(100%)";
const CARD_CONTAINER_BORDER_THICK = "0.063rem";
const MIDDLE_OPACITY = 0.5;
const MAX_OPACITY = 1;
const NotificationCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ isMobile, theme })=>{
    const padding = isMobile ? `${Spacing["1000"]}` : `${Spacing["1500"]}`;
    const defaultBorder = `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD}`;
    const borderHovered = `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD_HOVERED}`;
    const componentStyle = {
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        borderRadius: theme.spacing(2),
        boxShadow: displaying_Displaying.none,
        border: defaultBorder,
        padding,
        "&:hover": {
            cursor: isMobile ? cursor_style_CursorStyle["default"] : cursor_style_CursorStyle.pointer,
            border: isMobile ? defaultBorder : borderHovered
        }
    };
    return componentStyle;
});
const NotificationCardContentContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)("div")({
    display: displaying_Displaying.flex,
    gap: Spacing["1000"],
    width: "100%"
});
const GridItemSpaceBetween = (0, __WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.spaceBetween,
    alignItems: alignment_Alignment.center,
    minHeight: Spacing["2500"]
});
function NotificationCardDescription({ description, typographyVariant }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: typographyVariant,
            color: Text.secondary,
            children: description
        })
    });
}
var custom_arrow_button_interface_CustomArrowButtonDirections = /*#__PURE__*/ function(CustomArrowButtonDirections) {
    CustomArrowButtonDirections[CustomArrowButtonDirections["up"] = 0] = "up";
    CustomArrowButtonDirections[CustomArrowButtonDirections["down"] = 1] = "down";
    return CustomArrowButtonDirections;
}({});
const EMPTY_STRING = "";
const DEFAULT_STEP = 1;
const NUMBER_INPUT_ALLOWED_KEYS = new Set([
    "-",
    "Backspace",
    "Enter",
    "ArrowRight",
    "ArrowLeft",
    "Delete"
]);
const IS_NUMBER_CHARACTER_REGEX = /^\d$/;
function computeNewValueBasedOnDirection({ direction, value, step = DEFAULT_STEP, minValue, maxValue }) {
    const updateStep = direction === custom_arrow_button_interface_CustomArrowButtonDirections.up ? step : -step;
    const parsedCurrentValue = Number(value);
    let newValue = updateStep;
    if (!isNaN(parsedCurrentValue)) newValue = parsedCurrentValue + updateStep;
    return getNextBestValue({
        newValue,
        minValue,
        maxValue
    });
}
function computeNewValueBasedOnUserInput({ newValue, minValue, maxValue }) {
    const isNewValueEmpty = isValueEmpty(newValue);
    const isNewValueTheMinusSymbol = "-" === newValue;
    if (isNewValueEmpty || isNewValueTheMinusSymbol) return EMPTY_STRING;
    const parsedValue = Number(newValue);
    if (!isNaN(parsedValue)) return getNextBestValue({
        newValue: parsedValue,
        minValue,
        maxValue
    });
    return EMPTY_STRING;
}
function isLabelShrunk(currentValue, isFocused) {
    return isFocused || !isValueEmpty(currentValue);
}
function isAllowedKey(key) {
    return IS_NUMBER_CHARACTER_REGEX.test(key) || NUMBER_INPUT_ALLOWED_KEYS.has(key);
}
function callOnChangeWithNewValue(newValue, onChange) {
    if (isFunction(onChange)) onChange(newValue);
}
function getNextBestValue({ newValue, minValue, maxValue }) {
    if (isValueInRange({
        newValue,
        minValue,
        maxValue
    })) return newValue;
    if (!isValueBelowOrEqualToMaxValue({
        newValue,
        maxValue
    })) return maxValue ?? EMPTY_STRING;
    return minValue ?? EMPTY_STRING;
}
function isValueInRange(props) {
    return isValueAboveOrEqualToMinValue(props) && isValueBelowOrEqualToMaxValue(props);
}
function isValueAboveOrEqualToMinValue({ newValue, minValue }) {
    return void 0 === minValue || Number(newValue) >= minValue;
}
function isValueBelowOrEqualToMaxValue({ newValue, maxValue }) {
    return void 0 === maxValue || Number(newValue) <= maxValue;
}
function isValueEmpty(currentValue) {
    const isDefined = null != currentValue;
    if (isDefined && "string" == typeof currentValue) return currentValue.length <= 0;
    return !isDefined;
}
function NotificationCardFooter({ date, actionText = EMPTY_STRING, buttonSize, onClick }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "body2",
                color: Text.secondary,
                children: date
            }),
            actionText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                size: buttonSize,
                color: "primary",
                variant: "text",
                endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {}),
                onClick: onClick,
                children: actionText
            })
        ]
    });
}
function EnvelopeContent({ isMarkedAsRead, tooltipDescription, isNotificationStatusLoading, isMobile, onClickEnvelope }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        placement: "top",
        description: tooltipDescription,
        disableHoverListener: isMobile,
        enterDelay: 0,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            size: "small",
            isLoading: isNotificationStatusLoading,
            disabled: isNotificationStatusLoading,
            onClick: onClickEnvelope,
            children: isMarkedAsRead ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EnvelopeOpenOutlined, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EnvelopeOutlined, {})
        })
    });
}
function NotificationCardHeader({ isMobile, isMarkedAsRead, title, tooltipDescription, isNotificationStatusLoading, onClickEnvelope }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridItemSpaceBetween, {
        item: true,
        xs: 12,
        children: [
            isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeContainer, {
                isMarkedAsRead: isMarkedAsRead,
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "h6",
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(EnvelopeContent, {
                isMarkedAsRead: isMarkedAsRead,
                tooltipDescription: tooltipDescription,
                isNotificationStatusLoading: isNotificationStatusLoading,
                onClickEnvelope: onClickEnvelope,
                isMobile: isMobile
            })
        ]
    });
}
const GridContainerCentering = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])({
    alignItems: alignment_Alignment.center
});
const notification_card_NotificationCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ title, description, date, actionText = EMPTY_STRING, isMarkedAsRead, isMobile, tooltipDescription, onClick, onMarkAsRead, ...rest }, ref) {
    const midGap = isMobile ? Spacing["750"] : void 0;
    const smallGap = isMobile ? Spacing["250"] : void 0;
    const buttonSize = isMobile ? "small" : "medium";
    const typographyVariant = isMobile ? "body2" : "body1";
    const isDesktop = !isMobile;
    const [isNotificationStatusLoading, setIsNotificationStatusLoading] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const handleEnvelopeClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.stopPropagation();
        setIsNotificationStatusLoading(true);
        onMarkAsRead();
    }, [
        onMarkAsRead
    ]);
    const handleOnClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        event.stopPropagation();
        onClick?.();
    }, [
        onMarkAsRead
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardContainer, {
        isMobile: isMobile,
        "data-testid": "notification-card-container",
        onClick: onClick,
        ref: ref,
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(NotificationCardContentContainer, {
            "data-testid": "notification-card-content",
            children: [
                isDesktop && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    "data-testid": "notification-card-badge-container-desktop",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BadgeContainer, {
                        isMarkedAsRead: isMarkedAsRead,
                        isMobile: isMobile
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainerCentering, {
                    container: true,
                    gap: midGap,
                    "data-testid": "notification-card-content-grid",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainerCentering, {
                                container: true,
                                gap: smallGap,
                                "data-testid": "notification-card-content-header-desc",
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardHeader, {
                                        isMobile: isMobile,
                                        isMarkedAsRead: isMarkedAsRead,
                                        title: title,
                                        tooltipDescription: tooltipDescription,
                                        onClickEnvelope: handleEnvelopeClick,
                                        isNotificationStatusLoading: isNotificationStatusLoading
                                    }),
                                    isMobile && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GridItemSpaceBetween, {
                                        item: true,
                                        xs: 12,
                                        "data-testid": "notification-card-content-mobile-title",
                                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "subtitle1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardDescription, {
                                        description: description,
                                        typographyVariant: typographyVariant,
                                        "data-testid": "notification-card-description"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                container: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NotificationCardFooter, {
                                    date: date,
                                    actionText: actionText,
                                    buttonSize: buttonSize,
                                    onClick: handleOnClick
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
});
const customBorderStyle = `1px solid ${theme_theme.palette.border.main}`;
const customBorderRadius = ` ${BorderRadius.soft} ${BorderRadius.soft} `;
const zeroBorderRadius = ` ${BorderRadius.none} ${BorderRadius.none} `;
const defaultHoverStyle = {
    backgroundColor: theme_theme.palette.primary.main,
    borderColor: theme_theme.palette.primary.main,
    cursor: cursor_style_CursorStyle.pointer,
    color: theme_theme.palette.primary.contrastText
};
const disabledHoverStyle = {
    cursor: cursor_style_CursorStyle.notAllowed
};
const CustomButton = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("button")(({ direction, disabled })=>{
    const hoverStyle = disabled ? disabledHoverStyle : defaultHoverStyle;
    let borderRadius = customBorderRadius + zeroBorderRadius;
    let borderTop;
    if (direction === custom_arrow_button_interface_CustomArrowButtonDirections.down) {
        borderRadius = zeroBorderRadius + customBorderRadius;
        borderTop = displaying_Displaying.none;
    }
    return {
        border: customBorderStyle,
        borderTop,
        borderRadius,
        padding: Spacing["250"],
        display: displaying_Displaying.flex,
        appearance: displaying_Displaying.none,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        boxSizing: "border-box",
        background: theme_theme.palette.background["default"],
        color: theme_theme.palette.action.active,
        fontSize: Spacing["650"],
        "&:hover": hoverStyle
    };
});
function CustomArrowButtonBuilder({ onClick, direction, disabled, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomButton, {
        onClick: onClick,
        direction: direction,
        disabled: disabled,
        ...rest,
        children: direction === custom_arrow_button_interface_CustomArrowButtonDirections.up ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CaretUpSolid, {
            fontSize: displaying_Displaying.inherit
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CaretDownSolid, {
            fontSize: displaying_Displaying.inherit
        })
    });
}
const CustomArrowButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomArrowButtonBuilder);
function CustomNumberSpinnerBuilder({ onUpArrowClick, onDownArrowClick, disabled }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["0"],
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomArrowButton, {
                direction: custom_arrow_button_interface_CustomArrowButtonDirections.up,
                onClick: onUpArrowClick,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomArrowButton, {
                direction: custom_arrow_button_interface_CustomArrowButtonDirections.down,
                onClick: onDownArrowClick,
                disabled: disabled
            })
        ]
    });
}
const CustomNumberSpinner = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(CustomNumberSpinnerBuilder);
const number_input_NumberInput = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ value, minValue, maxValue, disabled, onChange, step = DEFAULT_STEP, ...rest }, ref) {
    const [currentValue, setCurrentValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(value ?? EMPTY_STRING);
    const [isFocused, setIsFocused] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(function() {
        setCurrentValue(value ?? EMPTY_STRING);
    }, [
        value
    ]);
    const handleInputChange = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        const newValue = computeNewValueBasedOnUserInput({
            newValue: event.target?.value,
            minValue,
            maxValue
        });
        setCurrentValue(newValue);
        callOnChangeWithNewValue(newValue, onChange);
    }, [
        onChange,
        minValue,
        maxValue
    ]);
    const handleKeyDown = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(event) {
        const pressedKey = event.key;
        if (!isAllowedKey(pressedKey)) event.preventDefault();
    }, [
        isAllowedKey
    ]);
    const handleArrowButtonClick = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function(direction) {
        const newValue = computeNewValueBasedOnDirection({
            direction,
            value: currentValue,
            step,
            minValue,
            maxValue
        });
        setCurrentValue(newValue);
        callOnChangeWithNewValue(newValue, onChange);
    }, [
        currentValue,
        step,
        minValue,
        maxValue,
        onChange
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(text_field_TextField, {
        ref: ref,
        value: currentValue,
        disabled: disabled,
        inputProps: {
            min: minValue,
            max: maxValue,
            pattern: "[0-9]*",
            inputMode: "numeric",
            onKeyDown: handleKeyDown
        },
        InputLabelProps: {
            shrink: isLabelShrunk(currentValue, isFocused)
        },
        type: "text",
        inputMode: "numeric",
        autoComplete: "off",
        autoCorrect: "off",
        maxRows: 1,
        onFocus: ()=>{
            setIsFocused(true);
        },
        onBlur: ()=>{
            setIsFocused(false);
        },
        onChange: handleInputChange,
        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomNumberSpinner, {
            disabled: disabled,
            onUpArrowClick: ()=>{
                handleArrowButtonClick(custom_arrow_button_interface_CustomArrowButtonDirections.up);
            },
            onDownArrowClick: ()=>{
                handleArrowButtonClick(custom_arrow_button_interface_CustomArrowButtonDirections.down);
            }
        }),
        ...rest
    });
});
function PaypalSolid(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_SvgIcon_d9b248b4__["default"], {
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("svg", {
            width: "60",
            height: "16",
            viewBox: "0 0 60 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M22.4451 3.79028H19.1292C18.9023 3.79028 18.7093 3.95513 18.6739 4.17913L17.3328 12.6819C17.3062 12.8497 17.4361 13.0009 17.6063 13.0009H19.1893C19.4162 13.0009 19.6092 12.8361 19.6446 12.6116L20.0063 10.3183C20.0412 10.0938 20.2346 9.92895 20.4611 9.92895H21.5108C23.695 9.92895 24.9556 8.87198 25.2848 6.77743C25.4332 5.86107 25.2911 5.14107 24.862 4.63683C24.3908 4.08313 23.5549 3.79028 22.4451 3.79028ZM22.8276 6.89574C22.6463 8.08556 21.7372 8.08556 20.8582 8.08556H20.3578L20.7088 5.86349C20.7297 5.72919 20.846 5.63028 20.9818 5.63028H21.2111C21.8099 5.63028 22.3748 5.63028 22.6666 5.97162C22.8407 6.17525 22.894 6.4778 22.8276 6.89574Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M32.3567 6.85734H30.7688C30.6336 6.85734 30.5167 6.95625 30.4959 7.09055L30.4256 7.53467L30.3145 7.3737C29.9708 6.8748 29.2042 6.70801 28.4391 6.70801C26.6845 6.70801 25.1858 8.03698 24.8939 9.90122C24.7422 10.8312 24.9579 11.7204 25.4855 12.3405C25.9693 12.9107 26.6617 13.1482 27.4854 13.1482C28.8993 13.1482 29.6833 12.2392 29.6833 12.2392L29.6125 12.6804C29.5858 12.8491 29.7158 13.0004 29.885 13.0004H31.3153C31.5427 13.0004 31.7347 12.8355 31.7705 12.611L32.6287 7.17637C32.6559 7.0091 32.5264 6.85734 32.3567 6.85734ZM30.1434 9.94776C29.9902 10.8549 29.2702 11.4639 28.3519 11.4639C27.8908 11.4639 27.5223 11.316 27.2857 11.0358C27.051 10.7575 26.9618 10.3613 27.0365 9.92013C27.1795 9.02073 27.9116 8.39189 28.8159 8.39189C29.2668 8.39189 29.6333 8.5417 29.8748 8.82437C30.1167 9.10995 30.2127 9.50849 30.1434 9.94776Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M40.8134 6.85742H39.2178C39.0655 6.85742 38.9225 6.93306 38.8362 7.0596L36.6355 10.3013L35.7026 7.18615C35.6439 6.99124 35.4641 6.85742 35.2604 6.85742H33.6924C33.5019 6.85742 33.3695 7.0436 33.4301 7.223L35.1877 12.3808L33.5353 14.7134C33.4054 14.8972 33.5363 15.1498 33.7608 15.1498H35.3545C35.5058 15.1498 35.6473 15.0761 35.7332 14.952L41.0403 7.29136C41.1673 7.10809 41.0369 6.85742 40.8134 6.85742Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M46.0964 3.79028H42.7801C42.5537 3.79028 42.3607 3.95513 42.3253 4.17913L40.9842 12.6819C40.9575 12.8497 41.0875 13.0009 41.2567 13.0009H42.9585C43.1166 13.0009 43.2518 12.8856 43.2766 12.7285L43.6572 10.3183C43.6921 10.0938 43.8855 9.92895 44.112 9.92895H45.1612C47.3459 9.92895 48.606 8.87198 48.9357 6.77743C49.0846 5.86107 48.9415 5.14107 48.5124 4.63683C48.0416 4.08313 47.2063 3.79028 46.0964 3.79028ZM46.479 6.89574C46.2981 8.08556 45.389 8.08556 44.5095 8.08556H44.0097L44.3612 5.86349C44.382 5.72919 44.4974 5.63028 44.6336 5.63028H44.863C45.4613 5.63028 46.0266 5.63028 46.3185 5.97162C46.4926 6.17525 46.5454 6.4778 46.479 6.89574Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M56.0077 6.85734H54.4208C54.2846 6.85734 54.1687 6.95625 54.1483 7.09055L54.078 7.53467L53.9665 7.3737C53.6228 6.8748 52.8567 6.70801 52.0916 6.70801C50.3369 6.70801 48.8388 8.03698 48.5469 9.90122C48.3956 10.8312 48.6104 11.7204 49.1379 12.3405C49.6228 12.9107 50.3142 13.1482 51.1379 13.1482C52.5517 13.1482 53.3357 12.2392 53.3357 12.2392L53.2649 12.6804C53.2383 12.8491 53.3682 13.0004 53.5384 13.0004H54.9682C55.1946 13.0004 55.3876 12.8355 55.423 12.611L56.2817 7.17637C56.3078 7.0091 56.1779 6.85734 56.0077 6.85734ZM53.7944 9.94776C53.6422 10.8549 52.9212 11.4639 52.0029 11.4639C51.5428 11.4639 51.1733 11.316 50.9367 11.0358C50.702 10.7575 50.6138 10.3613 50.6875 9.92013C50.8315 9.02073 51.5626 8.39189 52.4669 8.39189C52.9178 8.39189 53.2843 8.5417 53.5258 8.82437C53.7687 9.10995 53.8647 9.50849 53.7944 9.94776Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M57.8796 4.02349L56.5186 12.6819C56.492 12.8497 56.6219 13.0009 56.7911 13.0009H58.1593C58.3867 13.0009 58.5797 12.8361 58.6146 12.6116L59.9567 4.10931C59.9833 3.94155 59.8534 3.78979 59.6842 3.78979H58.1521C58.0168 3.79028 57.9004 3.88919 57.8796 4.02349Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M3.56256 14.6534L3.81614 13.0428L3.25129 13.0297H0.554077L2.4285 1.14459C2.43432 1.10871 2.45323 1.07525 2.48087 1.0515C2.5085 1.02774 2.5439 1.01465 2.58074 1.01465H7.12862C8.63844 1.01465 9.68038 1.32883 10.2244 1.94895C10.4794 2.23986 10.6418 2.54386 10.7204 2.87841C10.8028 3.22944 10.8043 3.64883 10.7238 4.16035L10.718 4.19768V4.52544L10.973 4.66992C11.1878 4.78386 11.3584 4.91428 11.4893 5.06362C11.7075 5.31235 11.8486 5.62847 11.9083 6.00325C11.9698 6.38871 11.9495 6.84738 11.8486 7.36665C11.7323 7.96398 11.5441 8.48422 11.2901 8.90992C11.0564 9.30216 10.7587 9.6275 10.4052 9.87962C10.0678 10.1191 9.6668 10.301 9.21347 10.4173C8.7742 10.5317 8.27335 10.5894 7.72402 10.5894H7.37008C7.11699 10.5894 6.87117 10.6806 6.6782 10.844C6.48474 11.0108 6.35674 11.2386 6.31747 11.4879L6.2908 11.6328L5.8428 14.4716L5.82244 14.5759C5.81711 14.6088 5.8079 14.6253 5.79432 14.6365C5.7822 14.6466 5.76474 14.6534 5.74777 14.6534H3.56256Z",
                    fill: "#253B80"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M11.2144 4.23535C11.2008 4.32214 11.1853 4.41087 11.1679 4.50202C10.5681 7.58129 8.51624 8.64505 5.89564 8.64505H4.56133C4.24085 8.64505 3.97079 8.87778 3.92085 9.1939L3.2377 13.5265L3.04424 14.7546C3.01176 14.9621 3.17176 15.1493 3.38121 15.1493H5.74776C6.028 15.1493 6.26606 14.9457 6.31018 14.6693L6.33345 14.549L6.77903 11.7214L6.80764 11.5663C6.85127 11.2889 7.08982 11.0853 7.37006 11.0853H7.724C10.0168 11.0853 11.8118 10.1544 12.3364 7.46056C12.5555 6.33523 12.4421 5.39559 11.8622 4.73475C11.6867 4.53547 11.469 4.37014 11.2144 4.23535Z",
                    fill: "#179BD7"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M10.5871 3.98529C10.4954 3.95863 10.4009 3.93438 10.3039 3.91257C10.2065 3.89123 10.1066 3.87232 10.0038 3.85584C9.64405 3.79766 9.24987 3.77002 8.82757 3.77002H5.26296C5.1752 3.77002 5.09181 3.7899 5.01714 3.82578C4.85278 3.90481 4.7306 4.06044 4.70102 4.25099L3.94272 9.0539L3.9209 9.19402C3.97084 8.8779 4.2409 8.64517 4.56138 8.64517H5.89569C8.51629 8.64517 10.5682 7.58093 11.1679 4.50214C11.1859 4.41099 11.2009 4.32226 11.2145 4.23547C11.0627 4.15499 10.8984 4.08614 10.7214 4.02747C10.6777 4.01293 10.6327 3.99887 10.5871 3.98529Z",
                    fill: "#222D65"
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                    d: "M4.701 4.25092C4.73058 4.06037 4.85276 3.90473 5.01712 3.82619C5.09227 3.79031 5.17518 3.77043 5.26294 3.77043H8.82755C9.24985 3.77043 9.64403 3.79807 10.0038 3.85625C10.1066 3.87273 10.2065 3.89164 10.3039 3.91298C10.4009 3.93479 10.4954 3.95904 10.5871 3.9857C10.6326 3.99928 10.6777 4.01334 10.7218 4.0274C10.8988 4.08607 11.0632 4.1554 11.2149 4.2354C11.3934 3.09746 11.2135 2.32267 10.5982 1.6211C9.91991 0.848733 8.69567 0.518066 7.12912 0.518066H2.58124C2.26124 0.518066 1.98827 0.750794 1.93882 1.0674L0.0445159 13.0747C0.00718259 13.3122 0.190455 13.5266 0.42997 13.5266H3.23773L3.9427 9.05382L4.701 4.25092Z",
                    fill: "#253B80"
                })
            ]
        })
    });
}
const PAYPAL_BUTTON_BACKGROUND = "#F9A000";
const PAYPAL_TEXT_COLOR = "#253B80";
const ButtonContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(button_Button)({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    flexDirection: direction_Direction.row,
    background: PAYPAL_BUTTON_BACKGROUND,
    padding: `${Spacing["750"]} ${Spacing["1000"]}`,
    gap: Spacing["250"],
    ":hover": {
        background: PAYPAL_BUTTON_BACKGROUND
    },
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        background: Action.disabledBackground,
        "& p": {
            color: Text.disabled
        }
    }
});
const PaypalTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    color: PAYPAL_TEXT_COLOR,
    fontFamily: "Inter",
    fontSize: Spacing["750"],
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: Spacing["1000"],
    letterSpacing: "-0.24px"
});
const PaypalIconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(PaypalSolid)({
    width: "4rem"
});
function PaypalButton({ children, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ButtonContainer, {
        className: "paypal-button",
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PaypalTypographyContainer, {
                children: children
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PaypalIconContainer, {})
        ]
    });
}
var isEmpty = __webpack_require__("./node_modules/lodash/isEmpty.js");
var isEmpty_default = /*#__PURE__*/ __webpack_require__.n(isEmpty);
var isUndefined = __webpack_require__("./node_modules/lodash/isUndefined.js");
var isUndefined_default = /*#__PURE__*/ __webpack_require__.n(isUndefined);
const PlanSelectorClickableGridSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
    shouldForwardProp: ()=>true
})(({ onClick })=>({
        [":hover"]: {
            cursor: isUndefined_default()(onClick) ? cursor_style_CursorStyle["default"] : cursor_style_CursorStyle.pointer
        }
    }));
function PlanSelectorIconSection({ color, readonly, selected, notAvailable }) {
    if (readonly || notAvailable) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    if (selected) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
        fontSize: "medium",
        color: color
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CircleLargeOutlined, {
        fontSize: "medium",
        color: "action"
    });
}
const PlanSelectorLabelSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(chip_Chip)`
  border-radius: ${Spacing["500"]} ${Spacing["500"]} 0px 0px;
  padding: ${Spacing["500"]} ${Spacing["750"]};
  color: ${({ theme, notAvailable })=>notAvailable ? theme.palette.text.secondary : void 0};
`;
function PlanSelector(props) {
    const defaultExtraTextVariant = "body2";
    const defaultExtraTextColor = "text.secondary";
    const extraTextConfig = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        let extraTextGradient;
        let extraTextVariant = defaultExtraTextVariant;
        let extraTextColor = defaultExtraTextColor;
        if (props.readonly || props.notAvailable) return {
            gradient: extraTextGradient,
            variant: extraTextVariant,
            color: extraTextColor
        };
        if (props.extraTextHighlighted) {
            extraTextGradient = props.borderColor;
            extraTextVariant = "subtitle2";
            extraTextColor = void 0;
        }
        return {
            gradient: extraTextGradient,
            variant: extraTextVariant,
            color: extraTextColor
        };
    }, [
        props.extraTextHighlighted,
        props.borderColor,
        props.readonly,
        props.notAvailable
    ]);
    const color = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (props.selected && true !== props.readonly && true !== props.notAvailable) return props.borderColor;
    }, [
        props.selected,
        props.borderColor,
        props.readonly,
        props.notAvailable
    ]);
    const formattedFrequencyCaption = `/${props.frequencyCaption}`;
    const priceTextProperties = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const defaultProperties = {
            color: "text.primary",
            fontWeight: typography_FontWeight.bold
        };
        if (isEmpty_default()(props.discountedPrice)) return defaultProperties;
        return {
            fontSize: typography_FontSize.xs,
            color: "text.secondary",
            sx: {
                textDecoration: "line-through"
            }
        };
    }, [
        props.discountedPrice
    ]);
    let onClickCallback;
    if (props.onClick && !props.readonly && !props.notAvailable) onClickCallback = props.onClick;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        container: true,
        direction: direction_Direction.column,
        rowSpacing: 0,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                item: true,
                children: props.label && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorLabelSection, {
                    size: "small",
                    label: props.label,
                    notAvailable: props.notAvailable
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorClickableGridSection, {
                item: true,
                onClick: onClickCallback,
                id: props.id,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBoxOutlined, {
                    gradient: color,
                    size: "small",
                    withLabel: !!props.label,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        container: true,
                        direction: direction_Direction.column,
                        rowGap: Spacing["250"],
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                    direction: direction_Direction.row,
                                    gap: Spacing["500"],
                                    alignItems: alignment_Alignment.center,
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PlanSelectorIconSection, {
                                            selected: props.selected,
                                            readonly: props.readonly,
                                            notAvailable: props.notAvailable,
                                            color: color
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "subtitle1",
                                            color: props.notAvailable ? "textSecondary" : void 0,
                                            children: props.frequencyTitle
                                        })
                                    ]
                                })
                            }),
                            !props.notAvailable && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                    direction: direction_Direction.row,
                                    spacing: Spacing["0"],
                                    alignItems: "baseline",
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"], {
                                            direction: direction_Direction.row,
                                            spacing: Spacing["250"],
                                            alignItems: "baseline",
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                                                    variant: "body1",
                                                    ...priceTextProperties,
                                                    children: [
                                                        props.price,
                                                        " ",
                                                        props.currency
                                                    ]
                                                }),
                                                props.discountedPrice && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Typography, {
                                                    variant: "body1",
                                                    fontWeight: typography_FontWeight.bold,
                                                    children: [
                                                        props.discountedPrice,
                                                        " ",
                                                        props.currency
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                            variant: "body1",
                                            children: formattedFrequencyCaption
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: true,
                                alignContent: alignment_Alignment.center,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                    variant: extraTextConfig.variant,
                                    gradient: extraTextConfig.gradient,
                                    color: extraTextConfig.color,
                                    children: props.extraText
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function hexToRgba(hex, opacity) {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const red = bigint >> 16 & 255;
    const green = bigint >> 8 & 255;
    const blue = 255 & bigint;
    return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
const GREYX_700_WITH_OPACITY = hexToRgba(Greyx["700"], 0.5);
const product_card_container_shouldForwardProp = dontForwardTheseProps([
    "isMobile",
    "accentColor",
    "disabled"
]);
const ProductCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], {
    shouldForwardProp: product_card_container_shouldForwardProp
})(({ disabled = false, accentColor, isMobile, theme })=>{
    const isBorderEnabled = !!accentColor;
    let borderLeftStyle = `${ONE_PIXEL_REM} ${border_style_BorderStyle.solid} inherit`;
    if (isBorderEnabled) {
        const borderColor = disabled ? GREYX_700_WITH_OPACITY : theme.palette[accentColor].main;
        borderLeftStyle = `${theme.spacing(2)} ${border_style_BorderStyle.solid} ${borderColor}`;
    }
    const padding = isMobile ? `${Spacing["750"]} ${Spacing["750"]} ${Spacing["750"]} ${Spacing["1500"]}` : `${Spacing["1000"]} ${Spacing["1500"]}`;
    return {
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        borderRadius: theme.spacing(2),
        boxShadow: displaying_Displaying.none,
        border: `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD}`,
        padding,
        borderLeft: borderLeftStyle,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer,
            border: `${CARD_CONTAINER_BORDER_THICK} ${border_style_BorderStyle.solid} ${GREY_BORDER_CARD_HOVERED}`,
            borderLeft: borderLeftStyle,
            "& #card-action-content": {
                background: ACTION_CONTENT_BACKGROUND_COLOR,
                borderRadius: ACTION_CONTENT_BORDER_RADIUS,
                padding: Spacing["500"]
            }
        }
    };
});
const product_card_content_shouldForwardProp = dontForwardTheseProps([
    "isMobile"
]);
const ProductCardContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", {
    shouldForwardProp: product_card_content_shouldForwardProp
})(({ isMobile })=>{
    const gap = isMobile ? Spacing["500"] : Spacing["2000"];
    return {
        gap,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        width: "100%"
    };
});
function ProductCardChipBuilder({ accentColor, disabled, badge }) {
    const chipConfig = {
        label: badge,
        variant: "outlined",
        size: "small",
        disabled,
        color: accentColor,
        sx: {
            opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
        }
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_Chip, {
        "data-testid": "product-card-chip",
        ...chipConfig
    });
}
const ProductCardChip = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardChipBuilder);
function ProductCardDateBuilder({ date }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        item: true,
        xs: 12,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
            variant: "body2",
            color: "GrayText",
            "data-testid": "product-card-date",
            children: date
        })
    });
}
const ProductCardDate = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardDateBuilder);
function PriceSectionBuilder({ price, disabled }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
        item: true,
        xs: 12,
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        "data-testid": "card-container-price-section",
        sx: {
            opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
        },
        children: price
    });
}
const ProductCardPrice = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(PriceSectionBuilder);
function ProductCardActionBuilder({ iconButtonId, disabled = false, isMobile }) {
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const sxForOpacity = {
        opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        sx: sxForOpacity,
        "data-testid": "card-container-boundary-margin-left",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
            id: iconButtonId ?? "product-card-action-icon",
            color: "default",
            size: "medium",
            disabled: disabled,
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {})
        })
    });
}
const ProductCardAction = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardActionBuilder);
function getChipColor(accentColor, disabled) {
    if (disabled) return "default";
    if (!accentColor) return "tertiary";
    if ("primary" === accentColor) return "info";
    return "secondary";
}
function getIconColor(accentColor, disabled) {
    if (disabled || !accentColor) return "action";
    return accentColor;
}
function ProductCardTitleGenerator({ isLocked, disabled, accentColor, title, titleVariant, titleIcon }) {
    const iconColor = getIconColor(accentColor, disabled);
    let renderedTitleIcon = titleIcon;
    if (titleIcon && !titleIcon?.props?.color) renderedTitleIcon = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].cloneElement(titleIcon, {
        color: iconColor,
        ...titleIcon?.props
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            isLocked ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LockViewfinderOutlined, {
                color: iconColor
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            renderedTitleIcon || /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: titleVariant,
                color: "textPrimary",
                "data-testid": "product-card-title",
                children: title
            })
        ]
    });
}
const ProductCardTitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(ProductCardTitleGenerator);
const product_card_shouldForwardProp = dontForwardTheseProps([
    "isBlurred",
    "disabled"
]);
const BlurEffectGrid = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
    shouldForwardProp: product_card_shouldForwardProp
})(({ isBlurred, disabled })=>({
        filter: isBlurred ? "blur(0.35rem)" : "none",
        opacity: disabled ? MIDDLE_OPACITY : MAX_OPACITY
    }));
const product_card_ProductCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ accentColor = PRIMARY_COLOR, title, price, date, badge, description, disabled = false, iconButtonId, isMobile: isMobileProp, isLocked, titleIcon, isBlurred, ...muiCardProps }, ref) {
    const isMobileHookResult = use_is_mobile();
    const isMobile = isMobileProp ?? isMobileHookResult;
    const color = getChipColor(accentColor, disabled);
    const productChip = {
        accentColor: color,
        disabled,
        badge
    };
    if (isBlurred) {
        productChip.accentColor = "tealDusk";
        productChip.disabled = false;
    }
    const titleItemsAlignment = isMobile ? alignment_Alignment.start : alignment_Alignment.center;
    const titleVariant = isMobile ? "subtitle1" : "h6";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardContainer, {
        accentColor: accentColor,
        disabled: disabled,
        isMobile: isMobile,
        ref: ref,
        ...muiCardProps,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProductCardContent, {
            isMobile: isMobile,
            "data-testid": "card-container-content-flexed",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    wrap: "nowrap",
                    direction: direction_Direction.column,
                    justifyContent: alignment_Alignment.center,
                    alignItems: alignment_Alignment.flexStart,
                    spacing: 2,
                    style: {
                        marginLeft: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardChip, {
                                ...productChip
                            })
                        }),
                        date ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardDate, {
                            date: date
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlurEffectGrid, {
                            item: true,
                            isBlurred: isBlurred,
                            disabled: disabled,
                            zeroMinWidth: true,
                            display: displaying_Displaying.flex,
                            gap: Spacing["500"],
                            alignItems: titleItemsAlignment,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardTitle, {
                                title: title,
                                titleVariant: titleVariant,
                                isLocked: isLocked,
                                disabled: disabled,
                                accentColor: accentColor,
                                titleIcon: titleIcon
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BlurEffectGrid, {
                            item: true,
                            isBlurred: isBlurred,
                            disabled: disabled,
                            children: description
                        }),
                        isBlurred ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardPrice, {
                            price: price,
                            disabled: disabled
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProductCardAction, {
                    iconButtonId: iconButtonId,
                    disabled: disabled,
                    isMobile: isMobile
                })
            ]
        })
    });
});
const IconSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ disabled })=>({
        filter: disabled ? FILTER_GRAYSCALE : INITIAL_OPTION
    }));
const ImageSection = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("img", styledOptions)(({ disabled })=>({
        objectFit: CONTAIN_OPTION,
        filter: disabled ? FILTER_GRAYSCALE : INITIAL_OPTION
    }));
const DEFAULT_STEPS = [
    {
        key: 1,
        label: "Primi passi"
    },
    {
        key: 2,
        label: "Efficace"
    },
    {
        key: 3,
        label: "Stellare"
    }
];
const DEFAULT_TITLE = "Completezza del profilo";
const DEFAULT_SIZE = "medium";
const DEFAULT_ACTIVE_STEP = 0;
const ProfileCompletionLevelStepConnector = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_StepConnector_b0bd5d60__["default"])(({ size })=>({
        [`&.${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.alternativeLabel}`]: {
            top: "large" === size ? Spacing["1000"] : Spacing["750"],
            marginTop: Spacing["250"]
        },
        [`&.${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.active}`]: {
            [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.line}`]: {
                backgroundColor: Bluex["50"]
            }
        },
        [`&.${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.completed}`]: {
            [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.line}`]: {
                backgroundColor: Bluex["50"]
            }
        },
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.stepConnectorClasses.line}`]: {
            height: Spacing["500"],
            border: 0,
            backgroundColor: Greyx["0"]
        }
    }));
const ONE_Z_INDEX_ELEVATION = 1;
const ProfileCompletionLevelStepIconRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ theme, ownerState })=>({
        backgroundColor: Greyx["0"],
        zIndex: ONE_Z_INDEX_ELEVATION,
        color: theme.palette.action.active,
        display: displaying_Displaying.flex,
        borderRadius: "50%",
        justifyContent: alignment_Alignment.center,
        alignItems: alignment_Alignment.center,
        border: `1px ${border_style_BorderStyle.dashed} ${theme.palette.border.main}`,
        fontSize: Spacing["1500"],
        width: "large" === ownerState.size ? Spacing["3000"] : Spacing["2500"],
        height: "large" === ownerState.size ? Spacing["3000"] : Spacing["2500"],
        variants: [
            {
                props: ({ ownerState })=>ownerState.active,
                style: {
                    backgroundColor: Bluex["50"],
                    color: theme.palette.primary.main,
                    border: "none"
                }
            },
            {
                props: ({ ownerState })=>ownerState.completed,
                style: {
                    backgroundColor: Bluex["50"],
                    color: theme.palette.primary.main,
                    border: "none"
                }
            }
        ]
    }));
function ProfileCompletionLevelStepIconWrapper(props) {
    const { active, completed, className, size = "medium", stepNumber } = props;
    const icons = {
        1: {
            active: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LeafSolid,
            unactive: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LeafSolid
        },
        2: {
            active: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeHeartSolid,
            unactive: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeHeartOutlined
        },
        3: {
            active: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.RocketLaunchSolid,
            unactive: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.RocketLaunchOutlined
        }
    };
    const stepIcon = icons[stepNumber];
    const Icon = active || completed ? stepIcon.active : stepIcon.unactive;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileCompletionLevelStepIconRoot, {
        ownerState: {
            completed,
            active,
            size
        },
        className: className,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Icon, {
            fontSize: size
        })
    });
}
const ProfileCompletionLevelStepper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stepper_18643dcd__["default"])(()=>({
        [".MuiStep-root:has(.MuiStepLabel-iconContainer.Mui-active) + .MuiStep-root .MuiStepConnector-line::before"]: {
            backgroundColor: Bluex["50"],
            height: Spacing["500"],
            width: "50%",
            borderTopRightRadius: BorderRadius.brand,
            borderBottomRightRadius: BorderRadius.brand,
            content: "' '",
            display: "block"
        }
    }));
function ProfileCompletionLevel({ size = DEFAULT_SIZE, title = DEFAULT_TITLE, activeStep = DEFAULT_ACTIVE_STEP }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["1000"],
        padding: Spacing["500"],
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                flexDirection: direction_Direction.row,
                justifyContent: alignment_Alignment.flexStart,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                    variant: "subtitle1",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileCompletionLevelStepper, {
                activeStep: activeStep,
                connector: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileCompletionLevelStepConnector, {
                    size: size
                }),
                alternativeLabel: true,
                children: DEFAULT_STEPS.map((step)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Step_3911fe4c__["default"], {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_StepLabel_7ace807e__["default"], {
                            StepIconComponent: (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileCompletionLevelStepIconWrapper, {
                                    ...props,
                                    size: size,
                                    stepNumber: step.key
                                }),
                            slotProps: {
                                label: {
                                    style: {
                                        marginTop: Spacing["250"]
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                variant: "large" === size ? "body2" : "caption",
                                children: step.label
                            })
                        })
                    }, step.key))
            })
        ]
    });
}
const ProfileCoverIconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ onClick })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.center,
        ["&:hover"]: {
            cursor: onClick ? cursor_style_CursorStyle.pointer : cursor_style_CursorStyle["default"]
        }
    }));
const ProfileCoverWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])(({ size })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["1500"],
        borderRadius: BorderRadius.brand,
        padding: "small" === size ? `${Spacing["1500"]} ${Spacing["1000"]}` : `${Spacing["2000"]} ${Spacing["1500"]}`,
        backgroundColor: Background["default"]
    }));
function ProfileCover({ profileName, profileUpdatedAt, size, subscriptionTier, onProfileIconClick, ...boxProps }) {
    const chipColorByTier = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        switch(subscriptionTier.toLowerCase()){
            case "base":
                return "tealDusk";
            case "premium":
                return "pinkHaze";
            case "gold":
                return "goldenUmber";
            case "free":
            default:
                return "primary";
        }
    }, [
        subscriptionTier
    ]);
    const chipVariantByTier = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        switch(subscriptionTier.toLowerCase()){
            case "free":
                return "outlined";
            case "base":
            case "premium":
            case "gold":
            default:
                return "filled";
        }
    }, [
        subscriptionTier
    ]);
    const textVariantBySize = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        const titleVariant = "small" === size ? "h6" : "h4";
        const subtitleVariant = "small" === size ? "caption" : "body1";
        return {
            title: titleVariant,
            subtitle: subtitleVariant
        };
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProfileCoverWrapper, {
        ...boxProps,
        size: size,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                flexDirection: direction_Direction.row,
                justifyContent: alignment_Alignment.spaceBetween,
                gap: Spacing["1500"],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                        display: displaying_Displaying.flex,
                        flexDirection: direction_Direction.column,
                        justifyContent: alignment_Alignment.spaceBetween,
                        flexGrow: 1,
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: textVariantBySize.title,
                                children: [
                                    "Ciao, ",
                                    profileName,
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: textVariantBySize.subtitle,
                                children: [
                                    "Profilo aggiornato il: ",
                                    profileUpdatedAt
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileCoverIconWrapper, {
                        onClick: onProfileIconClick,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UserCirclePenSolid, {
                            color: "primary",
                            sx: {
                                height: Spacing["4500"],
                                width: Spacing["4500"]
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                display: displaying_Displaying.flex,
                flexDirection: direction_Direction.row,
                justifyContent: alignment_Alignment.flexStart,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_Chip, {
                    size: "medium",
                    color: chipColorByTier,
                    label: `Piano ${subscriptionTier}`,
                    variant: chipVariantByTier
                })
            })
        ]
    });
}
function useIsHovering() {
    const [isHovering, setIsHovering] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    return {
        isHovering,
        startHover,
        endHover
    };
    function startHover() {
        setIsHovering(true);
    }
    function endHover() {
        setIsHovering(false);
    }
}
const use_is_hovering = useIsHovering;
var profile_questionnaire_status_enum_ProfileQuestionnaireStatus = /*#__PURE__*/ function(ProfileQuestionnaireStatus) {
    ProfileQuestionnaireStatus["ToComplete"] = "to-complete";
    ProfileQuestionnaireStatus["Completing"] = "completing";
    ProfileQuestionnaireStatus["Completed"] = "completed";
    return ProfileQuestionnaireStatus;
}({});
const IconContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    marginRight: Spacing["750"],
    "&.mobile-version": {
        paddingTop: Spacing["250"],
        alignItems: alignment_Alignment.flexStart,
        alignSelf: alignment_Alignment.stretch
    }
});
const IconWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ isActive })=>({
        padding: Spacing["250"],
        background: isActive ? Secondary.main : Common.white.main,
        borderRadius: BorderRadius.brand,
        color: isActive ? Common.white.main : Text.secondary,
        "& svg": {
            width: 20,
            height: 20
        }
    }));
function ProfileQuestionnaireIcon({ isMobile, isSectionCompleted, isSectionActive, activeIcon, inactiveIcon }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconContainer, {
        className: isMobile ? "mobile-version" : void 0,
        children: isSectionCompleted ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
            color: "secondary",
            style: {
                fontSize: 28
            }
        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(IconWrapper, {
            isActive: isSectionActive,
            children: isSectionActive ? activeIcon : inactiveIcon
        })
    });
}
const ACTIVE_PADDING = `${Spacing["750"]} ${Spacing["1500"]}`;
const MOBILE_PADDING = Spacing["0"];
function getProfileQuestionnaireItemWrapperPadding({ isMobile, isActive }) {
    if (isMobile) return MOBILE_PADDING;
    return isActive ? ACTIVE_PADDING : MOBILE_PADDING;
}
const ProfileQuestionnaireItemWrapper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)((args)=>{
    const padding = getProfileQuestionnaireItemWrapperPadding(args);
    return {
        width: "100%",
        padding
    };
});
const ACTIVE_MOBILE_PADDING_STYLES = `${Spacing["500"]} ${Spacing["1000"]} ${Spacing["1000"]} ${Spacing["1000"]}`;
const INACTIVE_MOBILE_PADDING_STYLES = `${Spacing["750"]} ${Spacing["1000"]}`;
const ACTIVE_PADDING_STYLES = `${Spacing["1500"]} ${Spacing["0"]}`;
const INACTIVE_PADDING_STYLES = `${Spacing["1500"]} ${Spacing["1500"]}`;
function getProfileQuestionnairePaperPadding({ isMobile, isActive }) {
    if (isMobile) return isActive ? ACTIVE_MOBILE_PADDING_STYLES : INACTIVE_MOBILE_PADDING_STYLES;
    return isActive ? ACTIVE_PADDING_STYLES : INACTIVE_PADDING_STYLES;
}
const ProfileQuestionnairePaper = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Paper_a338d346__["default"], styledOptions)((args)=>{
    const padding = getProfileQuestionnairePaperPadding(args);
    return {
        display: displaying_Displaying.flex,
        justifyContent: alignment_Alignment.spaceBetween,
        alignItems: alignment_Alignment.center,
        padding,
        borderRadius: 0,
        background: args.isActive ? Secondary.light : Common.white.main,
        "& div": {
            display: displaying_Displaying.inherit,
            alignItems: displaying_Displaying.inherit
        }
    };
});
const MAX_PERCENTAGE = 100;
const profile_questionnaire_item_EMPTY_STRING = "";
const PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE = "1.9375rem";
function ProfileQuestionnaireItem({ id, activeIcon, inactiveIcon, percentage, sectionNumber, title, fallbackDescription, status, isMobile = false, buttonText = "button text", percentagePrefixText = "percentage prefix text", withLinearProgress = false, withBottomDivider = true, onClick, onClickEndActionButton, editButtonTooltipText = "", tooltipOpen = false, itemTooltipMessage }) {
    const { isHovering, startHover, endHover } = use_is_hovering();
    const isSectionActive = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing;
    }, [
        status
    ]);
    const isSectionCompleted = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return percentage === MAX_PERCENTAGE;
    }, [
        percentage
    ]);
    const description = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        if (isSectionCompleted) return profile_questionnaire_item_EMPTY_STRING;
        if (status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing) return `${percentagePrefixText} ${percentage}%`;
        return fallbackDescription;
    }, [
        isSectionCompleted,
        status
    ]);
    const shouldUseGrayText = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return isSectionActive || isSectionCompleted;
    }, [
        isSectionActive,
        isSectionCompleted
    ]);
    const shouldShowTooltipMessage = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return itemTooltipMessage && "" !== itemTooltipMessage;
    }, [
        itemTooltipMessage
    ]);
    const shouldShowEditButtonTooltip = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(function() {
        return "" !== editButtonTooltipText;
    }, []);
    const titleVariant = isMobile ? "subtitle1" : "h6";
    const descriptionVariant = isMobile ? "caption" : "body1";
    const onClickBoxCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(function() {
        if (isSectionCompleted) return onClick?.(id);
        if (isSectionActive) return onClickEndActionButton?.(id);
    }, [
        isSectionCompleted,
        isSectionActive,
        onClick,
        onClickEndActionButton
    ]);
    const profileQuestionnaireItem = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_Box_c52672f4__["default"], {
        onMouseEnter: startHover,
        onMouseLeave: endHover,
        onClick: onClickBoxCallback,
        style: {
            cursor: isSectionActive || isSectionCompleted ? "pointer" : "initial"
        },
        children: [
            withLinearProgress ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LinearProgress, {
                value: percentage,
                color: "secondary",
                variant: "determinate"
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnairePaper, {
                elevation: 0,
                isMobile: isMobile,
                isActive: isSectionActive,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProfileQuestionnaireItemWrapper, {
                    isMobile: isMobile,
                    isActive: isSectionActive,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnaireIcon, {
                            isMobile: isMobile,
                            isSectionCompleted: isSectionCompleted,
                            isSectionActive: isSectionActive,
                            activeIcon: activeIcon,
                            inactiveIcon: inactiveIcon
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            style: {
                                display: isMobile ? displaying_Displaying.initial : displaying_Displaying.inherit,
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    style: {
                                        display: displaying_Displaying.flex
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                            style: {
                                                minWidth: PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                    color: shouldUseGrayText ? Text.primary : Text.secondary,
                                                    variant: titleVariant,
                                                    children: sectionNumber
                                                }),
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                    color: Text.secondary,
                                                    variant: titleVariant,
                                                    style: {
                                                        marginLeft: Spacing["500"],
                                                        marginRight: Spacing["500"]
                                                    },
                                                    children: "\xb7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                            style: {
                                                marginRight: Spacing["500"]
                                            },
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                                color: shouldUseGrayText ? Text.primary : Text.secondary,
                                                variant: titleVariant,
                                                children: title
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        flexGrow: 1,
                                        marginLeft: isMobile ? PROFILE_QUESTIONNAIRE_TITLE_SPACING_SIZE : 0
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                        color: isSectionActive ? Success.main : Text.secondary,
                                        variant: descriptionVariant,
                                        children: description
                                    })
                                }),
                                isSectionActive ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    style: {
                                        marginLeft: isMobile ? Spacing["1500"] : 0,
                                        marginTop: isMobile ? Spacing["750"] : "initial"
                                    },
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                                        variant: "contained",
                                        color: "success",
                                        size: "medium",
                                        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {}),
                                        onClick: ()=>onClickEndActionButton?.(id),
                                        children: buttonText
                                    })
                                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                            ]
                        }),
                        isSectionCompleted ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
                            description: editButtonTooltipText,
                            disableHoverListener: !shouldShowEditButtonTooltip,
                            disableTouchListener: !shouldShowEditButtonTooltip,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                                size: "small",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onClick?.(id);
                                },
                                style: {
                                    opacity: isHovering || isMobile ? 1 : 0,
                                    transition: "all .1s"
                                },
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.PenOutlined, {
                                    color: "primary"
                                })
                            })
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
                    ]
                })
            }),
            withBottomDivider ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], {
                style: {
                    borderColor: isSectionActive ? Secondary.main : Border.main
                }
            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {})
        ]
    });
    return shouldShowTooltipMessage ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tooltip, {
        open: tooltipOpen,
        description: itemTooltipMessage ?? "",
        arrow: true,
        placement: "top",
        children: profileQuestionnaireItem
    }) : profileQuestionnaireItem;
}
const ProfileQuestionnaireStack = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"])({
    borderRadius: BorderRadius.brand,
    border: `1px solid ${Border.main}`,
    overflow: "hidden"
});
function ProfileQuestionnaire({ sections, id, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ProfileQuestionnaireStack, {
        id: id,
        children: sections.map(function(section, index) {
            const sectionNumber = index + 1;
            const shouldShowLinearProgress = section.status === profile_questionnaire_status_enum_ProfileQuestionnaireStatus.Completing && section.percentage > 0;
            const shouldShowBottomDivider = index + 1 !== sections.length;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.createElement)(ProfileQuestionnaireItem, {
                ...section,
                ...rest,
                key: section.id,
                sectionNumber: sectionNumber,
                withLinearProgress: shouldShowLinearProgress,
                withBottomDivider: shouldShowBottomDivider
            });
        })
    });
}
const QuantitySelectorContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center
});
const quantitySelectorLetterSpacing = "0.009375rem";
const QuantitySelectorTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    fontStyle: "normal",
    fontSize: Spacing["1000"],
    letterSpacing: quantitySelectorLetterSpacing,
    color: Text.primary,
    lineHeight: "150%"
});
const TypographyWrapperContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    padding: `0 ${Spacing["250"]}`
});
function QuantitySelector({ quantity, color, size, incrementButtonId, decrementButtonId, isIncrementButtonDisable, isDecrementButtonDisable, onIncrementButtonClick, onDecrementButtonClick, ...rest }) {
    const _color = color ?? "default";
    const _size = size ?? "small";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(QuantitySelectorContainer, {
        ...rest,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                id: decrementButtonId,
                "data-testid": decrementButtonId,
                color: _color,
                size: _size,
                disabled: isDecrementButtonDisable ?? false,
                onClick: onDecrementButtonClick,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MinusCircleSolid, {})
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TypographyWrapperContainer, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(QuantitySelectorTypographyContainer, {
                    variant: "body1",
                    children: quantity
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                id: incrementButtonId,
                "data-testid": incrementButtonId,
                color: _color,
                size: _size,
                disabled: isIncrementButtonDisable ?? false,
                onClick: onIncrementButtonClick,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.PlusCircleSolid, {})
            })
        ]
    });
}
const LargeRadio = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.Radio)({
    "& .MuiSvgIcon-root": {
        fontSize: Spacing["1750"]
    }
});
const radio_Radio = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ isLarge, ...rest }, ref) {
    if (isLarge) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LargeRadio, {
        ...rest
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.Radio, {
        ref: ref,
        ...rest
    });
});
const SCROLL_AREA_DEFAULT_COLOR = PRIMARY_COLOR;
const SCROLL_AREA_HEIGHT = 320;
const SCROLL_AREA_WIDTH = 640;
const scroll_paper_area_ScrollPaperArea = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ color, title, children, ...rest }, ref) {
    const isMobile = use_is_mobile();
    const typographyStyles = isMobile ? theme_theme.typography.subtitle1 : theme_theme.typography.h6;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ScrollPaperAreaRoot, {
        ref: ref,
        ...rest,
        sx: {
            width: isMobile ? SCROLL_AREA_HEIGHT : SCROLL_AREA_WIDTH
        },
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ScrollPaperAreaHeader, {
                color: color,
                sx: {
                    ...typographyStyles
                },
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ScrollPaperAreaContent, {
                children: children
            })
        ]
    });
});
const ScrollPaperAreaRoot = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(3),
        height: SCROLL_AREA_HEIGHT,
        maxHeight: SCROLL_AREA_HEIGHT,
        overflow: "hidden"
    }));
const ScrollPaperAreaHeader = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ color = SCROLL_AREA_DEFAULT_COLOR, theme })=>({
        borderBottom: `1px solid ${theme.palette.border.main}`,
        backgroundColor: `${theme.palette[color].light}`,
        color: `${theme.palette[color].dark}`,
        textAlign: alignment_Alignment.center,
        padding: theme.spacing(1, 5)
    }));
const ScrollPaperAreaContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")(({ theme })=>({
        padding: theme.spacing(4, 6),
        overflowY: "scroll"
    }));
var search_card_interface_SearchCardTypes = /*#__PURE__*/ function(SearchCardTypes) {
    SearchCardTypes["BonusAndEconomicContributions"] = "bonusAndEconomicContributions";
    SearchCardTypes["DeductionsAndFiscalBonus"] = "deductionsAndFiscalBonus";
    SearchCardTypes["FiscalDeclarationAnd730"] = "fiscalDeclarationAnd730";
    SearchCardTypes["CertificatesAndSupportServices"] = "certificatesAndSupportServices";
    SearchCardTypes["FinancialServices"] = "financialServices";
    SearchCardTypes["Other"] = "other";
    return SearchCardTypes;
}({});
const SearchCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"])({
    padding: Spacing["1000"],
    borderRadius: Spacing["500"],
    border: `1px ${border_style_BorderStyle.solid} ${Border.main}`,
    "&:hover": {
        cursor: cursor_style_CursorStyle.pointer,
        border: `1px ${border_style_BorderStyle.solid} ${Border.dark}`
    }
});
const iconsBasedOnType = {
    bonusAndEconomicContributions: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HandHoldingDollarCircleDuotone,
    deductionsAndFiscalBonus: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BadgeDiscountDuotone,
    fiscalDeclarationAnd730: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.InvoiceDuotone,
    certificatesAndSupportServices: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.DocumentListDuotone,
    financialServices: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CoinsDuotone,
    other: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalDuotone
};
function CustomIconCard({ type, ...muiSvgIconProps }) {
    const Icon = iconsBasedOnType[type] ?? __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalDuotone;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Icon, {
        ...muiSvgIconProps,
        color: "secondary"
    });
}
const SearchCardContent = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"])`
  gap: ${Spacing["500"]};
  display: ${displaying_Displaying.flex};
  align-items: ${alignment_Alignment.center};
`;
const SearchCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function(props, ref) {
    const { type, isSmall = false, isMobile = false, value, ...muiCardProps } = props;
    const showRightArrow = !isMobile && !isSmall;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SearchCardContainer, {
        elevation: 0,
        ref: ref,
        ...muiCardProps,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ProductCardContent, {
            isMobile: isMobile,
            "data-testid": "search-card-container-content-flexed",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    container: true,
                    justifyContent: alignment_Alignment.spaceBetween,
                    wrap: "nowrap",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SearchCardContent, {
                        "data-testid": "search-card-content",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CustomIconCard, {
                                type: type
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                                children: value
                            })
                        ]
                    })
                }),
                showRightArrow && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
                    size: "small",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {
                        "data-testid": "search-card-angle-right-icon"
                    })
                })
            ]
        })
    });
});
const DEFAULT_ELEVATION = `${Spacing["0"]} ${Spacing["0"]} ${Spacing["1250"]} ${Spacing["0"]} ${WHITE_TRANSPARENT_LIGHT}`;
const NONE_ELEVATION = "none";
const SELECT_MAX_HEIGHT = "13.56rem";
const SELECT_MIN_WIDTH = "11.25rem";
const select_Select = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, error, size, helperText, label, labelId, fullWidth, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormControl_a4a2c2a1__["default"], {
        error: error,
        size: size,
        fullWidth: fullWidth,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_InputLabel_cf26b488__["default"], {
                id: labelId,
                children: label
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Select_bb5d0ab2__["default"], {
                ref: ref,
                color: PRIMARY_COLOR,
                variant: "outlined",
                error: error,
                label: label,
                labelId: labelId,
                IconComponent: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleDownSmallOutlined,
                sx: {
                    minWidth: SELECT_MIN_WIDTH,
                    ...rest.sx
                },
                MenuProps: {
                    slotProps: {
                        paper: {
                            sx: {
                                boxShadow: DEFAULT_ELEVATION,
                                maxHeight: SELECT_MAX_HEIGHT
                            }
                        }
                    },
                    ...rest.MenuProps
                },
                ...rest,
                children: children
            }),
            helperText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_FormHelperText_3b87fa55__["default"], {
                children: helperText
            })
        ]
    });
});
const sidebarRoutes = [
    {
        label: "Profilo",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UserCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UserCircleDuotone, {})
    },
    {
        label: "Bonus",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EuroCircleOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.EuroCircleDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileTextEditOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileTextEditDuotone, {})
    },
    {
        label: "Upgrade",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileWandOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FileWandDuotone, {})
    },
    {
        label: "Altro",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.MoreHorizontalDuotone, {}),
        disabled: true,
        isSectionDivider: true
    },
    {
        label: "Documenti",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FolderOpenOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.FolderOpenDuotone, {})
    },
    {
        label: "Impostazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsDuotone, {})
    },
    {
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BoxOutlined, {}),
        label: "Scartoffie",
        subpaths: [
            {
                label: "Termini di utilizzo"
            },
            {
                label: "Condizioni Generali di Servizio"
            },
            {
                label: "Privacy Policy"
            },
            {
                label: "Cookies Policy"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BoxDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutDuotone, {})
    }
];
const adminRoutes = [
    {
        label: "Home",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeDuotone, {})
    },
    {
        label: "Configurazioni",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsOutlined, {}),
        subpaths: [
            {
                label: "Documenti"
            },
            {
                label: "Avanzate"
            },
            {
                label: "Sconti"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.SettingsDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ListOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ListDuotone, {})
    },
    {
        label: "Anagrafica",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UsersGroupAltOutlined, {}),
        subpaths: [
            {
                label: "Utenti"
            },
            {
                label: "Enti Partner"
            }
        ],
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UsersGroupAltDuotone, {})
    },
    {
        label: "Pi\xf9",
        disabled: true
    },
    {
        label: "Guida",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BookOpenTextOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BookOpenTextDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutDuotone, {})
    }
];
const operatorRoutes = [
    {
        label: "Home",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.HomeDuotone, {})
    },
    {
        label: "Pratiche",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ListOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ListDuotone, {})
    },
    {
        label: "Anagrafica",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UsersGroupAltOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.UsersGroupAltDuotone, {})
    },
    {
        label: "Pi\xf9",
        disabled: true
    },
    {
        label: "Guida",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BookOpenTextOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.BookOpenTextDuotone, {})
    },
    {
        label: "Logout",
        icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutOutlined, {}),
        iconSelected: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.LogOutDuotone, {})
    }
];
const SIDEBAR_WIDTH = "16.5rem";
function Sidebar({ logo, items, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SidebarContainer, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SidebarLogo, {
                        children: logo
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NavigationList, {
                        disablePadding: true,
                        children: items && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NestedNavigation, {
                            navigationItems: items
                        })
                    })
                ]
            }),
            children
        ]
    });
}
const SidebarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Stack_4d21a1dc__["default"])(({ theme })=>({
        height: "100vh",
        overflow: "hidden",
        borderRight: "1px solid",
        scrollbarGutter: "stable",
        backgroundColor: Common.white.main,
        borderRightColor: theme.palette.border.main,
        padding: `${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(10)} ${theme.spacing(3)}`,
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        justifyContent: "space-between",
        ":hover": {
            overflowY: "auto"
        }
    }));
const SidebarLogo = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    height: Spacing["3500"]
});
function SnackBarIcon({ variant }) {
    switch(variant){
        case "success":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
                "data-testid": "snackbar-success-icon"
            });
        case "error":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TimesCircleSolid, {
                "data-testid": "snackbar-error-icon"
            });
        case "warning":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ExclamationCircleSolid, {
                "data-testid": "snackbar-warning-icon"
            });
        default:
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.InfoCircleSolid, {
                "data-testid": "snackbar-info-icon"
            });
    }
}
const SNACKBAR_ELEVATION = "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)";
const SnackBarContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], styledOptions)(({ theme, variant })=>{
    const variantColor = theme.palette[variant ?? "primary"];
    const backgroundColor = variantColor.main;
    const elementsColor = variantColor.contrastText;
    return {
        maxWidth: "fit-content",
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        gap: Spacing["500"],
        alignSelf: alignment_Alignment.stretch,
        padding: `0.375rem ${Spacing["1000"]}`,
        backgroundColor,
        color: elementsColor,
        borderRadius: Spacing["250"],
        boxShadow: SNACKBAR_ELEVATION
    };
});
function SnackbarSlide(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Slide_61aa8233__["default"], {
        ...props,
        direction: alignment_Alignment.left,
        in: true,
        mountOnEnter: true,
        unmountOnExit: true
    });
}
const MemoizedSnackBarIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.memo)(SnackBarIcon, function(prevProps, nextProps) {
    return prevProps.variant === nextProps.variant;
});
function SnackBar({ variant, message, minWidth, maxWidth, actionButtonText, onCloseButtonClick, onActionButtonClick, ...rest }) {
    const actionButton = onActionButtonClick && actionButtonText ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
        color: "white",
        variant: "text",
        onClick: onActionButtonClick,
        "data-testid": "snackbar-action-button",
        children: actionButtonText
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    const closeButton = onCloseButtonClick ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(icon_button_IconButton, {
        color: "inherit",
        "data-testid": "snackbar-icon-button",
        size: "medium",
        onClick: onCloseButtonClick,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TimesSolid, {})
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {});
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SnackbarSlide, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SnackBarContainer, {
            variant: variant,
            ...rest,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MemoizedSnackBarIcon, {
                    variant: variant
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                    minWidth: minWidth ?? Spacing["18750"],
                    maxWidth: maxWidth ?? Spacing["18750"],
                    "data-testid": "snackbar-container-message",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        variant: "body1",
                        color: Success.contrastText,
                        children: message
                    })
                }),
                actionButton,
                closeButton
            ]
        })
    });
}
const switch_Switch = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Switch_72bb925c__["default"], {
        ...rest,
        ref: ref
    });
});
const TABLE_ODD_ROW_BACKGROUND_COLOR = "#171F3614";
const TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR = "#171F3629";
const TABLE_CELL_MIN_WIDTH_PX = 140;
const TABLE_SMALL_CELL_MIN_HEIGHT_PX = 36;
const TABLE_SMALL_CELL_MAX_HEIGHT_PX = 48;
const TABLE_MEDIUM_CELL_MIN_HEIGHT_PX = 64;
const TABLE_MEDIUM_CELL_MAX_HEIGHT_PX = 96;
const TABLE_SMALL_CELL_PADDING = `${theme_theme.spacing(0)} ${theme_theme.spacing(4)}`;
const TABLE_MEDIUM_CELL_PADDING = `${theme_theme.spacing(2)} ${theme_theme.spacing(4)}`;
function Table({ columns, size, ...rest }) {
    function getRowClassName(params) {
        return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
    }
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledTable, {
        ...rest,
        getRowHeight: function() {
            return "auto";
        },
        columns: columns.map(function(column) {
            return {
                ...column,
                minWidth: TABLE_CELL_MIN_WIDTH_PX,
                renderHeader: ({ colDef: { headerName } })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TableHeader, {
                        children: headerName
                    })
            };
        }),
        slots: {
            columnSortedDescendingIcon: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ArrowUpSmallOutlined,
            columnSortedAscendingIcon: __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.ArrowDownSmallOutlined
        },
        getRowClassName: getRowClassName,
        disableColumnMenu: true,
        disableColumnFilter: true,
        hideFooter: true,
        sx: {
            ".MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                padding: "small" === size ? TABLE_SMALL_CELL_PADDING : TABLE_MEDIUM_CELL_PADDING
            },
            "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                minHeight: "small" === size ? TABLE_SMALL_CELL_MIN_HEIGHT_PX : TABLE_MEDIUM_CELL_MIN_HEIGHT_PX,
                maxHeight: "small" === size ? TABLE_SMALL_CELL_MAX_HEIGHT_PX : TABLE_MEDIUM_CELL_MAX_HEIGHT_PX
            },
            ".MuiDataGrid-columnHeaderCheckbox": {
                padding: theme_theme.spacing(0)
            }
        }
    });
}
function TableHeader({ children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
        variant: "subtitle1",
        fontWeight: "bold",
        children: children
    });
}
const StyledTable = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_cc7bd6a4__.DataGrid)(({ theme })=>({
        "&.MuiDataGrid-root": {
            overflow: "hidden",
            borderColor: theme.palette.border.main
        },
        ".MuiDataGrid-row--lastVisible .MuiDataGrid-cell": {
            borderBottom: "none"
        },
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within, &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within": {
            outline: "none"
        },
        "&.MuiDataGrid-root .MuiDataGrid-columnSeparator": {
            display: "none"
        },
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_cc7bd6a4__.gridClasses.row}.odd`]: {
            backgroundColor: TABLE_ODD_ROW_BACKGROUND_COLOR,
            [`&:hover, &.${mui_class_collection_MuiClassCollection.hovered}`]: {
                backgroundColor: TABLE_ODD_ROW_HOVER_BACKGROUND_COLOR
            },
            [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
                backgroundColor: theme.palette.primary.light
            }
        },
        [`& .${__WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_cc7bd6a4__.gridClasses.row}.even`]: {
            backgroundColor: theme.palette.common.white,
            [`&:hover, &.${mui_class_collection_MuiClassCollection.hovered}`]: {
                backgroundColor: theme.palette.action.hover
            },
            [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
                backgroundColor: theme.palette.primary.light
            }
        }
    }));
const StyledTab = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tab_d16acec7__["default"], styledOptions)(({ theme, color, icon })=>{
    const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
    return {
        [`&.${mui_class_collection_MuiClassCollection.selected}`]: {
            color: selectedColor
        },
        [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
            cursor: cursor_style_CursorStyle.notAllowed,
            pointerEvents: "all",
            color: theme.palette.text.disabled
        },
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
        minWidth: 60,
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        lineHeight: typography_LineHeight.md,
        minHeight: icon ? 0 : void 0,
        ...icon && {
            "& .MuiTab-iconWrapper": {
                height: 24,
                hidth: 24
            }
        }
    };
});
const tab_Tab = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ color, icon, iconPosition, leftIcon, rightIcon, ...rest }, ref) {
    const currentIcon = leftIcon ?? rightIcon;
    const currentIconPosition = leftIcon ? "start" : "end";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(StyledTab, {
        color: color,
        ref: ref,
        icon: currentIcon,
        iconPosition: currentIconPosition,
        ...rest
    });
});
const tabs_Tabs = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, color, variant, allowScrollButtonsMobile, textColor, indicatorColor, ...rest }, ref) {
    const theme = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.useTheme)();
    const selectedColor = color ? theme.palette[color].main : theme.palette.primary.main;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Tabs_81f0807c__["default"], {
        variant: "scrollable",
        allowScrollButtonsMobile: true,
        ref: ref,
        TabIndicatorProps: {
            style: {
                backgroundColor: selectedColor
            }
        },
        ...rest,
        children: __WEBPACK_EXTERNAL_MODULE_react__["default"].Children.map(children, (child)=>/*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].isValidElement(child) ? /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].cloneElement(child, {
                color
            }) : null)
    });
});
const define_global_styles_tealDuskStyle = tealDusk.getIconStylesOverride();
const define_global_styles_pinkHazeStyle = pinkHaze.getIconStylesOverride();
const define_global_styles_goldenUmberStyle = goldenUmber.getIconStylesOverride();
const styles = (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_daf4f520__.css)`
  .MuiSvgIcon-root {
    ${define_global_styles_tealDuskStyle}
    ${define_global_styles_pinkHazeStyle}
    ${define_global_styles_goldenUmberStyle}
  }
`;
function DefineGlobalStyles() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_styled_engine_24226ae5__.GlobalStyles, {
        styles: styles
    });
}
function ThemeProvider({ children, theme = theme_theme }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.ThemeProvider, {
        theme: theme,
        children: children
    });
}
const tealDuskSvgLinearGradient = tealDusk.getSvgGradient();
const pinkHazeSvgLinearGradient = pinkHaze.getSvgGradient();
const goldenUmberSvgLinearGradient = goldenUmber.getSvgGradient();
function SvgLinearGradient() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_system_a9d19080__.Box, {
        id: "hidden-svg-linear-gradient",
        sx: {
            position: "absolute",
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            overflow: "hidden"
        },
        children: [
            tealDuskSvgLinearGradient,
            " ",
            pinkHazeSvgLinearGradient,
            " ",
            goldenUmberSvgLinearGradient
        ]
    });
}
function ThemeStyles() {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DefineGlobalStyles, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SvgLinearGradient, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_CssBaseline_6a578862__["default"], {})
        ]
    });
}
const TicketCardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ turnBorderColor, turn, theme })=>{
    const fullBorderColor = "user" === turn ? turnBorderColor : GREY_BORDER_CARD;
    const leftBorderColor = turnBorderColor;
    const borderWidth = `0.063rem 0.063rem 0.063rem ${theme.spacing(2)}`;
    return {
        borderRadius: theme.spacing(2),
        boxShadow: "none",
        padding: `${Spacing["1000"]} ${Spacing["1500"]}`,
        border: `solid ${fullBorderColor}`,
        borderWidth,
        borderLeft: `${theme.spacing(2)} solid ${leftBorderColor}`,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    };
});
const ActionSectionFlexed = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    justifyContent: alignment_Alignment.flexEnd,
    gap: "0.75rem"
});
const TicketCardDesktop = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, turnIconToRender, turnColor, actionComponent, date, productName, productRequestedCode, ...rest }, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardContainer, {
        turnBorderColor: turnColor,
        turn: turn,
        ref: ref,
        "data-testid": "ticket-card-container-desktop",
        ...rest,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: "auto",
                    "data-testid": "ticket-card-desk-icon",
                    children: turnIconToRender
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xl: 7,
                    lg: 7,
                    md: 7,
                    sm: 6,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        container: true,
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "body2",
                                    color: theme_theme.palette.text.secondary,
                                    "data-testid": "ticket-card-desk-date",
                                    children: date
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "h6",
                                    "data-testid": "ticket-card-desk-product-name",
                                    children: productName
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                    variant: "body1",
                                    color: theme_theme.palette.text.secondary,
                                    "data-testid": "ticket-card-desk-code",
                                    children: `# ${productRequestedCode}`
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xl: 4,
                    lg: 4,
                    md: 4,
                    sm: 5,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActionSectionFlexed, {
                        "data-testid": "ticket-card-desk-action",
                        children: actionComponent
                    })
                })
            ]
        })
    });
});
var practice_turn_PracticeTurn = /*#__PURE__*/ function(PracticeTurn) {
    PracticeTurn["user"] = "user";
    PracticeTurn["operator"] = "cafOperator";
    PracticeTurn["finalized"] = "finalized";
    return PracticeTurn;
}({});
const CardContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Card_44726e4d__["default"], styledOptions)(({ turnBorderColor, turn, theme })=>{
    const fullBorderColor = turn === practice_turn_PracticeTurn.user ? turnBorderColor : GREY_BORDER_CARD;
    const leftBorderColor = turnBorderColor;
    const borderWidth = `${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${ONE_PIXEL_REM} ${theme.spacing(2)}`;
    return {
        borderRadius: theme.spacing(2),
        boxShadow: "none",
        padding: `${Spacing["1000"]} ${Spacing["1500"]}`,
        border: `solid ${fullBorderColor}`,
        borderWidth,
        borderLeft: `${theme.spacing(2)} solid ${leftBorderColor}`,
        "&:hover": {
            cursor: cursor_style_CursorStyle.pointer
        }
    };
});
const ActionComponentStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div", {
    shouldForwardProp: dontForwardTheseProps([
        "isFinalized"
    ])
})(({ isFinalized })=>({
        display: displaying_Displaying.flex,
        alignItems: alignment_Alignment.center,
        justifyContent: alignment_Alignment.spaceBetween,
        marginTop: isFinalized ? "0" : `${Spacing["1000"]}`,
        borderTop: isFinalized ? "0" : `${ONE_PIXEL_REM} solid ${GREY_BORDER_CARD}`,
        paddingTop: `${Spacing["1000"]}`
    }));
const DivFlexedCentered = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_styles_19cb2acd__.styled)("div")({
    display: displaying_Displaying.flex,
    alignItems: alignment_Alignment.center,
    gap: `${Spacing["1000"]}`
});
const TicketCardMobile = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, turnIconToRender, turnColor, actionComponent, date, productName, productRequestedCode, ...rest }, ref) {
    const isFinalized = turn === practice_turn_PracticeTurn.finalized;
    const productCodeWithSymbol = `# ${productRequestedCode}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardContainer, {
        turnBorderColor: turnColor,
        turn: turn,
        ref: ref,
        ...rest,
        "data-testid": "ticket-card-container-mobile",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            alignItems: alignment_Alignment.center,
            spacing: 1,
            rowSpacing: 1,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DivFlexedCentered, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: "auto",
                            style: {
                                paddingTop: `${Spacing["500"]}`
                            },
                            "data-testid": "ticket-card-mobile-icon",
                            children: turnIconToRender
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                            item: true,
                            xs: 10,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: "body2",
                                color: theme_theme.palette.text.secondary,
                                "data-testid": "ticket-card-mobile-date",
                                children: date
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "subtitle1",
                        "data-testid": "ticket-card-mobile-product-name",
                        children: productName
                    })
                }),
                isFinalized ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {}) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "body1",
                        color: theme_theme.palette.text.secondary,
                        "data-testid": "ticket-card-mobile-code",
                        children: productCodeWithSymbol
                    })
                }),
                isFinalized ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(ActionComponentStyled, {
                        isFinalized: isFinalized,
                        "data-testid": "ticket-card-mobile-action",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                                variant: "body1",
                                color: theme_theme.palette.text.secondary,
                                "data-testid": "ticket-card-mobile-code",
                                children: productCodeWithSymbol
                            }),
                            " ",
                            actionComponent
                        ]
                    })
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ActionComponentStyled, {
                        isFinalized: isFinalized,
                        "data-testid": "ticket-card-mobile-action",
                        children: actionComponent
                    })
                })
            ]
        })
    });
});
const WorkingTurnAction = {
    cafOperator: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {
        customColor: theme_theme.palette.action.active
    }),
    user: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
        color: "primary",
        size: "medium",
        variant: "contained",
        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {
            color: "inherit"
        }),
        children: "Procedi"
    }),
    finalized: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.AngleRightSmallOutlined, {
        customColor: theme_theme.palette.action.active
    })
};
const TicketCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ turn, date, productName, productRequestedCode, actionText, ...rest }, ref) {
    const isMobile = use_is_mobile();
    const turnIconToRender = __WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TurnIcons[turn];
    const turnColor = WorkingTurnsColors[turn];
    const actionTextInputted = actionText ?? "";
    const actionComponent = composeActionComponent(turn, actionTextInputted);
    return isMobile ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardMobile, {
        ref: ref,
        turnIconToRender: turnIconToRender,
        turnColor: turnColor,
        actionComponent: actionComponent,
        turn: turn,
        date: date,
        productName: productName,
        productRequestedCode: productRequestedCode,
        ...rest
    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TicketCardDesktop, {
        ref: ref,
        turnIconToRender: turnIconToRender,
        turnColor: turnColor,
        actionComponent: actionComponent,
        turn: turn,
        date: date,
        productName: productName,
        productRequestedCode: productRequestedCode,
        ...rest
    });
});
function composeActionComponent(turn, actionText) {
    const actionComponent = WorkingTurnAction[turn];
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                variant: "body2",
                children: actionText
            }),
            actionComponent
        ]
    });
}
const UpgradeCard = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(GradientBox, {
        sx: {
            maxWidth: "100%"
        },
        ref: ref,
        ...props.containerProps,
        gradient: props.gradient,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
            container: true,
            gap: 2,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                        variant: "subtitle1",
                        children: props.title
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    sx: {
                        display: displaying_Displaying.flex,
                        flexDirection: direction_Direction.row,
                        gap: Spacing["500"]
                    },
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.StarMagicSolid, {
                            color: props.gradient
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Typography_77749481__["default"], {
                            variant: "body1",
                            children: props.subtitle
                        })
                    ]
                }),
                props.buttonProps?.children && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                        id: props.buttonProps?.id,
                        color: props.gradient,
                        variant: "contained",
                        fullWidth: true,
                        ...props.buttonProps,
                        children: props.buttonProps?.children
                    })
                })
            ]
        })
    });
});
function UploaderTabRenderer({ tab, activeTabIndex, setActiveTabIndex, tabs, onRemoveTab, onDrop }) {
    const currentIndex = activeTabIndex + 1;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        id: `tab-${tab.id}`,
        style: {
            display: tab.id === tabs[activeTabIndex].id ? "inherit" : "none"
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Dropzone, {
            onClear: ()=>{
                onRemoveTab(tabs[activeTabIndex].id);
                setActiveTabIndex(Math.max(0, currentIndex - 2));
            },
            onDrop: onDrop,
            ...tab.dropzone.props
        }, tab.dropzone.key)
    });
}
const UploaderContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div", styledOptions)(({ elevated })=>({
        display: displaying_Displaying.flex,
        flexDirection: direction_Direction.column,
        gap: Spacing["750"],
        padding: Spacing["1500"],
        borderRadius: Spacing["750"],
        boxShadow: elevated ? DEFAULT_ELEVATION : "0",
        backgroundColor: Primary.light,
        width: "100%"
    }));
const TitleTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    display: displaying_Displaying.flex,
    padding: "0 !important",
    lineHeight: `${Spacing["2000"]}`,
    color: Text.primary
});
const DividerContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Divider_a12d1a94__["default"], styledOptions)(({ isMobile })=>({
        display: isMobile ? displaying_Displaying.none : displaying_Displaying.inherit
    }));
const GridContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], styledOptions)(({ isMobile })=>({
        display: displaying_Displaying.flex,
        flexDirection: isMobile ? direction_Direction.column : direction_Direction.row,
        gap: Spacing["750"],
        paddingBottom: isMobile ? Spacing["1500"] : Spacing["0"]
    }));
const SupportedFilesTextContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    paddingTop: Spacing["750"],
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center,
    gap: Spacing["500"],
    alignItems: alignment_Alignment.center
});
const SupportedFilesTypographyContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Typography)({
    color: Text.secondary,
    fontSize: Spacing["750"],
    fontStyle: "normal",
    fontWeight: typography_FontWeight.normal,
    lineHeight: "166%",
    letterSpacing: Spacing["25"]
});
const infoIconStyle = {
    width: Spacing["1000"],
    height: Spacing["1000"]
};
const DocumentReferenceYearContainer = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)("div")({
    display: displaying_Displaying.flex,
    gap: Spacing["250"],
    justifyContent: alignment_Alignment.center,
    alignItems: alignment_Alignment.center
});
const chip_ChipStyled = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(chip_Chip)({
    padding: `${Spacing["0"]} ${Spacing["500"]}`
});
const BoxCentered = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"])({
    display: displaying_Displaying.flex,
    justifyContent: alignment_Alignment.center
});
function Uploader({ isMobile, addButtonText, title, disableAddButton, isAddButtonVisible = true, supportedFilesText, elevated, tabs, addNewTab, removeTab, isActionButtonVisible, onClickUploadEntireDocument, activeTabIndex, setActiveTabIndex, actionButtonText, onDrop, scrollButtons, tabsFullWidth, canModifyDocument, onClickModifyDocument, documentRefYear, documentRefYearText, ...rest }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(UploaderContainer, {
        isMobile: isMobile,
        elevated: elevated,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                component: "div",
                variant: "body2",
                children: title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainer, {
                container: true,
                isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        sx: {
                            width: tabsFullWidth ? "100%" : "initial"
                        },
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(tabs_Tabs, {
                            scrollButtons: scrollButtons,
                            value: activeTabIndex,
                            onChange: (_event, newValue)=>setActiveTabIndex(newValue),
                            children: tabs.map(function(tab, _) {
                                return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(tab_Tab, {
                                    label: tab.label,
                                    "data-testid": `tab-${tab.id}`
                                }, tab.id);
                            })
                        })
                    }),
                    isAddButtonVisible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                        item: true,
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(GridContainer, {
                            container: true,
                            isMobile: isMobile,
                            sx: {
                                paddingBottom: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                    item: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DividerContainer, {
                                        isMobile: isMobile,
                                        orientation: "vertical",
                                        variant: "middle"
                                    })
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Grid_f9155c16__["default"], {
                                    item: true,
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                                        "data-testid": "add-tab-button",
                                        disabled: disableAddButton ?? false,
                                        onClick: addNewTab,
                                        endIcon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.PlusOutlined, {}),
                                        children: addButtonText ?? "Add"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mui_material_Box_d4513724__["default"], {
                children: tabs.map(function(tab, _) {
                    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UploaderTabRenderer, {
                        onDrop: onDrop,
                        tab: tab,
                        tabs: tabs,
                        activeTabIndex: activeTabIndex,
                        onRemoveTab: removeTab,
                        setActiveTabIndex: setActiveTabIndex
                    }, tab.id);
                })
            }),
            documentRefYear && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DocumentReferenceYearContainer, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Typography, {
                        variant: "body2",
                        color: Text.secondary,
                        children: documentRefYearText ?? "Anno di riferimento:"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(chip_ChipStyled, {
                        size: "small",
                        color: "default",
                        variant: "outlined",
                        label: documentRefYear
                    })
                ]
            }),
            isActionButtonVisible && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BoxCentered, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(button_Button, {
                    size: "small",
                    variant: "contained",
                    onClick: canModifyDocument ? onClickModifyDocument : onClickUploadEntireDocument,
                    children: actionButtonText
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(SupportedFilesTextContainer, {
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.InfoCircleOutlined, {
                        sx: infoIconStyle
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SupportedFilesTypographyContainer, {
                        children: supportedFilesText ?? "Supported files PDF, JPG. Max 1 Mb"
                    })
                ]
            })
        ]
    });
}
var uploader_accordion_UploaderAccordionVariant = /*#__PURE__*/ function(UploaderAccordionVariant) {
    UploaderAccordionVariant["RequestUpload"] = "request-upload";
    UploaderAccordionVariant["UploadSuccess"] = "upload-success";
    UploaderAccordionVariant["Success"] = "success";
    UploaderAccordionVariant["Error"] = "error";
    return UploaderAccordionVariant;
}({});
const iconMapping = {
    ["request-upload"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CloudUploadOutlined, {
        className: "uploader-icon"
    }),
    ["upload-success"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CloudUploadOutlined, {
        className: "uploader-icon"
    }),
    ["success"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.CheckCircleSolid, {
        className: "uploader-icon"
    }),
    ["error"]: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__bonusx_global_bx_icons_eb4f9481__.TriangleExclamationSolid, {
        className: "uploader-icon"
    })
};
const UploaderAccordionElement = (0, __WEBPACK_EXTERNAL_MODULE__mui_material_39280ebf__.styled)(Accordion)({
    ["&.request-upload"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.primary.main}`,
        borderColor: theme_theme.palette.primary.main,
        "& .uploader-icon": {
            color: theme_theme.palette.primary.main
        }
    },
    ["&.upload-success"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.secondary.main}`,
        borderColor: theme_theme.palette.secondary.main,
        "& .uploader-icon": {
            color: theme_theme.palette.secondary.main
        }
    },
    ["&.success"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.success.main}`,
        borderColor: theme_theme.palette.success.main,
        "& .uploader-icon": {
            color: theme_theme.palette.success.main
        }
    },
    ["&.error"]: {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.error.main}`,
        borderColor: theme_theme.palette.error.main,
        "& .uploader-icon": {
            color: theme_theme.palette.error.main
        }
    },
    "&.uploader-disabled": {
        borderLeft: `${Spacing["500"]} solid ${theme_theme.palette.primary.light}`,
        borderColor: theme_theme.palette.primary.light,
        color: theme_theme.palette.text.disabled,
        "& .uploader-icon": {
            color: theme_theme.palette.action.disabled
        },
        "> *": {
            cursor: "not-allowed !important"
        }
    },
    [`&.${mui_class_collection_MuiClassCollection.disabled}`]: {
        backgroundColor: "transparent",
        cursor: "not-allowed !important"
    }
});
const uploader_accordion_UploaderAccordion = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ children, uploadVariant, className, endAction, endChip, isMobile, disabled = false, ...rest }, ref) {
    const leftIcon = iconMapping[uploadVariant];
    const classNameOverride = `${className} ${uploadVariant} ${disabled ? "uploader-disabled" : ""}`;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(UploaderAccordionElement, {
        ref: ref,
        disabled: disabled,
        startIcon: leftIcon,
        className: classNameOverride,
        isMobile: isMobile,
        endChip: endChip,
        endAction: endAction,
        ...rest,
        children: children
    });
});
const Opacity = {
    10: 0.1,
    20: 0.2,
    30: 0.3,
    40: 0.4,
    50: 0.5,
    60: 0.6,
    70: 0.7,
    80: 0.8,
    90: 0.9,
    100: 1
};
export { ACTION_CONTENT_BACKGROUND_COLOR, ACTION_CONTENT_BORDER_RADIUS, ACTIVE_MOBILE_PADDING_STYLES, ACTIVE_PADDING, ACTIVE_PADDING_STYLES, APP_BAR_HEIGHT_DESKTOP, APP_BAR_HEIGHT_MOBILE, AUTO_OPTION, AcceptedPayment, AcceptedPaymentContainer, Accordion, Action, AdminPanel, alert_Alert as Alert, alignment_Alignment as Alignment, AlphaDeep, Amex, app_bar_AppBar as AppBar, ApplePay, Autocomplete, AutocompleteTextField, avatar_Avatar as Avatar, AvatarProgressBar, AvatarStepper, BOTTOM_NAVIGATION_HEIGHT, Background, badge_Badge as Badge, BadgeContainer, Bancomat, BlockNotice, BlockNoticeBodyContainer, BlockNoticeContainer, BlockNoticeIconContainer, BlockNoticeTitleContainer, Bluex, Border, BorderRadius, border_style_BorderStyle as BorderStyle, BottomNavigation, BottomNavigationDrawer, BoxOutlinedWithGradient, containers_BoxWrapper as BoxWrapper, breadcrumbs_Breadcrumbs as Breadcrumbs, BreadcrumbsLink, button_Button as Button, ButtonContainer, CARD_CONTAINER_BORDER_THICK, CONTAIN_OPTION, COUNTRY_CODE_WITH_PREFIX, Celestex, chat_input_ChatInput as ChatInput, ChatInputBottomBar, ChatInputInnerBox, ChatInputOuterBox, checkbox_Checkbox as Checkbox, chip_Chip as Chip, chip_ChipStyled as ChipStyled, Color, Common, CompanyData, ContainerWithMarginRight, ContainerWithTopSpacing, conversation_bubble_ConversationBubble as ConversationBubble, cursor_style_CursorStyle as CursorStyle, CustomArrowButton, custom_arrow_button_interface_CustomArrowButtonDirections as CustomArrowButtonDirections, CustomDropzone, CustomIconCard, CustomNumberSpinner, DEFAULT_ACTIVE_STEP, DEFAULT_ELEVATION, DEFAULT_FONT_FAMILY, DEFAULT_ICON_SIZE, DEFAULT_SIZE, DEFAULT_STEP, DEFAULT_STEPS, DEFAULT_TITLE, DIVIDER_COLOR, date_picker_DatePicker as DatePicker, date_time_picker_DateTimePicker as DateTimePicker, DeepBlue, DeepBluex, DefineGlobalStyles, DesktopDatePicker, desktop_date_time_picker_DesktopDateTimePicker as DesktopDateTimePicker, Dialog, DialogGridContainer, DialogIconContainer, direction_Direction as Direction, displaying_Displaying as Displaying, DividerContainer, DocumentReferenceYearContainer, Dropzone, DropzoneActionButton, DropzoneClearButton, DropzoneContainer, DropzoneMessage, dropzone_enum_DropzonePhase as DropzonePhase, DropzonePreviewer, DualGridCardLayourWrapper, DualGridCardLayout, DualGridCardLayoutColumn, DualGridCardLayoutContent, DualGridCardLayoutContentWrapper, DualGridCardLayoutElement, EMPTY_STRING, EndItemsContainer, EnvelopeContent, ErrorToken, FILTER_GRAYSCALE, FLAG_EXT, FileIcon, FlagImage, typography_FontSize as FontSize, typography_FontWeight as FontWeight, FormControlLabel, GREY_BORDER_CARD, GREY_BORDER_CARD_HOVERED, GREY_BORDER_CARD_HOVERED_MIDDLE_OPACITY, GREY_BORDER_CARD_MIDDLE_OPACITY, GoldenUmber, Goldenx, Gradient, GradientBox, GradientBoxOutlined, GradientPaletteBox, Greenx, Greyx, GridContainer, GridItemSpaceBetween, INACTIVE_MOBILE_PADDING_STYLES, INACTIVE_PADDING_STYLES, INITIAL_OPTION, icon_button_IconButton as IconButton, IconElement, IconListSelector, IconListSelectorContentWrapper, IconListSelectorContentWrapperV2, IconListSelectorItem, IconListSelectorItemContentWrapper, IconListSelectorItemContentWrapperV2, IconListSelectorItemEndIconWrapper, IconListSelectorItemEndSlotV2Wrapper, IconListSelectorItemIconEmojiWrapper, IconListSelectorItemIconEmojiWrapperV2, IconListSelectorItemMainIconV2, IconListSelectorItemSelectedIconWrapperV2, IconListSelectorItemStartIcon, IconListSelectorItemV2, IconListSelectorItemWrapper, IconListSelectorItemWrapperV2, IconListSelectorSearchInfoWrapper, IconListSelectorSearchInfoWrapperV2, IconListSelectorV2, IconListSelectorWrapper, IconListSelectorWrapperV2, IconSection, ImageSection, Info, InnerLabel, Interactive, IseeCard, IseeCardContent, LeftActionsBox, LeftSlotWrapper, typography_LetterSpacing as LetterSpacing, typography_LineHeight as LineHeight, LinearProgress, List, ListItem, Logo, MAX_OPACITY, MIDDLE_OPACITY, MOBILE_PADDING, Maestro, MasterCard, mobile_date_picker_MobileDatePicker as MobileDatePicker, mobile_date_time_picker_MobileDateTimePicker as MobileDateTimePicker, ModalBar, ModalBarHeader, ModalBarIcon, MuiAccordionContainer, MuiAccordionSummaryContainer, MuiAccordionSummaryContentContainer, mui_class_collection_MuiClassCollection as MuiClassCollection, NONE_ELEVATION, NONE_OPTION, NO_GAP, NO_GAP_V2, NUMBER_INPUT_ALLOWED_KEYS, Napolix, NavigationList, NavigationListItem, NavigationListItemCollapsible, NestedNavigation, NonInteractive, notification_card_NotificationCard as NotificationCard, NotificationCardContainer, NotificationCardContentContainer, NotificationCardDescription, NotificationCardFooter, NotificationCardHeader, Nudex, number_input_NumberInput as NumberInput, ONE_PIXEL_REM, Opacity, OperatorPanel, Orangex, PRIMARY_COLOR, Paypal, PaypalButton, PaypalIconContainer, PaypalSolid, PaypalTypographyContainer, PinkHaze, Pinkx, PlanSelector, PlanSelectorClickableGridSection, PlanSelectorIconSection, PlanSelectorLabelSection, positioning_Positioning as Positioning, practice_turn_PracticeTurn as PracticeTurn, Primary, product_card_ProductCard as ProductCard, ProductCardAction, ProductCardChip, ProductCardContainer, ProductCardContent, ProductCardDate, ProductCardPrice, ProductCardTitle, ProfileCompletionLevel, ProfileCompletionLevelStepConnector, ProfileCompletionLevelStepIconRoot, ProfileCompletionLevelStepIconWrapper, ProfileCompletionLevelStepper, ProfileCover, ProfileCoverIconWrapper, ProfileCoverWrapper, ProfileQuestionnaire, ProfileQuestionnaireIcon, ProfileQuestionnaireItem, ProfileQuestionnaireItemWrapper, ProfileQuestionnairePaper, profile_questionnaire_status_enum_ProfileQuestionnaireStatus as ProfileQuestionnaireStatus, Progress, Purple, PurpleLight, Purplex, QuantitySelector, QuantitySelectorContainer, QuantitySelectorTypographyContainer, radio_Radio as Radio, Redx, RightActionsBox, SCROLL_AREA_DEFAULT_COLOR, SCROLL_AREA_HEIGHT, SCROLL_AREA_WIDTH, SECONDARY_OPTION, SEE_FILE_PREVIEW, SIDEBAR_WIDTH, STABLE_OPTION, STORYBOOK_LARGE_MOBILE_WIDTH, scroll_paper_area_ScrollPaperArea as ScrollPaperArea, SearchCard, SearchCardContainer, SearchCardContent, search_card_interface_SearchCardTypes as SearchCardTypes, Secondary, select_Select as Select, SendButtonBox, Sidebar, SnackBar, SnackBarContainer, SnackBarIcon, SnackbarSlide, Spacing, StyledActionContainer, StyledChildrenContainer, StyledTable, StyledVerticalAlert, Success, SupportedFilesTextContainer, SupportedFilesTypographyContainer, SvgLinearGradient, switch_Switch as Switch, TRANSPARENT_COLOR, tab_Tab as Tab, Table, tabs_Tabs as Tabs, TealDusk, Tealx, Tertiary, Text, text_field_TextField as TextField, ThemeProvider, ThemeStyles, TicketCard, TicketCardContainer, TicketCardDesktop, TicketCardMobile, TitleTypographyContainer, Toolbar, Tooltip, TooltipContainerText, TooltipDescriptionTypographyContainer, TooltipTitleTypographyContainer, Typography, TypographyWrapperContainer, UpgradeCard, Uploader, uploader_accordion_UploaderAccordion as UploaderAccordion, uploader_accordion_UploaderAccordionVariant as UploaderAccordionVariant, UploaderContainer, UploaderTabRenderer, vertical_alert_VerticalAlert as VerticalAlert, Visa, WHITE_TRANSPARENT_LIGHT, Warning, White, WorkingTurnAction, WorkingTurnsColors, wrapping_Wrapping as Wrapping, accordionDetailsStyleOverrides, accordionStyleOverrides, accordionSummaryStyleOverrides, adminRoutes, alertDefaultProps, alertStylesOverride, alertTitleStylesOverride, badgeStylesOverride, bottomBarStyles, bottomNavigationDrawerRoutes, bottomNavigationRoutes, boxContentClassName, buttonStyleOverrides, callOnChangeWithNewValue, capitalizeFirstLetter, chatInputBoxStyles, chatInputInnerBoxStyles, checkboxStylesOverride, chipStyleOverrides, colorMapper, computeInputProps, computeLabelProps, computeNewValueBasedOnDirection, computeNewValueBasedOnUserInput, confirmButtonDefaultText, conversationBubbleContainerStyles, conversationBubbleStartIconStyles, conversationBubbleTextStyles, countryItems, countryItemsV2, defaultLoadingText, defaultMultipleSelectionInstructionText, defaultMultipleSelectionInstructionTextV2, defaultSingleSelectionInstructionText, defaultSingleSelectionInstructionTextV2, defaultStartTypingText, defaultStartTypingTextV2, defaultUploadButtonText, dialogActionsStylesOverrides, dialogContentStylesOverrides, dialogStyleOverrides, dialogTitleStylesOverrides, dontForwardTheseProps, emojiItems, emojiItemsV2, endSlotItemsV2, formatCurrency, generateCustomTextFieldStyle, getAdornmentAndIcon, getChipColor, getIconColor, getProfileQuestionnaireItemWrapperPadding, getProfileQuestionnairePaperPadding, getProgressBarFillColor, getProgressBarStrokeColor, getTextFieldInputAdornmentProperty, goldenUmber, goldenUmberPalette, handleClearButtonClickEventAndReturnNewStatus, handleModifyButtonEventAndReturnNewStatus, handleOnConfirmEventAndReturnNewStatus, handleOnDropEventAndReturnNewStatus, hexToRgba, iconButtonStyleOverrides, infoIconStyle, inputStyleOverrides, isAllowedKey, isArrayPopulated, isColorPaletteWithToken, isError, isFunction, isLabelShrunk, isStyledValidProp, leftActionsBoxStyles, linearProgressStylesOverride, listItemButtonOverrides, menuItemStylesOverrides, modifyButtonDefaultText, noResultsText, noResultsTextV2, noResultsTitle, noResultsTitleV2, operatorRoutes, palette, paletteMapper, paperStyleOverrides, parseErrorMessage, pinkHaze, pinkHazePalette, radioStylesOverride, rightActionsBoxStyles, sampleItems, sampleItemsV2, searchableSampleItems, searchableSampleItemsLongList, searchableSampleItemsLongListV2, searchableSampleItemsV2, sendButtonBoxStyles, sendButtonStyles, sidebarRoutes, styledOptions, switchStylesOverride, tealDusk, tealDuskPalette, textFieldStyleOverrides, textFieldStyles, toolTipStyleOverrides, typography };
